import type { Dict } from '../types';

export const ru: Dict = {
  'invite.header.eyebrow': "Team invitation",
  'invite.loading': "Loading invitation…",
  'invite.landing.title': "Join the team",
  'invite.landing.subtitle': "You’ve been invited to collaborate in OpenDesign.",
  'invite.landing.roleLabel': "Role",
  'invite.landing.invitedEmail': "Invited email",
  'invite.landing.expires': "Expires",
  'invite.role.admin': "Admin",
  'invite.role.member': "Member",
  'invite.role.admin.desc': "Can manage members, seats, and all project settings.",
  'invite.role.member.desc': "Can create your own projects, and view and comment on shared team projects.",
  'invite.accept.cta': "Accept invitation",
  'invite.accountMismatch.title': "You’re signed in as a different account",
  'invite.accountMismatch.body': "This invitation was sent to a different email address. You can continue with your current account, or switch accounts.",
  'invite.accountMismatch.continue': "Continue with current account",
  'invite.accountMismatch.switch': "Switch account",
  'invite.accepting.title': "Joining the team…",
  'invite.accepting.body': "Setting up your membership.",
  'invite.success.title': "You’re in",
  'invite.success.body': "Opening OpenDesign so you can start collaborating.",
  'invite.success.roleReceipt': "Joined as",
  'invite.success.enter': "Enter workspace",
  'invite.open.cta': "Open OpenDesign",
  'invite.open.opening': "Opening OpenDesign…",
  'invite.open.retry': "Already installed? Try opening again",
  'invite.notInstalled.title': "Didn’t open automatically?",
  'invite.notInstalled.body': "You may not have OpenDesign installed yet. Install it, then reopen this link to finish joining.",
  'invite.notInstalled.download': "Download OpenDesign",
  'invite.error.title': "Can’t accept this invitation",
  'invite.error.invite_expired': "This invitation has expired. Ask an admin to send a new one.",
  'invite.error.invite_consumed': "This invitation has already been used.",
  'invite.error.workspace_seat_limit_reached': "The team has no seats left. Ask an admin to free up a seat or add more.",
  'invite.error.workspace_subscription_locked': "The team’s subscription is inactive, so new members can’t join right now.",
  'invite.error.workspace_not_found': "This workspace no longer exists.",
  'invite.error.workspace_forbidden': "Your account isn’t allowed to accept this invitation.",
  'invite.error.invite_unavailable': "This invitation is no longer available.",
  'invite.error.generic': "Something went wrong. Please try again.",
  'invite.error.retry': "Try again",
  "workspaceInvite.dialogAria": "Invite members",
  "workspaceInvite.title": "Invite members to your team",
  "workspaceInvite.freePlanBody": "The free plan includes 1 seat. Inviting teammates will guide you to upgrade to Teams.",
  "workspaceInvite.teamPlanBody": "Invite teammates to share projects, design systems, and plugins together.",
  "workspaceInvite.seatsExhaustedBody": "В этом рабочем пространстве не осталось мест. Добавьте места, чтобы приглашать коллег.",
  "workspaceInvite.seatsExhaustedAction": "Места и тариф",
  "workspaceInvite.emailLabel": "Invite members by email",
  "workspaceInvite.roleLabel": "Assign role",
  "workspaceInvite.defaultRoleLabel": "Default role",
  "workspaceInvite.emailPlaceholder": "Enter email address…",
  "workspaceInvite.removeRow": "Remove",
  "workspaceInvite.addMember": "Add member",
  "workspaceInvite.visibilityQuestion": "Will team members see my designs?",
  "workspaceInvite.visibilityAnswer": "Team members can see designs you share to the team space. Private designs kept in Personal projects are not visible to others.",
  "workspaceInvite.sent": "Invitation sent",
  "workspaceInvite.sending": "Inviting…",
  "workspaceInvite.confirm": "Confirm and invite",
  "workspaceInvite.submitFailed": "Failed to send invitation. Try again later.",
  "workspaceInvite.errorAlreadyMember": "Этот адрес уже является участником команды.",
  "workspaceInvite.errorPendingInvite": "У этого адреса уже есть ожидающее приглашение.",
  "workspaceInvite.errorNoSession": "Войдите в свою учётную запись Vela, прежде чем приглашать участников.",
  "workspaceInvite.errorNoWorkspace": "Пока нет командного пространства, куда можно пригласить участников.",
  "workspaceInvite.errorUnreachable": "Не удалось отправить приглашение. Повторите попытку позже.",
  'chat.amrCard.switchTitle': 'Не удалось вызвать модель — это выполнение приостановлено',
  'chat.amrCard.switchBody': 'Переключитесь на официальный сервис моделей OpenDesign Cloud — без настройки API-ключа. После входа, авторизации и пополнения это выполнение будет автоматически повторено.',
  'chat.amrCard.chipOfficial': 'Официальный хостинг',
  'chat.amrCard.chipNoKey': 'Без API-ключа',
  'chat.amrCard.chipAutoRetry': 'Авто-повтор после входа',
  'chat.amrCard.switchCta': 'Переключиться на OpenDesign Cloud и повторить',
  'chat.amrError.authMessage': 'Ваш аккаунт OpenDesign Cloud ещё не авторизован. Авторизуйте его, и это выполнение будет автоматически повторено.',
  'chat.amrError.balanceMessage': 'Баланс OpenDesign Cloud исчерпан. Пополните, чтобы продолжить это выполнение.',
  'chat.amrError.authorizeCta': 'Авторизовать и повторить',
  'chat.amrError.rechargeCta': 'Пополнить',
  'chat.amrBalanceGate.title': 'Улучшите тариф и продолжайте творить',
  'chat.amrBalanceGate.message': 'Недостаточно кредитов (осталось {balance}). Улучшите тариф или пополните баланс — и задача сразу запустится.',
  'chat.amrBalanceGate.benefitsTitle': 'Что даёт OpenDesign Cloud',
  'chat.amrBalanceGate.benefit1': 'Без API-ключей — большой выбор моделей',
  'chat.amrBalanceGate.benefit2': 'Встроенный SOTA-агент для дизайна, без настройки',
  'chat.amrBalanceGate.benefit3': 'Официальный сервис — надёжно',
  'chat.amrBalanceGate.benefit4': 'Постоянно развивается: деплой в 1 клик, мультимодальность, команды и не только',
  'chat.amrBalanceGate.laterCta': 'Не сейчас',
  'chat.amrBalanceGate.plansCta': 'Улучшить тариф',
  'chat.amrBalanceGate.signedOutTitle': 'Войдите, чтобы начать творить',
  'chat.amrBalanceGate.signedOutMessage': 'Вы используете агент OpenDesign Cloud — войдите, и эта задача сразу запустится.',
  'chat.amrBalanceGate.signInCta': 'Войти',
  'chat.amrBalanceGate.watchingWallet': 'Продолжим автоматически, как только баланс обновится.',
  'chat.amrLowBalance.title': 'Кредиты заканчиваются',
  'chat.amrLowBalance.message': 'Осталось всего {balance} — вероятно, не хватит, чтобы завершить задачу. Сначала пополните баланс или улучшите тариф.',
  'chat.amrLowBalance.rechargeCta': 'Пополнить',
  'chat.amrLowBalance.proceedCta': 'Всё равно запустить',
  'chat.amrLowBalance.dontRemind': 'Больше не спрашивать',
  'chat.amrArtifactUpgrade.title': 'Продолжайте улучшать работу с более мощными моделями',
  'chat.amrArtifactUpgrade.message': 'Откройте продвинутые модели, больше параллельных задач и больше кредитов в месяц.',
  'chat.amrArtifactUpgrade.benefit1': 'Больше продвинутых моделей, включая Fable 5 и GPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'До 10 раз больше параллельных задач',
  'chat.amrArtifactUpgrade.benefit3': 'До 300 раз больше ежемесячных кредитов',
  'chat.amrArtifactUpgrade.benefit4': 'Приоритетная очередь в часы пик для быстрой генерации',
  'chat.amrArtifactUpgrade.promoBanner': 'Ограниченное предложение: скидка до 67% на подписку',
  'chat.amrArtifactUpgrade.countdownLabel': 'До конца акции',
  'chat.amrArtifactUpgrade.plansCta': 'Оформить подписку, скидка до 67%',
  'chat.amrArtifactUpgrade.homePlansCta': 'Сэкономить 67%',
  'chat.amrArtifactUpgrade.laterCta': 'Продолжить с Free и отправить',
  'chat.amrArtifactUpgrade.homeTitle': 'Работа готова. Сделайте следующую идею ещё сильнее.',
  'chat.amrArtifactUpgrade.homeMessage': 'Обновите тариф ради более мощных моделей, параллельных задач и дополнительных кредитов.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'Посмотреть работу',
  'chat.antigravityError.launchTerminalCta': 'Войти через терминал',
  'chat.antigravityError.launchSwitchModelCta': 'Сменить модель в терминале',
  'chat.connectionDropped': 'Соединение с сервисом модели прервалось до завершения ответа — обычно из-за нестабильной сети или прокси. Повторите попытку.',
  'chat.runError.title.authRequired': 'Требуется авторизация',
  'chat.runError.title.balance': 'Недостаточно средств',
  'chat.runError.title.connectionDropped': 'Соединение прервано',
  'chat.runError.title.signInRequired': 'Требуется вход',
  'chat.runError.title.rateLimited': 'Достигнут лимит использования',
  'chat.runError.title.modelWindowLimit': 'Высокая нагрузка',
  'chat.runError.title.strategyTaskHalted': "Задача остановлена контролем качества",
  'chat.runError.title.generic': 'Задача не выполнена',
  'chat.runError.title.artifactMissing': 'Результат не создан',
  'chat.runError.signInMessage.amr': 'Агент OpenDesign Cloud ещё не вошёл в систему — войдите, чтобы начать им пользоваться.',
  'chat.runError.signInMessage.other': '{agent} не выполнил вход. Проверьте статус входа локально. Рекомендуем агента OpenDesign Cloud — стабильнее и выгоднее.',
  'chat.runError.agentFallback': 'агент',
  'chat.runError.sourceLabel': 'Сведения об ошибке',
  'chat.runError.sourceExpandAria': 'Развернуть источник ошибки',
  'chat.runError.sourceCollapseAria': 'Свернуть источник ошибки',
  'chat.runError.title.cliMissing': 'Агент не установлен',
  'chat.runError.title.promptTooLarge': 'Слишком длинный ввод',
  'chat.runError.title.modelUnavailable': 'Модель недоступна',
  'chat.runError.title.upstreamUnavailable': 'Сервис временно недоступен',
  'chat.runError.title.toolLoop': 'Застряло в цикле',
  'chat.runError.title.outputInvalid': 'Недопустимый вывод модели',
  'chat.runError.title.runtimeConfig': 'Ошибка конфигурации',
  'chat.runError.cliMissingMessage': 'Инструмент командной строки {agent} не найден. Установите его и убедитесь, что он в PATH, затем повторите.',
  'chat.runError.promptTooLargeMessage': 'Этот запрос превысил лимит контекста модели. Сократите запрос, удалите вложения или начните новый разговор и повторите.',
  'chat.runError.modelUnavailableMessage': 'Выбранная модель недоступна или не существует. Переключитесь на другую модель в настройках и повторите.',
  'chat.runError.rateLimitedMessage': 'Достигнут лимит использования сервиса модели. Подождите немного и повторите или переключитесь на другую модель или сервис.',
  'chat.runError.modelWindowLimitMessage': 'Сейчас высокая нагрузка. Повторите попытку после {retryAt}. Этот запрос не был оплачен.',
  'chat.runError.modelWindowLimitMessageNoTime': 'Сейчас высокая нагрузка. Повторите попытку чуть позже. Этот запрос не был оплачен.',
  'chat.runError.upstreamUnavailableMessage': 'Сервис модели временно недоступен — обычно из-за нестабильности вышестоящего сервиса или проблемы сети/прокси. Повторите через мгновение.',
  'chat.runError.toolLoopMessage': '{agent} повторял одно и то же действие без прогресса и был остановлен. Проверьте целевой файл или команду и повторите.',
  'chat.runError.outputInvalidMessage': 'Модель выдала недопустимый вывод, и этот запрос был прерван. Обычно помогает повтор.',
  'chat.runError.runtimeConfigMessage': 'Конфигурация среды выполнения выбранного агента недействительна, поэтому запуск не удался. Обновитесь до последней версии или обратитесь в поддержку.',
  'chat.runError.title.quotaExhausted': "Лимит исчерпан",
  'chat.runError.title.timedOut': "Время ожидания истекло",
  'chat.runError.title.emptyOutput': "Нет вывода",
  'chat.runError.title.sessionExpired': "Сессия истекла",
  'chat.runError.title.gitBashMissing': "Нет Git Bash",
  'chat.runError.title.cpuUnsupported': "Процессор не поддерживается",
  'chat.runError.quotaExhaustedMessage': "Квота или платёжный лимит вашего модельного сервиса исчерпаны, повтор не поможет. Пополните баланс у провайдера или переключитесь на другую модель или сервис.",
  'chat.runError.workspaceCreditsMessage': "В вашем рабочем пространстве закончились кредиты. Добавьте кредиты (или попросите владельца пространства пополнить) либо переключитесь на другую модель или сервис.",
  'chat.runError.timedOutMessage': "Этот запуск длился слишком долго и был остановлен. Повторите попытку или сократите задачу и попробуйте снова.",
  'chat.runError.inactivityTimeoutMessage': "Агент слишком долго не выдавал новый вывод и был остановлен по тайм-ауту. Обычно повторная попытка возобновляет работу.",
  'chat.runError.emptyOutputMessage': "Агент завершился, не выдав никакого вывода. Обычно это временно, повторите попытку.",
  'chat.runError.sessionExpiredMessage': "Возобновляемая сессия истекла. Она сброшена, поэтому повторите попытку, чтобы начать новый запуск.",
  'chat.runError.gitBashMissingMessage': "Для запуска этого агента в Windows требуется Git Bash, но он не найден. Установите Git для Windows и повторите попытку.",
  'chat.runError.cpuUnsupportedMessage': "Среде выполнения этого агента требуется набор инструкций процессора (AVX2), которого нет на этом устройстве, поэтому она не может запуститься. Обновите OpenDesign до последней версии — она включает совместимую среду выполнения.",
  'chat.runError.strategyTaskStateMismatchMessage': "Эта задача уже остановлена контролем качества стратегии, поэтому этот этап формы нельзя продолжить. Повторите запрос или начните новый.",
  'common.cancel': 'Отмена',
  'chat.selectFromLibrary': 'Импортировать из библиотеки',
  'chat.importFigma': 'Импортировать из Figma',
  'chat.plus.group.files': 'Файлы',
  'chat.plus.group.code': 'Код',
  'chat.plus.group.designs': 'Дизайн',
  'chat.plus.group.other': 'Другое',
  'chat.plus.attachFiles': 'Прикрепить файлы',
  'chat.plus.referenceProject': 'Добавить другой проект как референс',
  'chat.plus.linkLocalCode': 'Подключить локальный код',
  'chat.plus.uploadFig': 'Загрузить .fig',
  'chat.plus.learnHow': 'Как это работает',
  'chat.plus.designSystem': 'Дизайн-система',
  'chat.plus.skills': 'Навыки',
  'chat.plus.noSkills': 'Навыки недоступны',
  'chat.plus.connectors': 'Коннекторы',
  'chat.plus.plugins': 'Плагины',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Добавить другой проект как референс',
  'chat.referenceProject.search': 'Поиск проектов…',
  'chat.referenceProject.empty': 'Проекты по запросу «{query}» не найдены',
  'chat.referenceProject.emptyAll': 'Других проектов пока нет',
  'chat.referenceProject.loadFailed': 'Не удалось загрузить проекты. Проверьте, что daemon запущен, и повторите попытку.',
  'chat.referenceProject.confirm': 'Добавить проект',
  'chat.contextPrompt.referenceProject': 'Используйте проект OpenDesign «{name}» как референсный контекст. Его локальный путь: {path}. Перед проектированием или изменениями при необходимости найдите и прочитайте файлы в этой папке.',
  'chat.contextPrompt.localCode': 'Используйте локальную папку с кодом «{name}» как референс по реализации. Абсолютный путь: {path}. При необходимости читайте связанные файлы и сохраняйте согласованность с текущей кодовой базой.',
  'chat.figmaHelp.title': 'Как скачать файл .fig',
  'chat.figmaHelp.intro': 'В веб-версии или десктопном приложении Figma:',
  'chat.figmaHelp.step1': 'Откройте файл в Figma.',
  'chat.figmaHelp.step2': 'Выберите File → Save local copy... (в веб-версии: главное меню → File).',
  'chat.figmaHelp.step3': 'Figma скачает файл .fig. Перетащите его в поле ввода сообщения или загрузите вручную.',
  'chat.figmaHelp.note': 'Файл .fig разбирается локально и не загружается в Figma.',
  'designFiles.library.label': 'Импортировать из библиотеки',
  'designFiles.library.title': 'Импортировать из библиотеки',
  'libraryPicker.title': 'Импортировать из библиотеки',
  'libraryPicker.searchPlaceholder': 'Поиск в библиотеке…',
  'libraryPicker.empty': 'В вашей библиотеке пока нет ресурсов',
  'libraryPicker.allKinds': 'Все',
  'libraryPicker.add': 'Импорт',
  'libraryPicker.loading': 'Загрузка…',
  'common.save': 'Сохранить',
  'common.close': 'Закрыть',
  'common.clear': 'Очистить',
  'common.delete': 'Удалить',
  'common.rename': 'Переименовать',
  'common.edit': 'Редактировать',
  'common.preview': 'Предпросмотр',
  'common.share': 'Поделиться',
  'common.search': 'Поиск',
  'common.searchEllipsis': 'Поиск…',
  'common.loading': 'Загрузка…',
  'common.all': 'Все',
  'common.none': 'Нет',
  'common.default': 'По умолчанию',
  'common.installed': 'установлено',
  'common.notInstalled': 'не установлено',
  'common.active': 'активно',
  'common.inactive': 'неактивно',
  'common.offline': 'офлайн',
  'common.selected': 'выбрано',
  'common.create': 'Создать',
  'common.openPreview': 'Открыть предпросмотр',
  'common.exitFullscreen': 'Выйти из полноэкранного режима',
  'common.fullscreen': 'Полноэкранный режим',
  'common.openInNewTab': 'Открыть в новой вкладке',
  'common.exportPdf': 'Экспорт в PDF',
  'common.exportZip': 'Скачать как .zip',
  'common.exportHtml': 'Экспорт как HTML',
  'common.exportImage': 'Экспорт как изображение',
  'common.exportImageFailed': 'Не удалось захватить изображение. Попробуйте еще раз или воспользуйтесь инструментом создания снимков экрана в браузере.',
  'common.justNow': 'только что',
  'common.minutesAgo': '{n} мин. назад',
  'common.hoursAgo': '{n} ч. назад',
  'common.daysAgo': '{n} д. назад',
  'common.weeksAgo': '{n} нед. назад',
  'common.now': 'сейчас',
  'common.minutesShort': '{n}м',
  'common.hoursShort': '{n}ч',
  'common.daysShort': '{n}д',
  'common.untitled': 'Без названия',
  'designBrowser.savePageBrief': 'Сохранить бриф страницы',
  'designBrowser.viewport.desktop': 'Десктоп',
  'designBrowser.viewport.desktopTitle': 'Использовать полный размер вкладки браузера',
  'designBrowser.viewport.tablet': 'Планшет',
  'designBrowser.viewport.tabletTitle': 'Предпросмотр шириной 820 пикс.',
  'designBrowser.viewport.mobile': 'Мобильный',
  'designBrowser.viewport.mobileTitle': 'Предпросмотр шириной 390 пикс.',
  'designBrowser.menu': 'Меню браузера',
  'designBrowser.copyScreenshot': 'Скопировать снимок экрана',
  'designBrowser.hardReload': 'Жесткая перезагрузка',
  'designBrowser.copyUrl': 'Скопировать URL',
  'designBrowser.openExternal': 'Открыть во внешнем браузере',
  'designBrowser.downloadPage': 'Скачать страницу',
  'designBrowser.downloadPageBusy': 'Скачиваем страницу...',
  'designBrowser.clearHistory': 'Очистить историю',
  'designBrowser.clearCookies': 'Очистить cookies',
  'designBrowser.clearAllData': 'Очистить все данные браузера',
  'designBrowser.status.noUrlToCopy': 'Нет URL для копирования.',
  'designBrowser.status.urlCopied': 'URL скопирован.',
  'designBrowser.status.openHttpFirst': 'Сначала откройте страницу http или https.',
  'designBrowser.status.openBeforeScreenshot': 'Откройте страницу, прежде чем делать снимок экрана.',
  'designBrowser.status.screenshotSaved': 'Снимок экрана сохранен.',
  'designBrowser.addImageToChatButton': 'Добавить в чат',
  'designBrowser.status.imageAddedToChat': 'Изображение добавлено в чат.',
  'designBrowser.status.screenshotFailed': 'Не удалось сделать снимок экрана.',
  'designBrowser.status.openBeforeBrief': 'Откройте страницу, прежде чем сохранять бриф.',
  'designBrowser.status.briefSaveFailed': 'Не удалось сохранить бриф страницы.',
  'designBrowser.status.openBeforeDownload': 'Откройте страницу, прежде чем сохранять снимок.',
  'designBrowser.status.pageSnapshotStarted': 'Сохраняем снимок страницы...',
  'designBrowser.status.pageSnapshotUnsupported': 'Эту страницу нельзя заархивировать.',
  'designBrowser.status.pageSnapshotFailed': 'Не удалось сохранить снимок страницы.',
  'designBrowser.status.pageSnapshotSaved': 'Снимок страницы сохранен (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'Посмотреть дизайн-файлы',
  'designBrowser.status.downloadAssistHint': 'Когда страница будет готова, нажмите «Скачать страницу». После сохранения вернитесь в чат.',
  'designBrowser.status.desktopDataUnavailable': 'Данные десктопного браузера здесь недоступны.',
  'designBrowser.status.browserDataCleared': 'Данные браузера очищены.',
  'designBrowser.status.browserDataClearFailed': 'Не удалось очистить данные браузера.',
  'designBrowser.status.historyCleared': 'История очищена.',
  'plugins.availableDetails.provenance': 'Происхождение',
  'plugins.availableDetails.provenanceLine': 'из {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'из {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Установить',
  'plugins.availableDetails.version': 'Версия',
  'plugins.availableDetails.pluginVersion': 'Версия плагина',
  'plugins.availableDetails.copyInstallCommand': 'Скопировать команду установки',
  'plugins.availableDetails.copied': 'Скопировано',
  'plugins.availableDetails.deprecatedPrefix': 'Устарело: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Эта версия помечена как устаревшая.',
  'plugins.availableDetails.yanked': 'Снято с публикации.',
  'plugins.availableDetails.yankedWithReason': 'Снято с публикации: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (устарело)',
  'plugins.availableDetails.versionYankedSuffix': ' (снято с публикации)',
  'plugins.availableDetails.ref': 'Ревизия',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Разрешения',
  'plugins.availableDetails.capabilitySummary': 'Сводка возможностей',
  'plugins.actions.copyInstallCommand': 'Скопировать команду установки',
  'plugins.actions.copyPluginId': 'Скопировать ID плагина',
  'plugins.actions.copyReadmeBadge': 'Скопировать бейдж README',
  'plugins.actions.openSourceGithub': 'Открыть исходники на GitHub',
  'plugins.actions.openSource': 'Открыть исходники',
  'plugins.actions.openHomepage': 'Открыть домашнюю страницу',
  'plugins.actions.openMarketplace': 'Открыть в маркетплейсе',
  'app.brand': 'OpenDesign',
  'app.brandPill': 'Предварительная исследовательская версия',
  'app.brandSubtitle': 'от Nexu Labs',
  'app.welcomeLoading': 'Загрузка рабочего пространства…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Добро пожаловать в OpenDesign',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Начать с краткого описания',
  'settings.onboardingCreateBody': 'Опишите сайт, приложение, презентацию, изображение или видео, которое вам нужно. OpenDesign создаст проект и сохранит возможность редактирования работы.',
  'settings.onboardingMemoryTitle': 'Сохранить рабочий контекст',
  'settings.onboardingMemoryBody': 'Добавьте предпочтения, факты о проекте и повторяющиеся правила, чтобы будущие чаты учитывали нужный контекст.',
  'settings.onboardingMemoryCalloutTitle': 'Сохранено в памяти',
  'settings.onboardingMemoryCalloutBody': 'Эти ответы формируют основу вашего профиля памяти. OpenDesign использует его в каждой задаче и продолжает учиться, пока вы работаете.',
  'settings.onboardingMemoryBenefitIntent': 'Понимает, что вы имеете в виду, по короткому запросу',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Пропускает повторяющиеся вопросы по настройке',
  'settings.onboardingMemoryBenefitPersonalized': 'Адаптирует результат под вашу роль, аудиторию и вкус',
  'settings.onboardingSystemsTitle': 'Подключите свою дизайн-систему',
  'settings.onboardingSystemsBody': 'Выберите или создайте бренд-систему, чтобы сгенерированные работы соответствовали реальным цветам, типографике и языку продукта.',
  'settings.onboardingExecutionTitle': 'Выберите источник модели',
  'settings.onboardingExecutionBody': 'Используйте OpenDesign Hosted, подключите локального агента или укажите собственный ключ модели.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Официально рекомендовано',
  'settings.onboardingAmrCloudBenefitReady': 'Без развертывания',
  'settings.onboardingAmrCloudBenefitModels': 'Получите доступ к Claude, GPT, Fable 5 и 5.6 sol со временной скидкой и высокой параллельностью.',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'Скоро',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Изображения и видео',
  'settings.onboardingAmrCloudUpcomingSkills': 'Много навыков',
  'settings.onboardingAmrCloudUpcomingRouting': 'Умная маршрутизация',
  'settings.onboardingAmrModelSourceLabel': 'OpenDesign Hosted',
  'settings.onboardingAmrCloudAuthorizeAction': 'Авторизовать OpenDesign Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'Авторизовано',
  'settings.onboardingStepConnect': 'Подключение',
  'settings.onboardingStepDesignSystem': 'Создать дизайн-систему',
  'settings.onboardingStepProfile': 'О вас',
  'settings.onboardingStepNewsletter': 'Будьте в курсе',
  'settings.onboardingNewsletterTitle': 'Оставайтесь в курсе',
  'settings.onboardingNewsletterBody': 'Получайте новости продукта, новые шаблоны, дизайн-системы и работу амбассадоров на почту. Необязательно — можно пропустить.',
  'settings.onboardingConnectTitle': 'Выберите среду запуска',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Войти в OpenDesign',
  'settings.onboardingCloudBody': 'Войдите и сразу начните создавать с облачным ИИ — без сложных настроек.',
  'settings.onboardingCloudSignIn': 'Войти в OpenDesign',
  'settings.onboardingCloudContinue': 'Продолжить (вы вошли)',
  'settings.onboardingCloudAlternative': 'Использовать локальный CLI или свой ключ API',
  'settings.onboardingCloudRights': 'Все права защищены.',
  'settings.onboardingCloudOr': 'или',
  'settings.onboardingGateTooltipNoRuntime': 'Следующие шаги выполняются на ИИ — выберите способ запуска, чтобы продолжить.',
  'settings.onboardingGateTooltipAmr': 'Следующие шаги выполняются на ИИ — войдите в OpenDesign Cloud, чтобы продолжить.',
  'settings.onboardingGateTooltipLocal': 'Следующие шаги выполняются на ИИ — выберите доступный локальный CLI, чтобы продолжить.',
  'settings.onboardingGateTooltipByok': 'Следующие шаги выполняются на ИИ — добавьте и протестируйте ключ модели, чтобы продолжить.',
  'settings.onboardingRecommended': 'Рекомендуется',
  'settings.onboardingAmrCloudOfficialBadge': 'Официальный',
  'settings.onboardingLocalTitle': 'Локальный агент',
  'settings.onboardingLocalBody': 'Используйте Claude Code, Codex, Cursor, OpenCode, Kimi, Qwen, Hermes, Kiro и другие.',
  'settings.onboardingLocalAction': 'Открыть настройки CLI',
  'settings.onboardingCliScanHint': 'Обычно это занимает 5-10 секунд.',
  'settings.onboardingByokTitle': 'Собственный ключ',
  'settings.onboardingByokBody': 'Безопасно подключите выбранного поставщика моделей с помощью собственного API-ключа.',
  'settings.onboardingByokAction': 'Открыть настройки BYOK',
  'settings.onboardingDesignTitle': 'Дизайн-система',
  'settings.onboardingDesignBody': 'Создайте один раз и переиспользуйте везде.',
  'settings.onboardingDesignIntroGenerateTitle': 'Создать из существующих материалов',
  'settings.onboardingDesignIntroGenerateBody': 'Загрузите дизайн-систему из GitHub или локального репозитория, файлов Figma, изображений и других материалов.',
  'settings.onboardingDesignIntroReuseTitle': 'Переиспользовать в будущих проектах',
  'settings.onboardingDesignIntroReuseBody': 'Будущие прототипы, презентации и другие материалы смогут ссылаться на ваши шрифты, отступы, стиль логотипа и цветовой тон.',
  'settings.onboardingDesignIntroSkipTitle': 'Пока необязательно',
  'settings.onboardingDesignIntroSkipBody': 'Пропустите этот шаг, если хотите начать без генерации дизайн-системы.',
  'settings.onboardingGithubTitle': 'Импорт из GitHub',
  'settings.onboardingGithubBody': 'Используйте frontend-репозиторий.',
  'settings.onboardingUploadTitle': 'Загрузить локальные файлы',
  'settings.onboardingUploadBody': 'Добавьте файлы проекта, снимки экрана, CSS, документацию или ассеты.',
  'settings.onboardingPromptTitle': 'Создать по запросу',
  'settings.onboardingPromptBody': 'Опишите продукт или бренд.',
  'settings.onboardingProfileTitle': 'О вас',
  'settings.onboardingProfileBody': 'Необязательные сведения для более точных настроек по умолчанию.',
  'settings.onboardingRoleLabel': 'Ваша роль',
  'settings.onboardingOrgSizeLabel': 'Размер организации',
  'settings.onboardingUseCaseLabel': 'Сценарий использования',
  'settings.onboardingSourceLabel': 'Откуда вы о нас узнали?',
  'settings.onboardingSelectPlaceholder': 'Выберите вариант',
  'settings.onboardingSelectMultiplePlaceholder': 'Выберите один или несколько вариантов',
  'settings.onboardingOrgSolo': 'Соло / личное использование (1)',
  'settings.onboardingOrgTeam': 'Небольшая команда (2-10)',
  'settings.onboardingOrgStartup': 'Стартап / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Растущая компания (51-200)',
  'settings.onboardingOrgMidMarket': 'Средний бизнес (201-1000)',
  'settings.onboardingOrgEnterprise': 'Крупная компания (1000+)',
  'settings.onboardingRolePm': '📋 Менеджер продукта',
  'settings.onboardingRoleDesigner': '🎨 Дизайнер',
  'settings.onboardingRoleEngineer': '💻 Инженер',
  'settings.onboardingRoleMarketing': '📣 Маркетинг',
  'settings.onboardingRoleAgency': '📣 Маркетинговое агентство',
  'settings.onboardingRoleGrowth': '📈 Рост',
  'settings.onboardingRoleOps': '⚙️ Операции',
  'settings.onboardingRoleFounder': '🚀 Фаундер / руководитель',
  'settings.onboardingRoleStudent': '🎓 Студент / преподаватель',
  'settings.onboardingRoleOther': '✨ Другое',
  'settings.onboardingUseProduct': '🎨 Продуктовый дизайн',
  'settings.onboardingUseDesignSystem': '🧩 Дизайн-система',
  'settings.onboardingUsePrototype': '📱 Прототип / UI приложения',
  'settings.onboardingUseLanding': '🌐 Лендинги',
  'settings.onboardingUseAds': '📣 Реклама / контент для соцсетей',
  'settings.onboardingUseDashboard': '📊 Дашборды / внутренние инструменты',
  'settings.onboardingUseDeck': '🖥️ Презентация / слайды',
  'settings.onboardingUseMarketing': '📈 Маркетинг / рост',
  'settings.onboardingUseEngineering': '🤝 Передача в разработку',
  'settings.onboardingUseAgency': '💼 Агентская / клиентская работа',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 Поиск (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 AI-инструмент (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 Друг или коллега',
  'settings.onboardingSourceCommunity': '💬 Discord / сообщество',
  'settings.onboardingSourceEmail': '✉️ Email / рассылка',
  'settings.onboardingSourceBlog': '📝 Блог / статья',
  'settings.onboardingSourceOther': '✨ Другое',
  'settings.onboardingSourceOtherPlaceholder': 'Укажите, где именно (необязательно)',
  'settings.onboardingBack': 'Назад',
  'settings.onboardingContinue': 'Продолжить',
  'settings.onboardingFinish': 'Завершить настройку',
  'settings.kicker': 'Настройки',
  'settings.title': 'Модели и провайдеры',
  'settings.subtitle': 'Выберите локальный CLI или BYOK.',
  'settings.general': 'Основные',
  'settings.generalHint': 'Язык, внешний вид, уведомления, расположения проектов, приватность и сведения о приложении.',
  'settings.modeAria': 'Режим выполнения',
  'settings.protocolAria': 'Протокол API',
  'settings.modeDaemon': 'Локальный CLI',
  'settings.modeDaemonHelp': 'Запуск через CLI код-агента на вашем компьютере',
  'settings.modeDaemonOffline': 'Демон не запущен',
  'settings.modeDaemonOfflineMeta': 'демон офлайн',
  'settings.modeDaemonInstalledMeta': '{count} установлено',
  'settings.modeApi': 'API-провайдер',
  'settings.cloudCalloutTitle': 'Use OpenDesign Cloud',
  'settings.cloudCalloutBody': 'Sign in to the cloud version to enable team spaces, shared projects, member permissions, and the audit dashboard.',
  'settings.cloudCalloutButton': 'Sign in / Register',
  'settings.modeApiMeta': 'API-провайдеры',
  'settings.byokNoFileToolsNotice': 'BYOK не может читать, записывать или редактировать файлы проекта. Используйте Local CLI, когда нужны изменения в коде.',
  'settings.byokDraftNotice': 'Заполните обязательные поля, чтобы сохранить этого провайдера. Текущая конфигурация останется активной.',
  'settings.codeAgent': 'Код-агент',
  'settings.codeAgentHint': 'Определяется сканированием вашего PATH. Выберите CLI, через который будут проходить генерации.',
  'settings.rescan': '↻ Пересканировать',
  'settings.rescanTitle': 'Пересканировать PATH',
  'settings.rescanRunning': 'Сканирование...',
  'settings.rescanSuccess': 'Сканирование завершено. Доступно: {count}.',
  'settings.designSystemRenameFailed': 'Не удалось переименовать. Проверьте демон и повторите попытку.',
  'settings.rescanFailed': 'Сканирование не удалось. Проверьте демон и повторите попытку.',
  'settings.test': 'Тест',
  'settings.testTitle': 'Отправить крошечный тестовый запрос для проверки соединения',
  'settings.testRunning': 'Проверка соединения…',
  'settings.byokReadyToTest': 'Готово к проверке',
  'settings.testCancel': 'Отмена',
  'settings.testRetry': 'Повторить проверку',
  'settings.required': 'обязательно',
  'settings.testMissingFields': 'Заполните {fields}, чтобы проверить подключение.',
  'settings.testSuccessApi': 'Подключено. Ответ за {ms} мс — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} ответил за {ms} мс — \'{sample}\'',
  'settings.testAuthFailed': 'Сбой аутентификации. Проверьте ключ API.',
  'settings.testForbidden': 'Доступ запрещен. Проверьте учетную запись, регион или организацию.',
  'settings.testNotFoundModel': 'Модель \'{model}\' не найдена на этом эндпойнте.',
  'settings.testInvalidModelId': 'ID модели \'{model}\' недействителен. Пользовательский ID должен начинаться с буквы или цифры и не содержать пробелов.',
  'settings.testInvalidBaseUrl': 'Base URL недействителен или недоступен.',
  'settings.testRateLimited': 'Поставщик ограничил тест. Конфигурация выглядит верной.',
  'settings.testUpstream': 'Поставщик вернул {status}. Повторите попытку чуть позже.',
  'settings.testTimeout': 'Тест прерван по таймауту через {ms} мс.',
  'settings.testAgentMissing': '{agentName} не установлен или отсутствует в PATH.',
  'settings.testAgentSpawn': 'Не удалось запустить {agentName}: {detail}.',
  'settings.testUnknown': 'Тест не пройден: {detail}',
  'settings.agentInstall.install': 'Установить',
  'settings.agentInstall.docs': 'Документация',
  'settings.agentInstall.pathHint': 'Если вы установили CLI через npm или Homebrew, но она всё ещё отмечена как не установленная, убедитесь, что bin-каталог инструмента есть в PATH, который наследует daemon OpenDesign (в macOS PATH у Terminal и GUI-приложений может отличаться). См. QUICKSTART.md (раздел "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Откройте Установить или Документация для нужного агента.',
  'settings.agentInstall.stepAuth': 'Пройдите аутентификацию в CLI поставщика (вход или добавление API-ключей), затем вернитесь в OpenDesign.',
  'settings.agentInstall.stepRescan': 'Нажмите «Пересканировать» в этом разделе.',
  'settings.agentInstall.stepSelect': 'Выберите карточку агента, когда он появится как установленный.',
  'settings.noAgentsDetected': 'Агенты ещё не обнаружены. Установите один из следующих инструментов: Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen или GitHub Copilot CLI, затем нажмите «Пересканировать».',
  'settings.agentInstalledGroup': 'Ваши CLI ({count})',
  'settings.agentInstallGroup': 'Доступно для установки ({count})',
  'settings.agentAuthRequired': 'Требуется аутентификация',
  'settings.agentAuthUnknown': 'Статус аутентификации неизвестен',
  'settings.amrCloud': 'OpenDesign Cloud',
  'settings.amrAuthorize': 'Авторизовать',
  'settings.amrBenefitOfficial': 'Официальный',
  'settings.amrBenefitLowerPrice': 'Ниже стоимость',
  'settings.amrBenefitManyModels': 'Множество моделей',
  'settings.amrPromoBonus': 'Ограниченный бонус: +100%',
  'settings.amrSignInToContinue': 'Войдите, чтобы продолжить',
  'settings.amrSignIn': 'Войти',
  'settings.amrSignedIn': 'Вы вошли',
  'settings.amrWalletBalance': 'Баланс кошелька',
  'settings.amrWalletUnavailable': 'Баланс временно недоступен',
  'settings.amrWalletUpdatedAt': 'Обновлено {time}',
  'settings.amrWalletCached': 'из кэша',
  'settings.amrWalletRefresh': 'Обновить',
  'settings.amrWalletRefreshTitle': 'Обновить баланс OpenDesign Cloud-кошелька',
  'settings.amrNotSignedIn': 'Вы не вошли',
  'settings.amrSigningIn': 'Вход…',
  'settings.amrActivationHint': 'Страница входа не открылась? Нажмите кнопку ниже, чтобы открыть её снова.',
  'settings.amrActivationBrowserFailed': 'Не удалось открыть браузер автоматически. Откройте страницу входа ниже, чтобы продолжить.',
  'settings.amrActivationOpen': 'Открыть страницу входа',
  'settings.amrCancelSignIn': 'Отменить вход',
  'settings.amrAccountStatus': 'Статус аккаунта OpenDesign Cloud',
  'settings.amrConsole': 'Управлять',
  'settings.amrBalance': 'Лимит',
  'settings.amrPlan': 'Тариф',
  'settings.amrUpgrade': 'Улучшить',
  'settings.amrModelUpgradeHint': 'Обновите, чтобы использовать',
  'settings.amrLoginErrorCompact': 'Не удалось войти в OpenDesign Cloud.',
  'settings.advanced': 'Дополнительно',
  'settings.amrLogin': 'Войти',
  'settings.amrLogout': 'Выйти',
  'settings.amrLoggingIn': 'Вход…',
  'settings.amrLoggingOut': 'Выход…',
  'settings.amrLoggedInAs': 'Вы вошли как {email}',
  'settings.amrLoggedInWithPlan': 'Вход выполнен как {email} · {plan}',
  'settings.amrLoggedInPill': 'Вы вошли',
  'settings.amrNotLoggedIn': 'Вы не вошли',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Быстро заполнить провайдера',
  'settings.providerPreset': 'Пресет провайдера',
  'settings.protocolGroupProtocols': 'Протоколы',
  'settings.protocolGroupGateways': 'Шлюзы',
  'settings.customProvider': 'Пользовательский провайдер',
  'settings.apiKey': 'API-ключ',
  'settings.apiKeyGetLink': 'Получить ключ ↗',
  'settings.showKey': 'Показать ключ',
  'settings.hideKey': 'Скрыть ключ',
  'settings.show': 'Показать',
  'settings.hide': 'Скрыть',
  'settings.model': 'Модель',
  'settings.apiKeyInvalid': 'Недействительный API key.',
  'settings.apiKeyCleaned': 'Из API key удалены лишние пробелы.',
  'settings.modelsLoadedFromAccount': '✓ Загружено моделей из вашего аккаунта: {count}.',
  'settings.modelsLoadedCount': '✓ Загружено моделей: {count}.',
  'settings.modelSourceAccount': 'Из вашего аккаунта',
  'settings.modelSourceSuggested': 'Рекомендуемое',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'Низкая стоимость',
  'modelCost.halfToOne': 'Средняя стоимость',
  'modelCost.oneToFour': 'Высокая стоимость',
  'modelCost.overFour': 'Максимальная стоимость',
  'settings.fetchModels': 'Загрузить модели',
  'settings.fetchModelsTitle': 'Загрузить доступные модели от этого провайдера',
  'settings.fetchModelsRunning': 'Загрузка моделей…',
  'settings.fetchModelsMissingFields': 'Заполните {fields}, чтобы загрузить модели.',
  'settings.fetchModelsInvalidBaseUrl': 'Введите корректный Base URL, чтобы загрузить модели.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI использует имена развёртываний, поэтому обнаружение моделей здесь недоступно.',
  'settings.fetchModelsUnsupportedOllama': 'Обнаружение моделей Ollama Cloud пока недоступно. Выберите или введите модель.',
  'settings.fetchModelsSuccess': 'Загружено моделей: {count}.',
  'settings.fetchModelsEmpty': 'Совместимые текстовые модели не найдены.',
  'settings.fetchModelsUnsupported': 'Обнаружение моделей недоступно для этого протокола.',
  'settings.fetchModelsFailed': 'Не удалось загрузить модели: {detail}',
  'settings.suggestedModelsHint': 'Это рекомендуемые модели для этого протокола. Ваш провайдер может поддерживать другие модели.',
  'settings.baseUrl': 'Базовый URL',
  'settings.baseUrlInvalid': 'Используйте публичный URL с http:// или https://.',
  'settings.baseUrlCustomize': 'Настроить URL',
  'settings.baseUrlDefaultHint': 'Изменяйте только при использовании прокси или совместимого шлюза.',
  'settings.azureBaseUrlPlaceholder': 'Вставьте URL эндпоинта Azure',
  'settings.azureBaseUrlHint': 'Найдите это в портале Azure → ваш ресурс → Endpoint.',
  'settings.azureDeploymentModel': 'Имя развертывания',
  'settings.azureCustomDeploymentName': 'Пользовательское имя развёртывания',
  'settings.azureDeploymentModelHint': 'Для Azure OpenAI это поле используется как имя развертывания в /openai/deployments/<model>. Укажите имя развертывания, созданного в Azure.',
  'settings.azureModelFetchHint': 'Введите имя развёртывания из вашего ресурса Azure. Развёртывания Azure нельзя получить автоматически.',
  'settings.apiVersion': 'Версия API',
  'settings.byokImageModel': 'Модель генерации изображений',
  'settings.byokVideoModel': 'Модель генерации видео',
  'settings.byokVideoI2vHint': 'Модель «изображение в видео»: нужно референсное изображение (иначе используется последнее изображение проекта)',
  'settings.byokSpeechModel': 'Модель синтеза речи',
  'settings.byokSpeechVoice': 'Голос',
  'settings.byokModelDefaultOption': 'По умолчанию',
  'settings.maxTokens': 'Макс. токенов (опционально)',
  'settings.maxTokensHint': 'Максимальная длина ответа. Оставьте поле пустым, чтобы использовать значение модели по умолчанию.',
  'settings.apiHint': 'Хранится локально на этом устройстве.',
  'settings.skipForNow': 'Пропустить сейчас',
  'settings.getStarted': 'Начать',
  'settings.envConfigure': 'Модели и провайдеры',
  'settings.localCli': 'Локальный CLI',
  'settings.dshSetupTitle': 'Connect DeepSeek Harness',
  'settings.dshSetupDescription': 'OpenDesign will install its connection component through the dsh CLI on this computer.',
  'settings.dshSetupNote': 'Only the OpenDesign profile component is installed. DeepSeek Harness remains user-installed and user-managed.',
  'settings.dshSetupConfirm': 'Install and select',
  'settings.dshSetupInstalling': 'Installing…',
  'settings.dshSetupRequired': 'Connection setup required',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'агент не выбран',
  'settings.language': 'Язык',
  'settings.languageHint': 'Переключить язык интерфейса. Сохраняется в этом браузере.',
  'settings.agentModelHead': 'Модель для:',
  'settings.modelPicker': 'Модель',
  'settings.modelSourceLive': 'Из CLI в реальном времени',
  'settings.modelUsesCliDefault': 'Значение CLI по умолчанию',
  'settings.modelSourceFallback': 'Встроенный список',
  'settings.reasoningPicker': 'Сложность рассуждений',
  'settings.serviceTierPicker': 'Уровень сервиса',
  'settings.modelPickerHint': 'Получается из CLI, если он поддерживает команду `models`. «По умолчанию» оставляет выбор конфигурации CLI, а «Пользовательская…» позволяет ввести любой ID модели, который CLI принимает.',
  'settings.modelPickerLiveHint': 'Модели обновлены из установленного CLI. Вариант по умолчанию по-прежнему использует конфигурацию CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Модели обновлены из установленного CLI.',
  'settings.modelPickerFallbackHint': 'Показаны встроенные значения по умолчанию. Нажмите «Пересканировать», чтобы получить актуальные модели из CLI.',
  'settings.cliEnvTitle': 'Дополнительно: прокси и пользовательские пути',
  'settings.cliEnvHint': 'Используйте эти поля, чтобы переопределить окружение выбранной CLI: API key, proxy base URL, пользовательские home-каталоги или нестандартные пути к бинарникам. Без base URL CLI использует свой endpoint по умолчанию. Секреты остаются в локальной конфигурации приложения и передаются только выбранной CLI.',
  'settings.cliEnvClaudeConfigDir': 'Каталог конфигурации Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL прокси Claude',
  'settings.cliEnvClaudeApiKey': 'API key Claude CLI',
  'settings.cliEnvCodexHome': 'Домашний каталог Codex',
  'settings.cliEnvCodexBin': 'Путь к исполняемому файлу Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL прокси Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key Codex/OpenAI CLI',
  'settings.modelCustom': 'Пользовательская (введите ниже)…',
  'settings.modelCustomLabel': 'Пользовательский ID модели',
  'settings.modelCustomPlaceholder': 'например, anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Медиа-провайдеры',
  'settings.mediaProvidersHint': 'API-ключи для генерации изображений, видео и аудио. Хранятся локально и синхронизируются с локальным демоном.',
  'settings.mcpServerTitle': 'OpenDesign MCP',
  'settings.mcpServerHint': 'Откройте OpenDesign как MCP-сервер для вашего кодинг-агента.',
  'settings.externalMcpTitle': 'Внешний MCP',
  'settings.externalMcpHint': 'Добавьте MCP-инструменты из внешних сервисов (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'API-ключ',
  'settings.mediaProviderBaseUrl': 'Базовый URL',
  'settings.mediaProviderConfigured': 'Настроено',
  'settings.mediaProviderUnset': 'Не настроено',
  'settings.mediaProviderClear': 'Очистить',
  'settings.mediaProviderClearConfirm': 'Удалить сохранённые настройки {name}? Вам придётся ввести их заново, чтобы использовать {name}.',
  'settings.mediaProviderPlaceholder': 'Вставьте API-ключ',
  'settings.mediaProviderBaseUrlPlaceholder': 'Переопределить базовый URL',
  'settings.mediaProviderReload': 'Перезагрузить из локального демона',
  'settings.mediaProviderReloadError': 'Не удалось заново загрузить настройки медиапровайдеров из локального демона.',
  'settings.mediaProviderReloadSuccess': 'Настройки медиапровайдеров заново загружены из локального демона.',
  'settings.mediaProviderLoadError': 'Не удалось загрузить настройки медиапровайдеров из локального демона. Пока используются настройки, сохранённые в браузере.',
  'settings.mediaProviderComingSoonHint': 'Мы отслеживаем их в дорожной карте; демон пока не поставляет клиент, поэтому настраивать нечего.',
  'settings.privacy': 'Конфиденциальность',
  'settings.privacyHint': 'Какие данные передаются команде OpenDesign',
  'settings.privacyConsentKicker': 'Помогите нам улучшить OpenDesign',
  'settings.privacyConsentLead': 'Передача данных об использовании помогает нам понять, как OpenDesign работает в реальных рабочих процессах, чтобы улучшать то, что сильнее всего влияет на ваш опыт.',
  'settings.privacyConsentFooter': 'Эти параметры можно изменить в любой момент в разделе «Настройки → Конфиденциальность».',
  'settings.privacyConsentShare': 'Поделиться',
  'settings.privacyConsentDecline': 'Не передавать',
  'settings.privacyConsentAccept': 'Понятно',
  'settings.privacyConsentBannerFooter': 'Передача данных включена по умолчанию. Вы можете отключить её в любой момент в разделе «Настройки → Конфиденциальность».',
  'settings.privacyConsentPolicyLink': 'Прочитать политику конфиденциальности',
  'settings.privacyMetrics': 'Анонимные метрики',
  'settings.privacyMetricsHint': 'Количество запусков, использование Token, частота ошибок и длительность как базовые метрики использования.',
  'settings.privacyContent': 'Содержимое диалога и инструментов',
  'settings.privacyContentHint': 'После удаления секретов и другой чувствительной информации мы используем запросы, ответы ассистента, входные/выходные данные инструментов и контекст, нужный для проверки качества.',
  'settings.privacyInstallationId': 'Анонимный идентификатор',
  'settings.privacyOptedOut': 'отключено',
  'settings.privacyDataDeletion': 'Удалить мои данные',
  'settings.privacyDataDeletionHint': 'Меняет ваш анонимный идентификатор и прекращает отправку данных. Существующие трассировки удаляются согласно нашей политике хранения.',
  'settings.about': 'О приложении',
  'settings.aboutHint': 'Версия и сведения о запуске',
  'settings.appVersion': 'Версия',
  'settings.appChannel': 'Канал',
  'settings.appRuntime': 'Среда запуска',
  'settings.appPlatform': 'Платформа',
  'settings.appArchitecture': 'Архитектура',
  'settings.runtimePackaged': 'Упакованное приложение',
  'settings.runtimeDevelopment': 'Разработка',
  'settings.versionUnavailable': 'Сведения о версии недоступны, пока daemon не запущен.',
  "settings.allowSilentUpdates": "Разрешить автоустановку будущих обновлений в приложении",
  "settings.allowSilentUpdatesDesc": "Когда внутриприложенческое обновление готово, устанавливать его автоматически при следующем запуске. Текущий сеанс сразу не обновляется. Обновления через установщик по-прежнему требуют подтверждения.",
  'settings.installLatest': 'Установить последнюю версию',
  'settings.alreadyLatest': 'У вас установлена последняя версия',
  'settings.updateCheck': 'Проверить обновления',
  'settings.updateNow': 'Обновить сейчас',
  'settings.updateRecheck': 'Проверить снова',
  'settings.updateRetry': 'Повторить',
  'settings.updateViewReleases': 'Примечания к выпуску',
  'settings.updateActionFailed': 'Не удалось выполнить действие обновления.',
  'settings.updateQuitFailed': 'Установщик открыт, но OpenDesign не смог автоматически закрыться.',
  'settings.updateStatusNotChecked': 'Еще не проверено',
  'settings.updateStatusDevelopment': 'Dev-сборки не поддерживают обновление внутри приложения.',
  'settings.updateStatusUnsupported': 'Эта среда не поддерживает обновление внутри приложения.',
  'settings.updateStatusChecking': 'Проверка обновлений...',
  'settings.updateStatusUpToDate': 'У вас уже последняя версия.',
  'settings.updateStatusAvailable': 'Найдена версия {version}. Подготовка загрузки.',
  'settings.updateStatusAvailableUnknown': 'Найдена новая версия. Подготовка загрузки.',
  'settings.updateStatusDownloading': 'Загрузка обновления...',
  'settings.updateStatusDownloadingPercent': 'Загрузка обновления {percent}%.',
  'settings.updateStatusReady': 'Версия {version} готова к установке.',
  'settings.updateStatusReadyUnknown': 'Обновление готово к установке.',
  'settings.updateStatusInstalling': 'Установка обновления...',
  'settings.updateStatusFailed': 'Проверка не удалась. Повторите.',
  'settings.mcpTitle': 'Сервер MCP',
  'settings.mcpHint': 'Позвольте агентам для кода (Cursor, Claude Code, VS Code…) напрямую читать ваши проекты OpenDesign.',
  'settings.mcpDaemonError': 'Не удалось подключиться к локальному демону для определения путей установки ({error}). Убедитесь, что OpenDesign запущен, затем снова откройте эту панель.',
  'settings.mcpBuildDaemon': 'Сначала соберите демон.',
  'settings.mcpNodeMissing': 'Отсутствует исполняемый файл Node.',
  'settings.mcpBuildHint': 'Файл apps/daemon/dist/cli.js отсутствует. Выполните `pnpm --filter @open-design/daemon build` и обновите.',
  'settings.mcpMethodCli': 'Команда CLI',
  'settings.mcpInstructionCli': 'Выполните это в терминале.',
  'settings.mcpMethodToml': 'Конфигурация TOML',
  'settings.mcpInstructionCodex': 'Добавьте эту таблицу в {path}. Одна и та же конфигурация используется совместно Codex CLI и расширением Codex для IDE.',
  'settings.mcpMethodOneClick': 'Установка в один клик',
  'settings.mcpInstructionCursor': 'Нажмите «Install in Cursor», чтобы установить с диалогом подтверждения, или объедините этот JSON с {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Установить в Cursor',
  'settings.mcpMethodJson': 'Конфигурация JSON',
  'settings.mcpInstructionKiro': 'Откройте {path} и объедините этот JSON. Для конфигурации на уровне workspace используйте .kiro/settings/mcp.json.',
  'settings.mcpInstructionCopilot': 'Откройте палитру команд ({shortcut}), выполните «MCP: Open User Configuration» и объедините этот JSON. Чтобы инструменты отображались, Copilot Chat должен находиться в режиме Agent.',
  'settings.mcpInstructionAntigravity': 'В Antigravity: меню «...» панели Agent → MCP Servers → Manage MCP Servers → View raw config. Объедините этот JSON.',
  'settings.mcpInstructionZed': 'Откройте настройки Zed ({shortcut}) и объедините это с объектом верхнего уровня. Zed использует «context_servers», а не «mcpServers».',
  'settings.mcpInstructionWindsurf': 'Откройте {path} (или используйте значок MCP в Cascade → Configure) и объедините:',
  'settings.mcpCopyAria': 'Скопировать фрагмент конфигурации MCP',
  'settings.mcpResolvingFailed': '# не удалось определить пути, см. ошибку выше',
  'settings.mcpLoadingPaths': '# загрузка путей установки из локального демона…',
  'settings.mcpCopied': 'Скопировано',
  'settings.mcpCopy': 'Копировать',
  'settings.mcpCursorApproval': 'Cursor открывает диалог подтверждения перед записью конфигурации.',
  'settings.mcpCodexOneClickInstall': 'Установить в Codex',
  'settings.mcpCodexOneClickUninstall': 'Удалить из Codex',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI не найден в PATH — установите Codex или вставьте фрагмент вручную.',
  'settings.mcpCodexInstallSuccess': 'Установлено. Перезапустите Codex, чтобы загрузить новый сервер.',
  'settings.mcpCodexUninstallSuccess': 'Удалено из Codex.',
  'settings.mcpCodexBusy': 'Выполняется…',
  'settings.mcpCodexInstallError': 'Операция не выполнена: {error}',
  'settings.mcpRestartNote': 'Перезапустите клиент, чтобы подключить новый сервер.',
  'settings.mcpRestartDetail': 'Большинство редакторов загружают серверы MCP только при запуске. В Cursor / VS Code / Antigravity / Windsurf вместо полного перезапуска можно выполнить `Developer: Reload Window` из палитры команд. Zed и Claude Code требуют выхода и повторного открытия.',
  'settings.mcpCapabilitiesTitle': 'Что может ваш Agent',
  'settings.mcpCapabilityRead': 'Читать или искать любой файл в проекте (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Получать набор данных дизайна одним вызовом: входной файл плюс каждую переменную CSS, компонент и шрифт, на которые он ссылается.',
  'settings.mcpCapabilityDefault': 'По умолчанию использовать проект и файл, открытые в OpenDesign, чтобы можно было сказать «собери это в моём приложении», не уточняя, о каком дизайне идёт речь.',
  'settings.mcpRunningNote': 'Для успешного выполнения вызовов инструментов MCP необходимо, чтобы OpenDesign был запущен. Если вы запустили своего агента для кодинга до открытия OpenDesign, перезапустите агент, чтобы он мог подключиться к работающему демону.',
  'entry.tabDesigns': 'Дизайны',
  'entry.tabTemplates': 'Шаблоны',
  'entry.tabDesignSystems': 'Дизайн-системы',
  'entry.tabConnectors': 'Коннекторы',
  'entry.openSettingsTitle': 'Настройки',
  'entry.openSettingsAria': 'Открыть настройки',
  'entry.discordLabel': 'Присоединиться к Discord',
  'entry.discordAria': 'Присоединиться к Discord-сообществу OpenDesign',
  'entry.discordAriaWithOnline': 'Присоединиться к Discord-сообществу OpenDesign — {online}',
  'entry.discordOnlineLabel': '{count} онлайн',
  'entry.mailAria': 'Написать OpenDesign по электронной почте',
  'entry.accountSettings': 'Настройки',
  'chat.collapsePane': 'Свернуть панель беседы',
  'collabPresence.ariaOne': '1 collaborator online',
  'collabPresence.aria': '{count} collaborators online',
  'collabPresence.ariaWithSelfOne': '1 collaborator online, including you',
  'collabPresence.ariaWithSelf': '{count} collaborators online, including you',
  'collabPresence.moreOnline': '{count} more online',
  'collabPresence.dialogTitle': 'Online collaborators',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'You',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'You are viewing {file}',
  'collabPresence.viewingFileOther': 'Viewing {file}',
  'collabPresence.viewingProjectSelf': 'You are viewing this project',
  'collabPresence.viewingProjectOther': 'Viewing this project',
  'entry.followXLabel': 'Подписаться на @OpenDesignHQ в X',
  'entry.followThreadsLabel': 'Подписаться на OpenDesign в Threads',
  'entry.youtubeLabel': 'OpenDesign на YouTube',
  'entry.followInstagramLabel': 'Подписаться на @opendesign.ai в Instagram',
  'entry.followLinkedinLabel': 'Подписаться на OpenDesign в LinkedIn',
  'entry.followXiaohongshuLabel': 'Подписаться на OpenDesign в Xiaohongshu',
  'entry.resizeAria': 'Изменить размер боковой панели',
  'entry.loadingWorkspace': 'Загрузка рабочего пространства…',
  'entry.useEverywhereTitle': 'Использовать везде',
  'entry.useEverywhereAria': 'Открыть руководство «Использовать везде» (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Команды',
  'workspaceSwitcher.team': 'Team',
  'workspaceSwitcher.invite': 'Invite colleague',
  'workspaceSwitcher.createTeam': 'New team',
  "workspaceSwitcher.draftsTooltip": "Личные проекты",
  "workspaceSwitcher.allProjectsTooltip": "Командные проекты",
  "entry.primaryNavAria": "Primary",
  "entry.billingTierTeam": "Teams",
  "entry.billingTierFree": "Free",
  "entry.billingTierPro": "Pro",
  "entry.billingFamilyCreator": "Creator",
  "entry.upgradeTitle": "Upgrade plan",
  "entry.upgradeCreditsExhaustedTitle": "Credits exhausted",
  "entry.upgradeAutoRechargeTitle": "Auto recharge",
  "entry.upgradeDialogAria": "Upgrade plan",
  "entry.upgradeSubtitle": "Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeCreditsExhaustedSubtitle": "You need more credits to continue. Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeAutoRechargeMemberSubtitle": "Enable a separate allowance for {member}. Saving this setting will not charge immediately; credits refill only when this member falls below the threshold.",
  "entry.upgradeAutoRechargeTeamSubtitle": "Enable an allowance for all teammates. Saving this setting will not charge immediately; team credits refill only when the balance falls below the threshold.",
  "entry.upgradeScopeLabel": "Scope",
  "entry.upgradeScopeMember": "{member} · single-member allowance",
  "entry.upgradeScopeTeam": "All teammates · shared allowance",
  "entry.upgradePaymentHint": "Uses the subscription payment method by default. You can manage it anytime.",
  "entry.upgradeManagePayment": "Manage payment method",
  "entry.upgradeMonthlyLimit": "Monthly limit",
  "entry.upgradeLimitCustom": "",
  "entry.upgradeLimitUnlimited": "∞ unlimited (no monthly cap)",
  "entry.upgradeBillingCycleAria": "Billing cycle",
  "entry.upgradeAnnual": "Annual",
  "entry.upgradeAnnualSave": "Save 20%",
  "entry.upgradeMonthly": "Monthly",
  "entry.upgradePlanPlus": "Personal Plus",
  "entry.upgradePlanPlusDesc": "Basic token allowance · SOTA models",
  "entry.upgradePlanPro": "Personal Pro",
  "entry.upgradePlanProDesc": "3x token allowance · top multimodal models",
  "entry.upgradePlanMax": "Personal Max",
  "entry.upgradePlanMaxDesc": "10x token allowance · top multimodal models",
  "entry.upgradePlanTeam": "Teams",
  "entry.upgradePlanTeamDesc": "Collaboration · shared assets · role permissions",
  "entry.upgradePriceUnitMonth": "/mo",
  "entry.upgradePriceUnitSeat": "/seat/mo",
  "entry.upgradeProrateAnnualPrefix": "Annual billing saves 20%; ",
  "entry.upgradeProrateMonthlyPrefix": "Monthly billing; ",
  "entry.upgradeProrateSuffix": "upgrades are prorated for the current billing cycle and take effect immediately.",
  "entry.upgradeBack": "Back",
  "entry.upgradeAutoRechargeSaved": "Auto recharge settings saved",
  "entry.upgradeConfirm": "Confirm payment and upgrade",
  "entry.creditsAria": "{tier} · credits remaining",
  "entry.creditsAriaWithBalance": "{tier} · {balance} credits remaining",
  "entry.creditsGrantTip": "Teams credits are granted by subscription allowance. Usage is available in billing.",
  "entry.creditsUpgrade": "Upgrade",
  "entry.creditsOpening": "Opening...",
  "entry.creditsRemaining": "Credits remaining",
  "entry.credits": "Лимит",
  "entry.creditsUsage": "View usage",
  "entry.creditsMemberNoticeTitle": "Need more credits?",
  "entry.creditsMemberNoticeBody": "You are currently a Member and cannot add credits yourself. Ask a team Admin to increase the allowance when you need more.",
  "entry.creditsMemberNoticeAction": "Ask Admin to increase allowance",
  "entry.accountToggleTheme": "Toggle theme",
  "entry.accountSwitchLanguage": "Switch language",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "Get help on GitHub",
  "entry.accountFeatureRequest": "Submit feature request",
  "entry.accountAddAccount": "Add account",
  "entry.accountSignOut": "Sign out",
  "signOut.confirmTitle": "Выйти",
  "signOut.confirmMessage": "Вы действительно хотите выйти?",
  "signOut.confirmAction": "Выйти",
  "entry.navRecents": "Главная",
  "entry.navDashboard": "Dashboard",
  "entry.blankDraftsTitle": "Start a private draft",
  "entry.blankDraftsDescription": "Create a project here first. It stays private until you move it into the team space.",
  "entry.blankAllProjectsTitle": "No team projects yet",
  "entry.blankAllProjectsDescription": "Projects shared to the team will appear here for everyone in the workspace.",
  "entry.blankCreate": "New project",
  'entry.workspaceTeamsTitle': 'Workspace для команд — расскажите, что нужно вашей команде',
  'entry.workspaceTeamsAria': 'Открыть страницу Workspace для команд',
  'entry.navExpand': 'Развернуть боковую панель',
  'entry.navCollapse': 'Свернуть боковую панель',
  'entry.navNewProject': 'Новый проект',
  'entry.navHome': 'Главная',
  'entry.navProjects': 'Проекты',
  'entry.navTasks': 'Автоматизации',
  'entry.navPlugins': 'Плагины',
  'entry.navDesignSystems': 'Дизайн-системы',
  'entry.navBrands': 'Бренд-кит',
  'entry.navIntegrations': 'Интеграции',
  'entry.navMembers': 'Members',
  'entry.navWorkspaceSettings': 'Workspace settings',
  'entry.navDrafts': 'Личные проекты',
  'entry.navAllProjects': 'Командные проекты',
  'entry.draftsDescription': 'Projects you created, visible only to you',
  'entry.allProjectsDescription': 'Projects owned by everyone on the team',
  'entry.navBoard': 'Board',
  'entry.navTeamSection': 'Team',
  'entry.teamSlotNote': 'This space is provided by the team service. Integration is in progress.',
  "entry.cloudCalloutTitle": "OpenDesign Cloud",
  'entry.cloudRecovering': 'Account connection interrupted. Recovering automatically…',
  'entry.authExpiredBody': 'Your sign-in has expired. Sign in to continue using OpenDesign Cloud.',
  'home.createFailed': 'Failed to start the run. Try again.',
  'home.daemonRecovering': 'Local service connection interrupted. Recovering automatically…',
  "entry.cloudCalloutBody": "Войдите, чтобы использовать OpenDesign Cloud и работать совместно в облаке",
  "entry.cloudCalloutDismissAria": "Закрыть уведомление OpenDesign Cloud",
  'entry.workspaceLockedNote': 'This workspace is locked. Restore billing to resume editing shared projects.',
  'entry.workspaceLockedRecover': 'Restore access',
  'messageCenter.openAria': 'Open message center',
  'messageCenter.unreadCount': '{count} unread',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'OpenDesign updates, platform announcements, and account notices.',
  'messageCenter.filterAll': 'All',
  'messageCenter.filterUnread': 'Unread',
  'messageCenter.filterRead': 'Read',
  'messageCenter.markAllRead': 'Mark all read',
  'messageCenter.emptyAllTitle': 'No messages yet',
  'messageCenter.emptyUnreadTitle': 'All caught up',
  'messageCenter.emptyReadTitle': 'No read messages',
  'messageCenter.emptyBody': 'New platform messages will appear here.',
  'messageCenter.close': 'Close message center',
  'messageCenter.desktopSettings': 'Desktop notification settings',
  'messageCenter.desktopSettingsHint': 'Task completion sounds and system notifications stay in Settings.',
  'workspaceTabs.project': 'Проект',
  'workspaceTabs.pluginDetails': 'Сведения о плагине',
  'workspaceTabs.marketplace': 'Маркетплейс',
  'homeHero.title': 'Что вы спроектируете сегодня вместе со своим агентом?',
  'homeHero.startWithTemplate': 'Начать с шаблона…',
  'homeHero.startBlankProject': 'создать пустой проект',
  'homeHero.templatePicker.label': 'Тип контента',
  'homeHero.templatePicker.searchPlaceholder': 'Поиск шаблонов',
  'homeHero.templatePicker.projectTypes': 'Типы проектов',
  'homeHero.templatesScrollHint': 'Прокрутите вверх, чтобы увидеть больше шаблонов',
  'homeHero.templatesCollapse': 'Свернуть шаблоны',
  'homeHero.subtitlePrefix': 'Альтернатива Claude Design с доступным исходным кодом.',
  'homeHero.placeholder': 'Опишите, что вы хотите сгенерировать…',
  'homeHero.placeholderActive': 'Измените пример запроса или напишите свой…',
  'homeHero.carousel.hint': 'Прикрепите файл, подключите дизайн-систему или опишите, что хотите создать',
  'homeHero.carousel.onePageBrief': 'Составить одностраничный бриф проекта',
  'homeHero.carousel.notesToDeck': 'Превратить мои заметки в презентацию',
  'homeHero.carousel.signupFlow': 'Сделать макет процесса регистрации',
  'homeHero.carousel.improveBrief': 'Улучшить существующий бриф проекта',
  'homeHero.carousel.loadingAnimation': 'Создать анимацию загрузки',
  'homeHero.carousel.teamUpdateSlides': 'Оформить слайды для отчёта команде',
  'homeHero.carousel.ordersDashboard': 'Сделать прототип дашборда для отслеживания заказов',
  'homeHero.carousel.productDetail': 'Свёрстать страницу товара',
  'homeHero.carousel.caseStudy': 'Набросать кейс-стади',
  'homeHero.carousel.landingIntro': 'Придумать короткое вступление для лендинга',
  'homeHero.carousel.pitchDeck': 'Сделать питч-дек для нового продукта',
  'homeHero.carousel.appIdea': 'Описать идею приложения',
  'homeHero.carousel.landingLayout': 'Набросать макет лендинга',
  'homeHero.skills': 'Навыки',
  'homeHero.addMenu': 'Добавить контекст',
  'homeHero.addPlugin': 'Добавить плагин',
  'homeHero.addConnectors': 'Добавить коннекторы',
  'homeHero.addMcp': 'Добавить сервер MCP',
  'homeHero.noPlugins': 'Нет установленных плагинов',
  'homeHero.noMcp': 'Нет серверов MCP',
  'homeHero.noConnectors': 'Нет подключённых коннекторов',
  'homeHero.applying': 'Применение…',
  'homeHero.pluginTitle': 'Плагин: {title}',
  'homeHero.pluginPrefix': 'Плагин: {title}',
  'homeHero.skillPrefix': 'Навык: {title}',
  'homeHero.removePlugin': 'Удалить плагин',
  'homeHero.removePluginAria': 'Удалить плагин {title}',
  'homeHero.clearActivePlugin': 'Сбросить активный плагин',
  'homeHero.clearActiveSkill': 'Сбросить активный навык',
  'homeHero.contextItemsResolved': 'Разрешено элементов контекста: {n}',
  'homeHero.removeFile': 'Удалить файл',
  'homeHero.contextSearchResults': 'Результаты поиска по контексту',
  'homeHero.contextSurfaces': 'Источники контекста',
  'homeHero.loadingContext': 'Загрузка контекста…',
  'homeHero.noResults': 'Нет результатов по запросу «{query}».',
  'homeHero.searchPrompt': 'Поиск файлов, плагинов, навыков, серверов MCP и коннекторов.',
  'homeHero.parameters': 'Параметров: {n}',
  'homeHero.details': 'Подробнее',
  'homeHero.toRun': 'для запуска',
  'homeHero.forNewLine': 'для новой строки',
  'homeHero.run': 'Запустить',
  'homeHero.typeSomethingToRun': 'Введите что-нибудь для запуска',
  'homeHero.promptExamples': 'Примеры',
  'homeHero.footer.designSystem': 'Стиль',
  'homeHero.footer.autoDesignSystem': 'Авто',
  'homeHero.footer.autoDesignSystemSummary': 'Автоматически подбирает дизайн-систему и визуальный стиль для текущего промпта.',
  'homeHero.footer.ratio': 'Формат',
  'homeHero.footer.duration': 'Длительность',
  'homeHero.footer.resolution': 'Разрешение',
  'homeHero.footer.speakerNotes': 'Заметки',
  'homeHero.footer.noSpeakerNotes': 'Без заметок',
  'homeHero.footer.availableCount': 'Доступно: {n}',
  'homeHero.footer.noMatches': 'Нет совпадений',
  'homeHero.moreShortcuts': 'Еще',
  'homeHero.railAria': 'Выберите категорию проекта или быстрый старт',
  'homeHero.subTypeAria': 'Выберите подтип',
  'homeHero.subTypeMore': 'Ещё',
  'homeHero.confirmReplaceTitle': 'Заменить текущий запрос?',
  'homeHero.confirmReplaceBody': 'Использование {title} заменит текст, который сейчас введён в поле.',
  'homeHero.confirmReplace': 'Заменить',
  'homeHero.chip.prototype': 'Прототип',
  'homeHero.chip.webClone': 'Клон сайта',
  'homeHero.chip.liveArtifact': 'Живой артефакт',
  'homeHero.chip.deck': 'Презентация',
  'homeHero.chip.image': 'Изображение',
  'homeHero.chip.video': 'Видео',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'WebGL',
  'homeHero.chip.webglDesc': 'Шейдеры, 3D и генеративная GPU-графика',
  'homeHero.chip.worker': 'Worker-визуализатор',
  'homeHero.chip.workerDesc': 'Симуляции вне потока, частицы и визуализация данных',
  'homeHero.chip.audio': 'Аудио',
  'homeHero.chip.createBrandKit': 'Создать бренд-кит',
  'homeHero.chip.createPlugin': 'Создать плагин',
  'homeHero.chip.figma': 'Из Figma',
  'homeHero.chip.folder': 'Из папки',
  'homeHero.chip.template': 'Из шаблона',
  'homeHero.chip.liveArtifactHint': 'Создайте интерактивный артефакт HTML/CSS/JS с живым предпросмотром.',
  'homeHero.chip.hyperframesHint': 'Создавайте анимацию на основе HTML: субтитры, реагирующая на звук графика, переходы между сценами.',
  'homeHero.chip.createBrandKitHint': 'Извлеките бренд-кит с веб-сайта и применяйте его в любом чате.',
  'homeHero.chip.createPluginHint': 'Создайте многоразовый плагин OpenDesign и добавьте его в раздел «Мои плагины».',
  'homeHero.chip.figmaHint': 'Перенесите фрейм Figma в активную дизайн-систему.',
  'homeHero.chip.folderHint': 'Импортируйте существующую локальную папку и продолжите редактирование.',
  'homeHero.chip.templateHint': 'Начните со встроенного шаблона.',
  'homeHero.chip.wireframe': 'Вайрфрейм',
  'homeHero.chip.mobile': 'Мобильное приложение',
  'homeHero.chip.document': 'Документ',
  'homeHero.chip.prototypeDesc': 'Интерактивные макеты приложений',
  'homeHero.chip.webCloneDesc': 'Source-first site reproduction',
  'homeHero.chip.wireframeDesc': 'Черновые экраны и пользовательские потоки',
  'homeHero.chip.mobileDesc': 'Экраны iOS и Android',
  'homeHero.chip.deckDesc': 'Презентации и pitch deck',
  'homeHero.chip.documentDesc': 'Резюме, отчеты и PDF',
  'homeHero.chip.imageDesc': 'Постеры, графика и арт',
  'homeHero.chip.videoDesc': 'Клипы, reels и проморолики',
  'homeHero.chip.audioDesc': 'Озвучка, музыка и SFX',
  'homeHero.chip.hyperframesDesc': 'Моушн-графика и циклы',
  'homeHero.chip.liveArtifactDesc': 'Живые дашборды на данных',
  'homeHero.chip.createBrandKitDesc': 'Извлечь бренд-дизайн-систему',
  'homeHero.chip.prototypeNext': 'Откроет чат для создания высокоточного кликабельного веб-прототипа, который можно уточнять шаг за шагом.',
  'homeHero.chip.webCloneNext': 'Open a chat that asks for a target URL, reconstructs the site, and audits the clone.',
  'homeHero.chip.wireframeNext': 'Откроет чат для черновых экранов и потоков, чтобы сначала проверить структуру.',
  'homeHero.chip.mobileNext': 'Откроет чат для проектирования мобильных экранов iOS и Android.',
  'homeHero.chip.deckNext': 'Откроет чат для создания презентации, которую можно показывать и экспортировать.',
  'homeHero.chip.documentNext': 'Откроет чат для подготовки аккуратного документа — резюме, отчета или PDF.',
  'homeHero.chip.imageNext': 'Откроет чат для генерации брендовых изображений с возможностью итераций.',
  'homeHero.chip.videoNext': 'Откроет чат для короткого видео, которое можно дорабатывать.',
  'homeHero.chip.audioNext': 'Откроет чат для озвучки, музыки или звуковых эффектов.',
  'homeHero.chip.webClonePromptSeed': 'Ссылка на сайт для копирования: ',
  'homeWorkingDir.trigger': 'Выбрать рабочую папку',
  'homeWorkingDir.triggerShort': 'Рабочая папка',
  'homeWorkingDir.pick': 'Выбрать папку',
  'homeWorkingDir.replace': 'Сменить рабочую папку',
  'homeWorkingDir.recent': 'Недавние папки',
  'homeWorkingDir.recentEmpty': 'Недавних папок нет',
  'homeWorkingDir.clear': 'Убрать рабочую папку',
  'homeWorkingDir.hint': 'Разрешите агенту читать эту локальную папку (она не импортируется в Design Files)',
  'homeWorkingDir.missing': 'Эта рабочая папка больше не существует — выберите другую',
  'homeWorkingDir.applyFailed': 'Не удалось задать рабочую папку — возможно, она больше не существует',
  'workingDirPicker.title': 'Папка',
  'workingDirPicker.homeTitle': 'Сохраняется в локальном хранилище — нажмите, чтобы выбрать папку',
  'workingDirPicker.processing': 'Обработка…',
  'workingDirPicker.select': 'Локальное хранилище',
  'workingDirPicker.clearAria': 'Очистить рабочий каталог',
  'workingDirPicker.replaceFailed': 'Не удалось заменить рабочий каталог',
  'workingDirPicker.unavailable': 'Выбор папки недоступен в этой сборке. Запустите десктопное приложение, чтобы выбрать папку.',
  'workingDirPicker.openUnavailable': 'Откройте этот проект в десктопном приложении, чтобы показать папку.',
  'workingDirPicker.openFailed': 'Не удалось показать эту папку',
  'workingDirPicker.showInFileManager': 'Показать в файловом менеджере',
  'workingDirPicker.replace': 'Выбрать папку…',
  'workingDirPicker.recent': 'Недавние каталоги',
  'workingDirPicker.defaultLabel': 'Локальное хранилище',
  'handoff.toTarget': 'Передать в {target}',
  'handoff.openInTarget': 'Открыть в {target}',
  'handoff.openAction': 'Открыть',
  'handoff.menuTitle': 'В каком редакторе открыть?',
  'handoff.action': 'Передать',
  'handoff.fallbackTitle': 'Редакторы в $PATH не найдены — откроется в {target}',
  'handoff.chooseTargetAria': 'Выберите цель передачи',
  'handoff.optionsAria': 'Параметры передачи',
  'handoff.editorSection': 'Открыть в редакторе',
  'handoff.cliSection': 'Скопировать для CLI',
  'handoff.clickOpen': 'Нажмите, чтобы открыть',
  'handoff.framework': 'Фреймворк кода',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'чистый JavaScript, HTML и CSS',
  'handoff.amrWebsite': 'Открыть сайт OpenDesign Cloud',
  'handoff.copyPrompt': 'Скопировать запрос',
  'handoff.copyPromptForTarget': 'Скопировать запрос для {target}',
  'handoff.copied': 'Скопировано',
  'handoff.projectPathUnavailable': 'Путь к проекту ещё загружается. Повторите попытку через мгновение.',
  'handoff.copyFailed': 'Запись в буфер обмена заблокирована. Повторите попытку через мгновение.',
  'handoff.promptIntro': 'Продолжить из этой локальной папки проекта OpenDesign:',
  'handoff.promptTarget': 'Цель',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Вы перенимаете работу в {cli}. Пожалуйста:',
  'handoff.promptReadFiles': 'Сначала перейдите в этот каталог или прочитайте его. Отдавайте приоритет DESIGN.md, README, существующим HTML/CSS/JS, ресурсам и package.json, если он есть.',
  'handoff.promptKeepDesign': 'Сохраняйте текущий визуальный дизайн, макет, взаимодействия и ресурсы. Не останавливайтесь на плане.',
  'handoff.promptProduceCode': 'Создавайте или изменяйте реальный работоспособный код {framework}. Если в проекте уже есть более понятный стек, укажите на конфликт и сохраните работоспособность результата.',
  'handoff.promptVerify': 'В завершение сообщите мне команды для запуска, предпросмотра и проверки.',
  'handoff.promptCommandHint': 'Чтобы начать из каталога проекта, используйте:',
  'handoff.promptProject': 'Проект',
  'handoff.promptProjectId': 'ID проекта',
  'handoff.notInstalled': 'Не установлено',
  'handoff.notDetectedTitle': '{target} — не обнаружено в $PATH',
  'designSystemPicker.select': 'Выберите дизайн-систему',
  'designSystemPicker.loading': 'Загрузка дизайн-систем…',
  'designSystemPicker.searchPlaceholder': 'Поиск дизайн-систем (название / категория / описание)',
  'designSystemPicker.searchCompactPlaceholder': 'Поиск дизайн-систем',
  'designSystemPicker.noneTitle': 'Без дизайн-системы',
  'designSystemPicker.noneSummary': 'Позволить модели выбирать свободно',
  'designSystemPicker.empty': 'Подходящих дизайн-систем нет',
  'designSystemPicker.openPreview': 'Открыть предпросмотр',
  'designSystemPicker.loadingPreview': 'Загрузка предпросмотра…',
  'designSystemPicker.noPreview': 'Нет страницы предпросмотра. Откройте «Дизайн-системы», чтобы посмотреть полный предпросмотр.',
  'designSystemPicker.previewHint': 'Наведите курсор на дизайн-систему для предпросмотра',
  'designSystemPicker.fullscreenAria': 'Полноэкранный предпросмотр: {title}',
  'designSystemPicker.closeFullscreen': 'Закрыть полноэкранный предпросмотр',
  'designSystemPicker.closeEsc': 'Закрыть (Esc)',
  'designSystemPicker.previewFrameTitle': 'Предпросмотр: {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Полноэкранный предпросмотр: {title}',
  'recentProjects.title': 'Недавние проекты',
  'recentProjects.viewAll': 'Показать все',
  'recentProjects.empty': 'Пока нет проектов — введите запрос, чтобы начать.',
  'recentProjects.ownerAll': 'All',
  'recentProjects.ownerMine': 'Mine',
  'recentProjects.ownerOthers': 'Others',
  'recentProjects.kindAll': 'Any type',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Other',
  'recentProjects.inviteTeammates': 'Invite teammates',
  'recentProjects.multiSelect': 'Multi-select',
  'recentProjects.sortAria': 'Sort projects',
  'recentProjects.sortNewest': 'Newest first',
  'recentProjects.sortOldest': 'Oldest first',
  'recentProjects.sortName': 'Name',
  'recentProjects.viewList': 'List view',
  'recentProjects.sharedBadge': 'Shared',
  'recentProjects.sharedProjectFallbackName': 'Shared project',
  'recentProjects.creatorLine': 'Created by {name}',
  'recentProjects.selfCreator': 'Me',
  'recentProjects.teamMemberCreator': 'Team member',
  'recentProjects.ownOnlyMutation': 'Only projects you created can be changed or deleted.',
  'recentProjects.shareInProgress': 'Sharing…',
  'recentProjects.sharedInTeam': 'In team space',
  'recentProjects.moveToTeam': 'Move to team space',
  'recentProjects.moveToTeamDescPre': 'Once moved to the team space, ',
  'recentProjects.moveToTeamDescStrong': 'all team members can view and comment',
  'recentProjects.moveToTeamDescPost': ', and only the creator can edit. You can find it under "Team projects".',
  'recentProjects.moveToPersonalDescPre': 'Once moved out of the team space, it returns to a personal project, ',
  'recentProjects.moveToPersonalDescStrong': 'only you can view and edit it',
  'recentProjects.moveToPersonalDescPost': '.',
  'recentProjects.moveDontRemind': 'Don\'t remind me again',
  'recentProjects.confirmMoveToTeam': 'Confirm move',
  'recentProjects.confirmMoveToPersonal': 'Confirm move',
  'recentProjects.unshareInProgress': 'Moving out…',
  'recentProjects.moveOutOfTeam': 'Move out of team space',
  'recentProjects.unshareFailed': 'Could not move out of team space. Try again.',
  'recentProjects.shareFailed': 'Could not move to team space. Try again.',
  'recentProjects.shareOwnerConflict': 'Could not move to team space: another member already shares this project with the team.',
  'recentProjects.clearFilters': 'Сбросить фильтры',
  'pluginsHome.title': 'Сообщество',
  'pluginsHome.subtitle': 'Готовые рабочие процессы OpenDesign, входящие в состав этой среды выполнения. Выберите один, чтобы загрузить стартовый запрос, или просмотрите реестр для дополнительных вариантов.',
  'pluginsHome.browseRegistry': 'Просмотр реестра',
  'pluginsHome.count': '{filtered} из {total}',
  'pluginsHome.loadingCatalog': 'Загрузка каталога…',
  'pluginsHome.emptyCatalog': 'Каталог пуст. Встроенные плагины поставляются вместе с OpenDesign и должны появляться здесь автоматически — если проблема не исчезает, попробуйте перезапустить демон.',
  'pluginsHome.emptyFiltered': 'Нет плагинов, соответствующих текущим фильтрам.',
  'pluginsHome.clearFilters': 'Сбросить фильтры',
  'pluginsHome.modeAria': 'Режим плагина',
  'pluginsHome.featured': 'Сохранено',
  'pluginsHome.totalInCatalog': '{n} в каталоге',
  'pluginsHome.categoryFilterAria': 'Фильтр по категории',
  'pluginsHome.subcategoryFilterAria': 'Фильтр по подкатегории {label}',
  'pluginsHome.allCategory': 'Все: {label}',
  'pluginsHome.searchPlaceholder': 'Поиск плагинов…',
  'pluginsHome.searchAria': 'Поиск плагинов',
  'pluginsHome.clearSearch': 'Очистить поиск',
  'pluginsHome.sortAria': 'Порядок сортировки',
  'pluginsHome.sortHot': 'Популярные',
  'pluginsHome.sortNewest': 'Новые',
  'pluginsHome.facet.import': 'Импорт',
  'pluginsHome.facet.create': 'Создать',
  'pluginsHome.facet.export': 'Экспорт',
  'pluginsHome.facet.share': 'Поделиться',
  'pluginsHome.facet.deploy': 'Развернуть',
  'pluginsHome.facet.refine': 'Доработать',
  'pluginsHome.facet.extend': 'Расширить',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Код / папка',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Скриншот',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Слайды',
  'pluginsHome.facet.publicLink': 'Публичная ссылка',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Дашборды',
  'pluginsHome.subfacet.app-prototypes': 'Приложения',
  'pluginsHome.subfacet.landing-marketing': 'Лендинги / маркетинг',
  'pluginsHome.subfacet.developer-tools': 'Инструменты разработчика',
  'pluginsHome.subfacet.docs-reports': 'Документы / отчёты',
  'pluginsHome.subfacet.brand-design': 'Бренд / дизайн',
  'pluginsHome.subfacet.pitch-business': 'Питч / бизнес',
  'pluginsHome.subfacet.course-training': 'Курсы / обучение',
  'pluginsHome.subfacet.reports-briefings': 'Отчёты / брифинги',
  'pluginsHome.subfacet.product-sales': 'Продукт / продажи',
  'pluginsHome.subfacet.engineering-talks': 'Технические доклады',
  'pluginsHome.subfacet.creative-decks': 'Креативные презентации',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / мокапы',
  'pluginsHome.subfacet.brand-visuals': 'Бренд / логотип',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Раскадровки',
  'pluginsHome.subfacet.social-content': 'Соцсети / контент',
  'pluginsHome.subfacet.avatar-portrait': 'Аватар / портрет',
  'pluginsHome.subfacet.illustration-style': 'Иллюстрация / стиль',
  'pluginsHome.subfacet.motion-effects': 'Моушн / эффекты',
  'pluginsHome.subfacet.social-short-form': 'Соцсети / короткие видео',
  'pluginsHome.subfacet.marketing-product': 'Маркетинг / продукт',
  'pluginsHome.subfacet.data-explainers': 'Данные / объяснения',
  'pluginsHome.subfacet.cinematic-story': 'Кино / истории',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'Просматривайте установленные рабочие процессы, изучайте записи реестра, управляйте источниками и подготавливайте плагины для распространения в команде.',
  'pluginsView.importPlugin': 'Импортировать плагин',
  'pluginsView.agentContext': 'Контекст Agent',
  'pluginsView.summaryAria': 'Сводка по плагину',
  'pluginsView.areasAria': 'Области плагина',
  'pluginsView.loading': 'Загрузка плагинов…',
  'pluginsView.tab.installed': 'Установлено',
  'pluginsView.tab.available': 'Доступно',
  'pluginsView.tab.sources': 'Источники',
  'pluginsView.tab.team': 'Команда',
  'pluginsView.tabHint.installed': 'Ваши плагины',
  'pluginsView.tabHint.available': 'Из источников',
  'pluginsView.tabHint.sources': 'Каталоги',
  'pluginsView.tabHint.team': 'Корпоративные',
  'pluginsView.installedTitle': 'Установленные плагины',
  'pluginsView.installedSubtitle': 'Плагины, которые вы импортировали или установили из источников маркетплейса.',
  'pluginsView.installedEmpty': 'Пока нет установленных пользовательских плагинов. Воспользуйтесь действием «Создать / Импорт» или установите запись из раздела «Доступно».',
  'pluginsView.availableTitle': 'Доступно из источников',
  'pluginsView.availableSubtitle': 'Записи каталога, найденные в настроенных маркетплейсах.',
  'pluginsView.availableFiltersAria': 'Фильтры доступных плагинов',
  'pluginsView.searchAvailableAria': 'Поиск доступных плагинов',
  'pluginsView.searchAvailablePlaceholder': 'Поиск доступных плагинов',
  'pluginsView.clearAvailableSearch': 'Очистить поиск доступных плагинов',
  'pluginsView.source': 'Источник',
  'pluginsView.availableEmptyInstalled': 'Пока нет доступных записей. Установленные записи каталога удаляются из раздела «Доступно»; удалите одну из них, чтобы она снова стала доступной.',
  'pluginsView.availableEmptyFiltered': 'Нет доступных записей, соответствующих вашим фильтрам.',
  'pluginsView.availableEmptyNoSources': 'Пока нет доступных записей. Добавьте источник на вкладке «Источники».',
  'pluginsView.installing': 'Установка…',
  'pluginsView.installWaiting': 'Ожидание…',
  'pluginsView.installQueuedHint': 'Сейчас устанавливается другой плагин. Установки выполняются по одной — кнопка станет доступна после завершения.',
  'pluginsView.install': 'Установить',
  'pluginsView.sourcesTitle': 'Источники реестра',
  'pluginsView.sourcesSubtitle': 'Каталоги маркетплейса, из которых формируются доступные плагины.',
  'pluginsView.sourceUrl': 'URL источника',
  'pluginsView.defaultTrust': 'Уровень доверия по умолчанию',
  'pluginsView.trust.restricted': 'Ограниченный',
  'pluginsView.trust.trusted': 'Доверенный',
  'pluginsView.trust.official': 'Официальный',
  'pluginsView.adding': 'Добавление…',
  'pluginsView.addSource': 'Добавить источник',
  'pluginsView.sourcesEmpty': 'Источники реестра ещё не настроены.',
  'pluginsView.pluginsCount': 'Плагинов: {n}',
  'pluginsView.catalogVersion': 'каталог v{version}',
  'pluginsView.trustFor': 'Доверие для {name}',
  'pluginsView.refreshing': 'Обновление…',
  'pluginsView.removing': 'Удаление…',
  "pluginsView.marketplaceTitle": "Extensions",
  "pluginsView.marketplaceBody": "Install expert suites, skills, and connectors to add new work capabilities to OpenDesign.",
  "pluginsView.marketplaceModeAria": "Marketplace mode",
  "pluginsView.marketplaceSourceFiltersAria": "Marketplace source filters",
  "pluginsView.scope.official": "OpenDesign official",
  "pluginsView.scope.team": "Team",
  "pluginsView.scope.personal": "Personal",
  "pluginsView.kind.plugins": "Expert suites",
  "pluginsView.kind.skills": "Skills",
  "pluginsView.searchPlugins": "Search expert suites",
  "pluginsView.searchSkills": "Search skills",
  "pluginsView.modeNote.plugins": "Expert suites are role- and industry-focused toolkits. Type @ or slash in the composer to use them.",
  "pluginsView.modeNote.skills": "Skills are reusable task workflows and review rules. Use them directly or compose them into expert suites.",
  "pluginsView.create": "Add",
  "pluginsView.createTitle": "Add {kind}",
  "pluginsView.createWithAgent": "Describe it and let the agent build it",
  "pluginsView.createWithAgentBody": "Start from a prompt in the home composer instead of importing an existing extension.",
  "pluginsView.createWithAgentAction": "Start from a prompt",
  "pluginsView.createPluginBody": "Import a plugin from GitHub or a local folder, then upload it for team use.",
  "pluginsView.createSkillBody": "Create a reusable task workflow or review rule that can later be reused by plugins.",
  "pluginsView.createClose": "Close add panel",
  "pluginsView.createTypeAria": "Create type",
  "pluginsView.importFromUrl": "Import from link",
  "pluginsView.importUrlBody": "Paste a public link for a {kind}. OpenDesign will fetch the manifest, validate capabilities, and upload it to the team space.",
  "pluginsView.uploadFolder": "Upload local folder",
  "pluginsView.uploadFolderBody": "Choose a local folder containing {manifest}. After validation, it will upload as a team {kind}.",
  "pluginsView.importing": "Importing…",
  "pluginsView.importAndUpload": "Import and upload",
  "pluginsView.uploading": "Uploading…",
  "pluginsView.uploadKind": "Upload {kind}",
  "pluginsView.filesSelected": "{count} files selected",
  "pluginsView.chooseFolder": "Choose folder",
  "pluginsView.emptyNoMatchTitle": "No matching results",
  "pluginsView.emptyNoMatchHint": "Try another keyword.",
  "pluginsView.emptyTeamTitle": "No content shared to the team yet",
  "pluginsView.emptyTeamHint": "Share expert suites or skills from Personal to Team, and they will appear here.",
  "pluginsView.emptyPersonalPluginsTitle": "No personal expert suites yet",
  "pluginsView.emptyPersonalSkillsTitle": "No personal skills yet",
  "pluginsView.emptyPersonalHint": "Install from OpenDesign official, or use Add in the top right to create one.",
  "pluginsView.emptyOfficialPluginsTitle": "No official expert suites available",
  "pluginsView.emptyOfficialSkillsTitle": "No official skills available",
  "pluginsView.emptyOfficialHint": "Check back later, or add a marketplace in plugin sources.",
  "pluginsView.teamSharedBadge": "Shared with team",
  "pluginsView.tryIt": "Try it",
  "pluginsView.categoriesAria": "Categories",
  "pluginsView.statSkills": "{count} skills",
  "pluginsView.statConnectors": "{count} connectors",
  "pluginsView.uninstall": "Uninstall",
  "pluginsView.uninstalling": "Uninstalling…",
  "pluginsView.uninstallConfirm": "Uninstall {title}?",
  "pluginsView.uninstallSuccess": "Uninstalled {title}",
  "pluginsView.uninstallFailed": "Could not uninstall {title}",
  "pluginsView.sharing": "Sharing…",
  "pluginsView.unsharing": "Removing…",
  "pluginsView.shareToTeam": "Share with team",
  "pluginsView.syncToTeam": "Синхронизировать с командой",
  "pluginsView.unshareFromTeam": "Remove from team",
  "pluginsView.moreActions": "{title} more actions",
  "pluginsView.skillUrlUnsupported": "Skills do not support import from link yet. Use Upload local folder instead.",
  "pluginsView.importPluginSuccess": "Imported and uploaded expert suite",
  "pluginsView.importFailed": "Import failed. Check the link and try again.",
  "pluginsView.uploadPluginSuccess": "Uploaded expert suite",
  "pluginsView.uploadFailed": "Upload failed. Check the folder contents.",
  "pluginsView.importSkillSuccess": "Imported Skill \"{name}\". You can share it with the team from Personal.",
  "pluginsView.shareSuccess": "Shared \"{title}\" with the team. Teammates can now use it.",
  "pluginsView.shareUnavailable": "Could not share \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.shareFailed": "Failed to share \"{title}\". Try again later.",
  "pluginsView.syncSuccess": "Последняя версия \"{title}\" синхронизирована с командой.",
  "pluginsView.syncUnavailable": "Пока не удалось синхронизировать \"{title}\". Убедитесь, что вы находитесь в командном рабочем пространстве.",
  "pluginsView.syncFailed": "Не удалось синхронизировать \"{title}\" с командой. Повторите попытку позже.",
  "pluginsView.unshareSuccess": "Removed \"{title}\" from team sharing.",
  "pluginsView.unshareUnavailable": "Could not remove \"{title}\" from team sharing. Confirm you have permission.",
  "pluginsView.unshareFailed": "Failed to remove \"{title}\" from team sharing. Try again later.",
  "pluginsView.installSuccess": "Installed \"{title}\"",
  "pluginsView.installFailed": "Failed to install \"{title}\"",
  "pluginsView.skillMissingFile": "No SKILL.md was found in the selected folder.",
  "pluginsView.skillReadFailed": "Could not read SKILL.md. Try again.",
  "pluginsView.skillMissingName": "SKILL.md is missing a name field.",
  "pluginsView.skillEmptyBody": "SKILL.md content is empty.",
  'pluginsView.teamTitle': 'Частные командные маркетплейсы',
  'pluginsView.teamBody': 'Этот раздел зарезервирован для корпоративных и командных каталогов, частных политик доверия и общих средств управления жизненным циклом плагинов.',
  'pluginCard.details': 'Подробности',
  'pluginCard.use': 'Использовать',
  'pluginCard.useWithQuery': 'Использовать с запросом',
  'pluginCard.applying': 'Применение…',
  'pluginCard.duplicate': 'Ремикс',
  'pluginCard.duplicating': 'Создание remix…',
  'pluginCard.duplicateFailed': 'Не удалось сделать ремикс этого шаблона.',
  'pluginCard.saved': 'Сохранено',
  'pluginCard.publish': 'Опубликовать',
  'pluginCard.contribute': 'Внести вклад',
  'pluginCard.starting': 'Запуск…',
  'pluginCard.detailsAria': 'Посмотреть подробности для {title}',
  'pluginCard.chooseUseAria': 'Выберите способ использования {title}',
  'pluginCard.useOptionsAria': 'Параметры использования для {title}',
  'pluginCard.duplicateAria': 'Сделать ремикс {title} как новый проект',
  'pluginCard.saveAria': 'Сохранить {title}',
  'pluginCard.savedAria': '{title} сохранено',
  'pluginCard.shareAria': 'Поделиться {title}',
  'pluginCard.publishAria': 'Опубликовать {title} как репозиторий GitHub',
  'pluginCard.publishTitle': 'Опубликовать плагин как репозиторий GitHub',
  'pluginCard.contributeAria': 'Внести {title} в OpenDesign',
  'pluginCard.contributeTitle': 'Внести плагин в OpenDesign через pull request',
  'skillPluginCandidate.createForMe': 'Создать плагин/шаблон',
  'skillPluginCandidate.contributeToMain': 'Внести вклад в open-design',
  'skillPluginCandidate.repoDescription': 'Похоже, этот репозиторий может работать как плагин.',
  'integrations.kicker': 'Интеграция',
  'integrations.lede': 'Подключайте внешние системы, добавляйте инструменты MCP в цикл работы вашего агента и используйте OpenDesign из других IDE, скриптов и средств автоматизации.',
  'integrations.agentReady': 'Готово для агента',
  'integrations.areasAria': 'Области интеграции',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Навыки',
  'integrations.tabHint.mcp': 'Внешние инструменты',
  'integrations.tabHint.connectors': 'Учётные записи и API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Интеграции навыков',
  'integrations.skillsBody': 'Управление интеграцией на уровне навыков переносится из другой ветки. Эта вкладка зарезервирована, чтобы настройка MCP, коннекторов и будущих навыков находилась в одном маршруте Интеграции.',
  'mcpClient.title': 'Внешние серверы MCP',
  'mcpClient.subtitle': 'Сторонние инструменты для вашего агента-программиста.',
  'mcpClient.addServer': 'Добавить сервер',
  'mcpClient.emptyTitle': 'Серверы MCP не настроены.',
  'mcpClient.emptyBody': 'Нажмите «Add server», чтобы начать — выберите шаблон (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) или настройте собственный stdio / HTTP-сервер.',
  'mcpClient.saveChanges': 'Сохранить изменения',
  'mcpClient.storedAt': 'Хранится в',
  'mcpClient.daemonError': 'Не удалось подключиться к локальному демону. Убедитесь, что OpenDesign запущен, затем снова откройте эту панель.',
  'mcpClient.saveFailed': 'Не удалось сохранить. Убедитесь, что демон запущен, и повторите попытку.',
  'useEverywhere.modalAria': 'Используйте OpenDesign везде',
  'useEverywhere.modalTitle': 'Используйте OpenDesign везде',
  'useEverywhere.modalSubtitle': 'Подключайте OpenDesign к любой IDE, агенту или скрипту — CLI, HTTP, MCP и Skills. Используйте «Copy guide for an agent» и вставьте в Claude Code, Codex, Cursor, openclaw или hermes, чтобы настроить всё.',
  'useEverywhere.closeAria': 'Закрыть «использовать везде»',
  'useEverywhere.closeTitle': 'Закрыть (Esc)',
  'useEverywhere.tabsAria': 'Точки интеграции',
  'useEverywhere.footStrong': 'Передача в один клик.',
  'useEverywhere.footBody': 'Копирует структурированное руководство в формате markdown, с которым ваш агент может сразу работать — установить, проверить и использовать.',
  'useEverywhere.configureMcp': 'Настроить сервер MCP',
  'useEverywhere.copyGuide': 'Скопировать руководство для агента',
  'useEverywhere.copy': 'Копировать',
  'useEverywhere.copied': 'Скопировано',
  'useEverywhere.copyFailed': 'Не удалось скопировать',
  'useEverywhere.copySnippetAria': 'Скопировать фрагмент: {label}',
  'useEverywhere.section.overview.tab': 'Обзор',
  'useEverywhere.section.overview.heading': 'OpenDesign работает везде, где работает ваш Agent',
  'useEverywhere.section.overview.intro': 'OpenDesign — это больше, чем окно: это локальный привилегированный демон (`od`) плюс реестр Skills + Design-Systems + Atoms. Как только он запущен на вашей машине, любой код-агент (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, ваш собственный скрипт) может управлять генерациями, инспектировать проекты и создавать дизайн-артефакты через четыре взаимозаменяемые поверхности.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` для headless-скриптов, CI и автоматизации в shell.',
  'useEverywhere.section.overview.bullet2': 'MCP-сервер — подключает OpenDesign как сервер Model Context Protocol, чтобы любой агент с поддержкой MCP мог получать список навыков, запускать сценарии и читать артефакты.',
  'useEverywhere.section.overview.bullet3': 'HTTP API — REST- и SSE-эндпоинты `http://127.0.0.1:7456/api/*`; та же поверхность, что использует веб-интерфейс.',
  'useEverywhere.section.overview.bullet4': 'Skills — готовые к использованию пакеты `SKILL.md` (совместимые с Claude), которые любой агент, уже находящийся в вашем PATH, может вызвать вообще без OpenDesign.',
  'useEverywhere.section.overview.bullet5': 'Стандартные артефакты — создавайте реальные HTML-проекты из Skills, встроенных плагинов по умолчанию и примеров плагинов сообщества ещё до запуска демона.',
  'useEverywhere.section.overview.snippet1': 'Запустите демон (и веб-интерфейс) локально',
  'useEverywhere.section.overview.snippet2': 'Убедитесь, что он доступен',
  'useEverywhere.section.overview.snippet3': 'Загрузите стандартные артефакты перед запуском',
  'useEverywhere.section.overview.footer': 'По умолчанию демон пишет в `./.od/` (локально для проекта). Установите `OD_DATA_DIR=~/.open-design`, чтобы использовать общие данные между проектами.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Управляйте OpenDesign из любой оболочки',
  'useEverywhere.section.cli.intro': 'Исполняемый файл `od` поставляется вместе с демоном и является тем же бинарником, который используют Claude Code / Codex при запуске генерации. Большинство подкоманд — это лёгкие клиенты, отправляющие POST-запросы локальному демону, поэтому они работают одинаково независимо от того, запустили ли вы его через `pnpm tools-dev` или как упакованное приложение.',
  'useEverywhere.section.cli.bullet1': '`od` (без аргументов) — запускает демон и открывает веб-интерфейс.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — создаёт байты изображения / видео / аудио через единый медиа-протокол.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — запускает выполнение проекта на основе промпта + навыка.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — устанавливает и применяет плагины сообщества.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — показывает, что доступно локально.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — проверяет состояние демона и обнаруживает CLI агентов в вашем PATH.',
  'useEverywhere.section.cli.snippet1': 'Сгенерировать изображение (делегируется настроенному медиа-провайдеру)',
  'useEverywhere.section.cli.snippet2': 'Запустить сценарный плагин в фоновом режиме и передавать события в виде строк JSON',
  'useEverywhere.section.cli.snippet3': 'Инвентаризация доступных локально навыков и дизайн-систем',
  'useEverywhere.section.cli.snippet4': 'Проверить начальные артефакты через CLI',
  'useEverywhere.section.cli.snippet5': 'Проверить окружение + обнаруженные агенты (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Все подкоманды принимают `--daemon-url http://127.0.0.1:<port>` для обращения к конкретному запущенному демону — полезно при запуске второго экземпляра в песочнице для тестов.',
  'useEverywhere.section.mcp.tab': 'Сервер MCP',
  'useEverywhere.section.mcp.heading': 'Предоставьте OpenDesign как сервер MCP любому кодовому Agent',
  'useEverywhere.section.mcp.intro': 'OpenDesign поставляется с сервером Model Context Protocol (`od mcp`), который позволяет любому клиенту с поддержкой MCP — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — обнаруживать инструменты OpenDesign (получать список навыков, отображать предпросмотры, генерировать медиа, запускать плагины) без ручного вызова через shell. Демон публикует готовый к вставке фрагмент установки через `GET /api/mcp/install-info` для каждого основного клиента.',
  'useEverywhere.section.mcp.bullet1': 'Транспорт stdio — без дополнительного порта, клиент запускает `od mcp` напрямую.',
  'useEverywhere.section.mcp.bullet2': 'Автоматически определяет URL активного демона через локальный сокет статуса IPC при запуске в качестве sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Возвращается к `--daemon-url http://127.0.0.1:<port>` для обычных установок, чтобы процесс MCP всегда находил запущенный демон.',
  'useEverywhere.section.mcp.bullet4': 'Закрепляет `OD_DATA_DIR`, чтобы порождённый процесс MCP писал туда же, куда уже пишет демон (позволяет избежать EPERM в упакованных бандлах приложений macOS).',
  'useEverywhere.section.mcp.snippet1': 'Общая конфигурация MCP-клиента (работает в Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Или: запросите у демона фрагмент, адаптированный под вашу установку',
  'useEverywhere.section.mcp.snippet3': 'Вариант MCP с активными артефактами (чтение и обновление панелей)',
  'useEverywhere.section.mcp.footer': 'В приложении OpenDesign откройте Settings → Integrations, чтобы скопировать команду установки для конкретного клиента (Cursor, Claude Code, Antigravity, VS Code) вместо ручного редактирования JSON.',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'Тот же интерфейс REST + SSE, который использует веб-интерфейс',
  'useEverywhere.section.http.intro': 'Локальный демон предоставляет HTTP API по адресу `http://127.0.0.1:7456` (порт настраивается). Любая конечная точка, которую вызывает веб-интерфейс, доступна и для ваших скриптов. Потоковые конечные точки (ходы чата, запуски проектов) отправляют события Server-Sent Events с типами контракта из `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — проверка работоспособности демона.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` и `GET /api/design-systems` — доступные реестры.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` и `POST /api/projects` — список и создание проектов (POST возвращает проект + первый диалог).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — SSE-поток событий агента для диалога.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — привязывает установленный плагин и возвращает его готовый пример запроса + входные данные.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — обнаруженные CLI код-агентов в вашем PATH.',
  'useEverywhere.section.http.snippet1': 'Список установленных навыков (Agent будет использовать их как шаблоны)',
  'useEverywhere.section.http.snippet2': 'Создать проект из промпта (полный серверный процесс)',
  'useEverywhere.section.http.snippet3': 'Стриминг хода чата (SSE — каждая строка совместима с JSON-Lines)',
  'useEverywhere.section.http.footer': 'Чистые типы TypeScript для каждого запроса/ответа находятся в `@open-design/contracts` — импортируйте их в свой скрипт для полного автодополнения без настройки генератора.',
  'useEverywhere.section.skills.tab': 'Навыки и фоновый режим',
  'useEverywhere.section.skills.heading': 'Готовые к использованию Skills для любого агента — даже без запущенного OpenDesign',
  'useEverywhere.section.skills.intro': 'Skill — это директория с совместимым с Claude файлом `SKILL.md` (YAML-фронтматтер + тело). OpenDesign расширяет формат пространством имён `od:` (`mode`, `preview`, `design_system`, `inputs`, …), чтобы один и тот же артефакт можно было использовать как внутри OpenDesign, так и обычным агентом, например Claude Code, Codex, openclaw или hermes. Обнаружение следует цепочке приоритетов, поэтому проекты могут переопределять свои собственные навыки.',
  'useEverywhere.section.skills.bullet1': 'Обнаружение: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (приоритет у проекта).',
  'useEverywhere.section.skills.bullet2': 'Создайте символическую ссылку на один навык в нескольких проектах, чтобы делиться им без копирования.',
  'useEverywhere.section.skills.bullet3': 'Каждый навык может объявлять коннекторы, атомы, требования к дизайн-системе и пример вывода `preview` для галереи.',
  'useEverywhere.section.skills.bullet4': 'Фоновый режим: Agent с `od` в своём PATH может вызвать `od skills list`, а затем запустить любой навык; для операций только на чтение демон необязателен.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` отрабатывает ту же структуру артефактов на примерах плагинов по умолчанию и примерах плагинов сообщества, а затем сохраняет полученные проекты `index.html` как переиспользуемые тестовые данные.',
  'useEverywhere.section.skills.snippet1': 'Минимальный SKILL.md (совместимый с Claude front matter + дополнения OpenDesign)',
  'useEverywhere.section.skills.snippet2': 'Создать символическую ссылку на общий навык в проекте (в стиле cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Фоновый режим: список навыков, которые демон видит прямо сейчас',
  'useEverywhere.section.skills.snippet4': 'Набор фикстур артефактов для фонового режима',
  'useEverywhere.section.skills.footer': 'Спецификация: `docs/skills-protocol.md` и `docs/agent-adapters.md` охватывают весь интерфейс адаптеров (Claude Code, Codex, Cursor, Agent с поддержкой MCP, резервный вариант BYOK API) и стратегии внедрения навыков для каждого адаптера.',
  'tasks.kicker': 'Рабочее пространство автоматизации',
  'tasks.comingSoon': 'Скоро',
  'tasks.lede': 'Автоматизации превращают промпты в устойчивую работу: Orbit запускает их, рутины сохраняют их, расписания решают, когда они срабатывают, а активные артефакты показывают, что изменилось.',
  'tasks.newAutomation': 'Новая автоматизация',
  'tasks.previewNote': 'Только предпросмотр интерфейса. Настройки Orbit доступны уже сегодня; рутины, расписания и связка с активными артефактами появятся по мере слияния серверных веток.',
  'tasks.primitivesAria': 'Примитивы автоматизации',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Постоянная среда выполнения для долгосрочной или повторяющейся работы Agent.',
  'tasks.primitive.orbit.enabled': 'Ежедневная сводка включена',
  'tasks.primitive.orbit.manualOnly': 'Только вручную',
  'tasks.primitive.routines.title': 'Рутины',
  'tasks.primitive.routines.body': 'Устойчивые определения задач, которые сохраняются после завершения отдельного чата.',
  'tasks.primitive.routines.meta': 'Оболочка продукта готова',
  'tasks.primitive.schedules.title': 'Расписания',
  'tasks.primitive.schedules.body': 'Триггеры по времени или событиям, которые решают, когда должна запуститься рутина.',
  'tasks.primitive.schedules.meta': 'Ветка в ожидании',
  'tasks.primitive.liveArtifacts.title': 'Активные артефакты',
  'tasks.primitive.liveArtifacts.body': 'Отчёты и заметки, которые продолжают обновляться, пока работает Agent.',
  'tasks.primitive.liveArtifacts.meta': 'Модель предпросмотра',
  'tasks.listAria': 'Список автоматизаций',
  'tasks.routinesAndRuns': '{n} рутин и запусков',
  'tasks.filtersAria': 'Фильтры автоматизаций',
  'tasks.filter.scheduled': 'По расписанию',
  'tasks.filter.running': 'Выполняется',
  'tasks.filter.done': 'Готово',
  'tasks.configurationAria': 'Настройка автоматизации',
  'tasks.slot.trigger': 'Триггер',
  'tasks.slot.pattern': 'Шаблон',
  'tasks.slot.runtime': 'Среда выполнения',
  'tasks.slot.output': 'Результат',
  'tasks.liveArtifact': 'Живой артефакт',
  'tasks.viewProgress': 'Посмотреть прогресс',
  'tasks.pause': 'Пауза',
  'tasks.runNow': 'Запустить сейчас',
  'tasks.openArtifact': 'Открыть артефакт',
  'tasks.status.dailyAt': 'Ежедневно · {time}',
  'tasks.status.pausedManual': 'Приостановлено · только вручную',
  'tasks.sample.orbit.title': 'Сводка коннектора Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'Дайджест коннектора запланирован',
  'tasks.sample.orbit.metaDisabled': 'Откройте настройки Orbit, чтобы включить',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · живой артефакт',
  'tasks.sample.orbit.previewDisabled': 'Нет запланированных запусков',
  'tasks.sample.orbit.triggerEnabled': 'Расписание · ежедневно в {time}',
  'tasks.sample.orbit.triggerDisabled': 'Вручную · запуск по требованию',
  'tasks.sample.orbit.pattern': 'Рутина · дайджест коннекторов',
  'tasks.sample.orbit.runtime': 'Orbit · по расписанию демона',
  'tasks.sample.orbit.output': 'Живой артефакт · обновляемый отчёт',
  'tasks.sample.orbit.artifactMetaEnabled': 'Обновляется после каждого запуска',
  'tasks.sample.orbit.artifactMetaDisabled': 'Ожидание расписания',
  'tasks.sample.orbit.body1': '# Сводка активности Orbit Daily',
  'tasks.sample.orbit.body2': 'Коннекторы проверены · успехи, пропуски и сбои',
  'tasks.sample.orbit.body3': 'Ключевые моменты становятся обновляемым живым артефактом.',
  'tasks.sample.mcp.title': 'Исследование альтернатив MCP',
  'tasks.sample.mcp.status': 'Выполняется в orbit · 2 ч 14 мин',
  'tasks.sample.mcp.meta': 'Обработано источников: 14 / 30',
  'tasks.sample.mcp.preview': 'research_notes.md · живой',
  'tasks.sample.mcp.trigger': 'Вручную · однократно',
  'tasks.sample.mcp.pattern': 'Запрос для глубокого исследования',
  'tasks.sample.mcp.runtime': 'Удалённо · постоянно',
  'tasks.sample.mcp.output': 'Живой отчёт · автообновление',
  'tasks.sample.mcp.artifactMeta': 'Обновлено 12 с назад',
  'tasks.sample.mcp.body1': '# Альтернативы MCP — промежуточные результаты',
  'tasks.sample.mcp.body2': 'Изучено 14 источников · отобрано 3 претендента',
  'tasks.sample.mcp.body3': '## Краткий список',
  'tasks.sample.mcp.body4': '- Схемы вызова инструментов через JSON-RPC...',
  'tasks.sample.mcp.body5': '- Протоколы агентов на основе gRPC...',
  'tasks.sample.weekly.title': 'Еженедельный дайджест команды',
  'tasks.sample.weekly.status': 'Далее: пн, 9:00',
  'tasks.sample.weekly.meta': 'Обновляет еженедельный документ команды',
  'tasks.sample.weekly.preview': 'team_weekly.md · следующий артефакт',
  'tasks.sample.weekly.trigger': 'Расписание · еженедельно',
  'tasks.sample.weekly.pattern': 'Рутина · командный дайджест',
  'tasks.sample.weekly.runtime': 'Удалённо · повторяющееся',
  'tasks.sample.weekly.output': 'Активный артефакт · markdown',
  'tasks.sample.weekly.artifactMeta': 'Обновлено 4 дн назад',
  'tasks.sample.weekly.body1': '# Итоги недели команды',
  'tasks.sample.weekly.body2': '## В работе',
  'tasks.sample.weekly.body3': '- Этап интеграции дизайн-системы',
  'tasks.sample.weekly.body4': '- Проверка качества коннекторов',
  'tasks.sample.weekly.body5': '## Риски',
  'tasks.sample.pr.title': 'Напоминание о ревью PR',
  'tasks.sample.pr.status': 'При новом PR · запущено 23 мин назад',
  'tasks.sample.pr.meta': 'Отправляет личное сообщение в Slack',
  'tasks.sample.pr.preview': 'Последняя доставка выполнена успешно',
  'tasks.sample.pr.trigger': 'Событие · новый PR',
  'tasks.sample.pr.pattern': 'Рутина · уведомление',
  'tasks.sample.pr.runtime': 'Локально · быстрый запуск',
  'tasks.sample.pr.output': 'Сообщение · личка в Slack',
  'tasks.sample.pr.artifactMeta': 'Последний запуск 23 мин назад',
  'tasks.sample.pr.body1': 'Открыт PR #184 для ревью',
  'tasks.sample.pr.body2': 'Подобранные ревьюеры: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Доставка: личное сообщение в Slack отправлено',
  'tasks.sample.meeting.title': 'Подготовка к встрече',
  'tasks.sample.meeting.status': 'Завтра · 10:00',
  'tasks.sample.meeting.meta': 'Разовый запуск · отправляет сводку',
  'tasks.sample.meeting.preview': 'meeting_brief.md · в очереди',
  'tasks.sample.meeting.trigger': 'Расписание · разовый запуск',
  'tasks.sample.meeting.pattern': 'Запрос для брифинга',
  'tasks.sample.meeting.runtime': 'Удалённо · ограниченный',
  'tasks.sample.meeting.output': 'Артефакт + сообщение',
  'tasks.sample.meeting.artifactMeta': 'В очереди на генерацию',
  'tasks.sample.meeting.body1': '# Бриф встречи',
  'tasks.sample.meeting.body2': 'Источник повестки: событие календаря + связанные документы',
  'tasks.sample.meeting.body3': 'Результат будет включать решения, блокеры и вопросы.',
  'tasks.sample.candidate.title': 'Отслеживание кандидатов',
  'tasks.sample.candidate.status': 'Сбой · требует внимания',
  'tasks.sample.candidate.meta': 'Срок авторизации истёк',
  'tasks.sample.candidate.preview': 'Переподключите Greenhouse, чтобы продолжить',
  'tasks.sample.candidate.trigger': 'Расписание · ежедневно',
  'tasks.sample.candidate.pattern': 'Рутина · синхронизация кандидатов',
  'tasks.sample.candidate.runtime': 'Удалённо · повторяющийся',
  'tasks.sample.candidate.output': 'Активный артефакт · таблица',
  'tasks.sample.candidate.artifactMeta': 'Приостановлено до восстановления авторизации',
  'tasks.sample.candidate.body1': '# Пайплайн кандидатов',
  'tasks.sample.candidate.body2': 'Последняя успешная синхронизация: 2 дн назад',
  'tasks.sample.candidate.body3': 'Требуется действие: переподключите учётную запись источника.',
  'routines.title': 'Автоматизации',
  'routines.subtitle': 'Запланированные автоматизации, работающие без участия пользователя.',
  'routines.newAutomation': 'Новая автоматизация',
  'routines.loading': 'Загрузка…',
  'routines.empty': 'Автоматизаций пока нет.',
  'routines.emptyHint': 'Нажмите «Новая автоматизация», чтобы запланировать автономный запуск Agent.',
  'routines.runHistoryLoading': 'Загрузка запусков…',
  'routines.runHistoryEmpty': 'Запусков пока нет.',
  'routines.fieldName': 'Название',
  'routines.fieldNamePlaceholder': 'Утренняя сводка',
  'routines.fieldPrompt': 'Запрос',
  'routines.fieldPromptPlaceholder': 'Собрать вчерашнюю активность в GitHub и Linear и обобщить изменения.',
  'routines.fieldSchedule': 'Расписание',
  'routines.fieldMinute': 'Минута каждого часа',
  'routines.fieldTime': 'Время',
  'routines.fieldTimezone': 'Часовой пояс',
  'routines.fieldsetProject': 'Проект',
  'routines.kind.hourly': 'Ежечасно',
  'routines.kind.daily': 'Ежедневно',
  'routines.kind.weekdays': 'По будням',
  'routines.kind.weekly': 'Еженедельно',
  'routines.weekday.short.0': 'Вс',
  'routines.weekday.short.1': 'Пн',
  'routines.weekday.short.2': 'Вт',
  'routines.weekday.short.3': 'Ср',
  'routines.weekday.short.4': 'Чт',
  'routines.weekday.short.5': 'Пт',
  'routines.weekday.short.6': 'Сб',
  'routines.weekday.long.0': 'Воскресенье',
  'routines.weekday.long.1': 'Понедельник',
  'routines.weekday.long.2': 'Вторник',
  'routines.weekday.long.3': 'Среда',
  'routines.weekday.long.4': 'Четверг',
  'routines.weekday.long.5': 'Пятница',
  'routines.weekday.long.6': 'Суббота',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Запускается каждый час в :{minute}',
  'routines.describe.daily': 'Запускается ежедневно в {time} {tz}',
  'routines.describe.weekdays': 'Запускается с пн по пт в {time} {tz}',
  'routines.describe.weekly': 'Запускается каждый {day} в {time} {tz}',
  'routines.modeCreate': 'Создавать новый проект при каждом запуске',
  'routines.modeCreateHint': 'Новое изолированное рабочее пространство при каждом срабатывании.',
  'routines.modeReuse': 'Использовать существующий проект',
  'routines.modeReuseHint': 'Каждый запуск создаётся как новый разговор внутри проекта.',
  'routines.pickProject': '— Выберите проект —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ новый проект при каждом запуске',
  'routines.tagPaused': 'приостановлено',
  'routines.metaNext': 'далее: {when}',
  'routines.metaLast': 'последний:',
  'routines.triggerManual': 'вручную',
  'routines.triggerScheduled': 'по расписанию',
  'routines.openProject': 'Открыть проект',
  'routines.openProjectTitle': 'Открыть проект, в который записал этот запуск',
  'routines.runNow': 'Запустить сейчас',
  'routines.edit': 'Изменить',
  'routines.pause': 'Приостановить',
  'routines.resume': 'Возобновить',
  'routines.history': 'История',
  'routines.hideHistory': 'Скрыть историю',
  'routines.delete': 'Удалить',
  'routines.deleteTitle': 'Удалить эту автоматизацию',
  'routines.cancel': 'Отмена',
  'routines.save': 'Сохранить',
  'routines.saving': 'Сохранение…',
  'routines.create': 'Создать',
  'routines.creating': 'Создание…',
  'routines.status.queued': 'в очереди',
  'routines.status.running': 'выполняется',
  'routines.status.succeeded': 'успешно',
  'routines.status.failed': 'ошибка',
  'routines.status.canceled': 'отменено',
  'routines.confirmDelete': 'Удалить эту автоматизацию? Прошлые запуски и их проекты будут сохранены.',
  'routines.errorPickProject': 'Выберите проект для повторного использования или переключитесь на «Создавать новый при каждом запуске»',
  'routines.errorAgentEmptyOutput': 'Agent завершил работу, не создав никакого результата. Возможно, модель или провайдер вернули пустой ответ — проверьте журналы агента на наличие ошибок на стороне сервиса.',
  'entry.helpAria': 'Помощь',
  'entry.helpMenuAria': 'Меню помощи',
  'entry.helpGetHelp': 'Получить помощь на GitHub',
  'entry.helpSubmitFeature': 'Предложить функцию',
  'entry.helpWhatsNew': 'Что нового',
  'entry.helpDownloadDesktop': 'Скачать настольное приложение',
  'entry.githubStarLabel': 'Звезда',
  'entry.githubStarTitle': 'Поставьте нам звезду на GitHub',
  'entry.githubStarAria': 'Поставить OpenDesign звезду на GitHub',
  'entry.tabImageTemplates': 'Шаблоны изображений',
  'entry.tabVideoTemplates': 'Шаблоны видео',
  'promptTemplates.searchPlaceholder': 'Поиск шаблонов…',
  'promptTemplates.countLabel': '{n} результатов',
  'promptTemplates.emptyImage': 'Шаблоны промптов изображений не установлены.',
  'promptTemplates.emptyVideo': 'Шаблоны промптов видео не установлены.',
  'promptTemplates.emptyNoMatch': 'Нет шаблонов, соответствующих поиску.',
  'promptTemplates.attributionFooter': 'Адаптировано из публичных библиотек промптов. Каждая карточка ссылается на исходного автора.',
  'promptTemplates.openPreviewTitle': 'Открыть промпт и предпросмотр',
  'promptTemplates.sourcePrefix': 'Источник:',
  'promptTemplates.fetchError': 'Не удалось загрузить текст шаблона.',
  'promptTemplates.promptLabel': 'Текст промпта',
  'promptTemplates.copyPrompt': 'Копировать промпт',
  'promptTemplates.copyDone': 'Скопировано!',
  'promptTemplates.modelHint': 'Рекомендуемая модель: {model}',
  'promptTemplates.openSource': 'Открыть оригинал',
  'promptTemplates.openFullscreen': 'Открыть полноэкранный предпросмотр',
  'promptTemplates.closeFullscreen': 'Закрыть полноэкранный предпросмотр',
  'promptTemplates.allSources': 'Все источники',
  'promptTemplates.sourceFilterAria': 'Фильтр по источнику',
  'promptTemplates.retry': 'Повторить',
  'connectors.title': 'Коннекторы',
  'connectors.subtitle': 'Локальные и будущие источники данных для live-артефактов.',
  'connectors.account': 'Аккаунт',
  'connectors.noAccount': 'Не подключено',
  'connectors.tools': 'Инструменты',
  'connectors.connect': 'Подключить',
  'connectors.disconnect': 'Отключить',
  'connectors.authorizationPending': 'Ожидание авторизации...',
  'connectors.authorizationPendingHint': 'Завершите авторизацию в открытом окне.',
  'connectors.cancelAuthorization': 'Отмена',
  'connectors.configure': 'Настроить',
  'connectors.unavailable': 'Недоступно',
  'connectors.phaseStubTitle': 'API коннекторов появятся на этапе 3; это предварительный интерфейс.',
  'connectors.statusAvailable': 'Доступно',
  'connectors.statusConnected': 'Подключено',
  'connectors.statusError': 'Ошибка',
  'connectors.statusDisabled': 'Отключено',
  'connectors.gateTitle': 'Добавьте ключ Composio API, чтобы продолжить',
  'connectors.gateBody': 'Вставьте ключ выше и нажмите «Сохранить ключ», чтобы загрузить доступные интеграции.',
  'connectors.aboutLabel': 'О коннекторе',
  'connectors.detailsLabel': 'Детали',
  'connectors.statusLabel': 'Статус',
  'connectors.category.aiAgents': 'AI-агенты',
  'connectors.category.aiInfrastructure': 'AI-инфраструктура',
  'connectors.category.accounting': 'Бухгалтерия',
  'connectors.category.admin': 'Администрирование',
  'connectors.category.advertising': 'Реклама',
  'connectors.category.analytics': 'Аналитика',
  'connectors.category.automation': 'Автоматизация',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Календарь',
  'connectors.category.commerce': 'Коммерция',
  'connectors.category.communication': 'Коммуникации',
  'connectors.category.contacts': 'Контакты',
  'connectors.category.dataPlatform': 'Платформа данных',
  'connectors.category.database': 'База данных',
  'connectors.category.design': 'Дизайн',
  'connectors.category.developer': 'Инструменты разработчика',
  'connectors.category.documentation': 'Документация',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Образование',
  'connectors.category.email': 'Почта',
  'connectors.category.events': 'События',
  'connectors.category.fieldService': 'Выездное обслуживание',
  'connectors.category.finance': 'Финансы',
  'connectors.category.fitness': 'Фитнес',
  'connectors.category.forms': 'Формы',
  'connectors.category.gaming': 'Игры',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Гостеприимство',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Интеграция',
  'connectors.category.localization': 'Локализация',
  'connectors.category.logistics': 'Логистика',
  'connectors.category.maps': 'Карты',
  'connectors.category.marketing': 'Маркетинг',
  'connectors.category.media': 'Медиа',
  'connectors.category.meetings': 'Встречи',
  'connectors.category.nonprofit': 'НКО',
  'connectors.category.observability': 'Наблюдаемость',
  'connectors.category.payments': 'Платежи',
  'connectors.category.personal': 'Личное',
  'connectors.category.presentations': 'Презентации',
  'connectors.category.procurement': 'Закупки',
  'connectors.category.product': 'Продукт',
  'connectors.category.productivity': 'Продуктивность',
  'connectors.category.projectManagement': 'Управление проектами',
  'connectors.category.recruiting': 'Рекрутинг',
  'connectors.category.research': 'Исследования',
  'connectors.category.salesIntelligence': 'Аналитика продаж',
  'connectors.category.scheduling': 'Планирование',
  'connectors.category.search': 'Поиск',
  'connectors.category.security': 'Безопасность',
  'connectors.category.signing': 'Подписание',
  'connectors.category.social': 'Социальные сети',
  'connectors.category.spreadsheets': 'Таблицы',
  'connectors.category.storage': 'Хранилище',
  'connectors.category.support': 'Поддержка',
  'connectors.category.surveys': 'Опросы',
  'connectors.category.tasks': 'Задачи',
  'connectors.category.timeTracking': 'Учёт времени',
  'connectors.category.video': 'Видео',
  'connectors.category.whiteboard': 'Доска',
  'connectors.categoryLabel': 'Категория',
  'connectors.providerLabel': 'Провайдер',
  'connectors.toolsSection': 'Инструменты',
  'connectors.toolsLoading': 'Загрузка инструментов…',
  'connectors.noToolsAvailable': 'Инструменты ещё не загружены. Подключитесь, чтобы увидеть возможности интеграции.',
  'connectors.toolDetailsUnavailable': 'Сведения об инструментах недоступны, но этот коннектор сообщает о {n} инструментах.',
  'connectors.loadMoreTools': 'Загрузить ещё инструменты',
  'connectors.openDetailsAria': 'Открыть детали «{name}»',
  'connectors.toolsBadgeNone': 'Нет инструментов',
  'connectors.toolsBadgeOne': '{n} инструмент',
  'connectors.toolsBadgeMany': '{n} инструментов',
  'connectors.searchPlaceholder': 'Поиск коннекторов…',
  'connectors.searchAriaLabel': 'Поиск коннекторов по названию, провайдеру или инструменту',
  'connectors.searchClear': 'Очистить поиск',
  'connectors.emptyNoMatchTitle': 'Нет коннекторов по запросу «{query}»',
  'connectors.emptyNoMatchBody': 'Попробуйте другое ключевое слово или очистите поиск, чтобы вернуться к полному каталогу.',
  'connectors.emptyNoMatchAction': 'Очистить поиск',
  'newproj.tabPrototype': 'Прототип',
  'newproj.tabLiveArtifact': 'Новый live-артефакт',
  'newproj.tabDeck': 'Презентация',
  'newproj.tabTemplate': 'Шаблон',
  'newproj.tabMedia': 'Медиа',
  'newproj.tabOther': 'Другое',
  'newproj.titlePrototype': 'Новый прототип',
  'newproj.titleLiveArtifact': 'Новый live-артефакт',
  'newproj.titleDeck': 'Новая презентация',
  'newproj.titleTemplate': 'Начать с шаблона',
  'newproj.titleImage': 'Новое изображение',
  'newproj.titleVideo': 'Новое видео',
  'newproj.titleAudio': 'Новое аудио',
  'newproj.titleMedia': 'Новый медиафайл',
  'newproj.titleOther': 'Новый проект',
  'newproj.namePlaceholder': 'Название проекта',
  'newproj.fidelityLabel': 'Детализация',
  'newproj.fidelityWireframe': 'Вайрфрейм',
  'newproj.fidelityHigh': 'Высокая детализация',
  'newproj.toggleSpeakerNotes': 'Использовать заметки докладчика',
  'newproj.toggleSpeakerNotesHint': 'Меньше текста на слайдах — основные тезисы в заметках.',
  'newproj.toggleAnimations': 'Включить анимации',
  'newproj.toggleAnimationsHint': 'Добавить анимации (появление, наведение, переходы) поверх шаблона.',
  'newproj.targetPlatformsLabel': 'Целевые платформы',
  'newproj.targetPlatformsHint': 'Выберите одну или несколько. Адаптивный веб охватывает только контрольные точки браузера; добавьте iOS, Android, приложение для планшета или настольное приложение для нативных кросс-платформенных вариантов.',
  'newproj.platform.responsive.label': 'Адаптивный веб',
  'newproj.platform.responsive.hint': 'Единый веб-интерфейс, адаптированный для настольных, планшетных и мобильных браузеров',
  'newproj.platform.webDesktop.label': 'Настольный веб',
  'newproj.platform.webDesktop.hint': 'Продукт или целевая страница с ориентацией на браузер',
  'newproj.platform.mobileIos.label': 'Приложение iOS',
  'newproj.platform.mobileIos.hint': 'Фреймы iPhone и правила взаимодействия iOS',
  'newproj.platform.mobileAndroid.label': 'Приложение Android',
  'newproj.platform.mobileAndroid.hint': 'Фреймы Pixel и правила взаимодействия Material',
  'newproj.platform.tablet.label': 'Приложение для планшета',
  'newproj.platform.tablet.hint': 'Нативный интерфейс планшета с разделёнными представлениями',
  'newproj.platform.desktopApp.label': 'Настольное приложение',
  'newproj.platform.desktopApp.hint': 'Оформление приложения macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Сопутствующие поверхности',
  'newproj.includeLandingPage': 'Включить целевую страницу',
  'newproj.includeLandingPageHint': 'Добавьте адаптивную маркетинговую страницу для рекламы, списков ожидания, кампаний запуска, загрузок приложения или описания продукта.',
  'newproj.includeOsWidgets': 'Включить виджеты ОС',
  'newproj.includeOsWidgetsHint': 'Добавьте нативные для платформы виджеты главного экрана, экрана блокировки или быстрого доступа для мобильных и планшетных приложений.',
  'newproj.includeOsWidgetsDisabledHint': 'Доступно, когда в качестве целевой платформы выбрано приложение iOS, Android или планшета.',
  'newproj.templateLabel': 'Шаблон',
  'newproj.noTemplatesTitle': 'Шаблонов пока нет',
  'newproj.noTemplatesBody': 'Откройте любой проект, затем используйте меню «Поделиться» в просмотре файлов, чтобы преобразовать его в шаблон. Шаблоны появятся здесь.',
  'newproj.savedTemplate': 'Сохраненный шаблон',
  'newproj.fileSingular': 'файл',
  'newproj.filePlural': 'файлов',
  'newproj.create': 'Создать',
  'newproj.locationLabel': 'Сохранить в',
  'newproj.locationDefault': 'Проекты OpenDesign',
  'newproj.locationExternalBase': 'Внешняя база',
  'newproj.createLiveArtifact': 'Создать live-артефакт',
  'newproj.createFromTemplate': 'Создать из шаблона',
  'newproj.createDisabledTitle': 'Сначала сохраните проект как шаблон (меню «Поделиться» в любом проекте).',
  'newproj.openFolder': 'Открыть папку',
  'newproj.openingFolder': 'Открытие…',
  'newproj.importClaudeZip': 'Импортировать ZIP-файл из Claude Design',
  'newproj.importClaudeZipTitle': 'Импортировать экспорт `.zip` из Claude Design',
  'newproj.importingClaudeZip': 'Импорт…',
  'newproj.privacyFooter': 'По умолчанию только вы можете видеть свой проект.',
  'newproj.designSystem': 'Дизайн-система',
  'newproj.dsNoneFreeform': 'Нет — произвольная форма',
  'newproj.dsNoneSubtitleEmpty': 'Без системных токенов, выбирайте свою палитру',
  'newproj.dsNoneSubtitleSelected': 'Пропустить системные токены. Агент выбирает свою палитру.',
  'newproj.dsCategoryFallback': 'Дизайн-система',
  'newproj.dsSearch': 'Поиск дизайн-систем…',
  'newproj.dsModeAria': 'Режим выбора',
  'newproj.dsModeSingle': 'Один',
  'newproj.dsModeMulti': 'Несколько',
  'newproj.dsNoneTitle': 'Нет — произвольная форма',
  'newproj.dsNoneSub': 'Пропустить системные токены. Агент выбирает свою палитру.',
  'newproj.dsEmpty': 'Нет дизайн-систем, соответствующих «{query}».',
  'newproj.dsFootSingular': 'только для вдохновения.',
  'newproj.dsFootPlural': 'только для вдохновения.',
  'newproj.dsFootClear': 'Очистить',
  'newproj.dsBadgeDefault': 'ПО УМОЛЧАНИЮ',
  'newproj.dsPrimaryFallback': 'Основной',
  'newproj.surfaceImage': 'Изображение',
  'newproj.surfaceVideo': 'Видео',
  'newproj.surfaceAudio': 'Аудио',
  'newproj.modelLabel': 'Модель',
  'newproj.modelSearch': 'Поиск моделей…',
  'newproj.modelEmpty': 'Нет подходящих моделей.',
  'newproj.modelRecommended': 'Рекомендовано',
  'newproj.modelMissingTitle': 'Выберите модель',
  'newproj.modelMissingSub': 'Выберите модель для этой среды.',
  'newproj.aspectLabel': 'Формат',
  'newproj.videoLengthLabel': 'Длина',
  'newproj.videoLengthSeconds': '{n}с',
  'newproj.audioKindLabel': 'Тип аудио',
  'newproj.audioKindMusic': 'Музыка',
  'newproj.audioKindSpeech': 'Речь / TTS',
  'newproj.audioKindSfx': 'Звуковые эффекты',
  'newproj.audioDurationLabel': 'Длительность',
  'newproj.audioDurationSeconds': '{n}с',
  'newproj.voiceLabel': 'Голос',
  'newproj.voicePlaceholder': 'Voice id провайдера, опционально',
  'newproj.connectorsLabel': 'Коннекторы',
  'newproj.connectorsHint': 'Источники данных, из которых артефакт может получать данные.',
  'newproj.connectorsEmptyTitle': 'Коннекторы не настроены',
  'newproj.connectorsEmptyBody': 'Подключите источник данных, чтобы live-артефакт использовал реальные данные вместо заглушек.',
  'newproj.connectorsEmptyCta': 'Настроить коннекторы →',
  'newproj.connectorsLoading': 'Загрузка коннекторов…',
  'newproj.connectorsCountOne': 'Подключено: {n}',
  'newproj.connectorsCountMany': 'Подключено: {n}',
  'newproj.connectorsManage': 'Управлять',
  'newproj.promptTemplateLabel': 'Эталонный шаблон',
  'newproj.promptTemplateNoneTitle': 'Без шаблона — свой бриф',
  'newproj.promptTemplateNoneSub': 'Пропустить галерею и описать самостоятельно',
  'newproj.promptTemplateRefSub': 'Эталонный шаблон',
  'newproj.promptTemplateSearch': 'Поиск шаблонов…',
  'newproj.promptTemplateEmpty': 'Шаблоны для этого формата ещё не добавлены.',
  'newproj.promptTemplateBodyLabel': 'Промпт (можно править)',
  'newproj.promptTemplateOptimizeHint': 'Меняйте всё что нужно — правки попадут в бриф агента.',
  'newproj.promptTemplateBodyEmpty': 'Пустое тело — агент не получит шаблонную референцию.',
  'newproj.deleteTemplateTitle': 'Удалить шаблон',
  'newproj.deleteTemplateConfirm': 'Удалить «{name}»? Это действие невозможно отменить.',
  'newproj.deleteTemplateConfirmCta': 'Удалить шаблон',
  'newproj.deleteTemplateError': 'Не удалось удалить шаблон. Попробуйте ещё раз.',
  'designs.subRecent': 'Недавние',
  'designs.subYours': 'Ваши дизайны',
  'designs.filterAria': 'Фильтр проектов',
  'designs.searchPlaceholder': 'Поиск…',
  'designs.emptyNoProjects': 'Проектов пока нет.',
  'designs.emptyNoMatch': 'Нет проектов, соответствующих вашему поиску.',
  'designs.deleteTitle': 'Удалить проект',
  'designs.deleteConfirm': 'Удалить «{name}»?',
  'designs.cardFreeform': 'произвольная форма',
  'designs.badgeLive': 'Активно',
  'designs.liveArtifactBadgesAria': 'Бейджи live-артефактов',
  'designs.liveCount': 'Активно: {n}',
  'designs.statusLive': 'Live-артефакт',
  'designs.statusArchived': 'Архивирован',
  'designs.statusError': 'Ошибка',
  'designs.statusRefreshing': 'Обновление…',
  'designs.statusRefreshFailed': 'Не удалось обновить',
  'designs.statusRefreshed': 'Обновлено',
  'designs.status.notStarted': 'Не начато',
  'designs.status.queued': 'В очереди',
  'designs.status.running': 'Выполняется',
  'designs.status.awaitingInput': 'Нужен ввод',
  'designs.status.incomplete': 'Не завершено',
  'designs.status.succeeded': 'Завершено',
  'designs.status.published': 'Опубликовано',
  'designs.status.failed': 'Ошибка',
  'designs.status.canceled': 'Отменено',
  'designs.viewToggleAria': 'Режим просмотра',
  'designs.viewGrid': 'Вид сеткой',
  'designs.viewKanban': 'Вид доской',
  'designs.kanbanEmptyColumn': 'Нет дизайнов',
  'designs.deleteAria': 'Удалить проект {name}',
  'designs.menuMore': 'Другие действия',
  'designs.menuRename': 'Переименовать',
  'designs.menuDuplicate': 'Дублировать проект',
  'designs.menuDelete': 'Удалить',
  'designs.renamePrompt': 'Новое имя для «{name}»',
  'designs.selectMode': 'Выбрать',
  'designs.cancelSelect': 'Отмена',
  'designs.deleteSelected': 'Удалить выбранное',
  'designs.selectedCount': 'Выбрано: {n}',
  'designs.deleteSelectedConfirm': 'Удалить проектов: {n}?',
  'designs.deleteSelectedSuccess': 'Проектов удалено: {n}.',
  'designs.deleteSelectedPartial': 'Удалено проектов: {deleted}; не удалось: {failed}.',
  'designs.tagPrototype': 'Прототип',
  'designs.tagLiveArtifact': 'Живой артефакт',
  'designs.tagWebClone': 'Клон сайта',
  'designs.tagSlide': 'Слайд',
  'designs.tagMedia': 'Медиа',
  'designs.renameTitle': 'Переименовать проект',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Отмена',
  'examples.typeLabel': 'Тип',
  'examples.surfaceLabel': 'Поверхность',
  'examples.surfaceWeb': 'Веб',
  'examples.surfaceImage': 'Изображение',
  'examples.surfaceVideo': 'Видео',
  'examples.surfaceAudio': 'Аудио',
  'examples.scenarioLabel': 'Сценарий',
  'examples.modeAll': 'Все',
  'examples.modePrototypeDesktop': 'Прототипы · Десктоп',
  'examples.modePrototypeMobile': 'Прототипы · Мобильные',
  'examples.modeDeck': 'Презентации',
  'examples.modeDocument': 'Документы и шаблоны',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'В эфире',
  'examples.scenarioGeneral': 'Общее',
  'examples.scenarioEngineering': 'Инженерия',
  'examples.scenarioProduct': 'Продукт',
  'examples.scenarioDesign': 'Дизайн',
  'examples.scenarioMarketing': 'Маркетинг',
  'examples.scenarioSales': 'Продажи',
  'examples.scenarioFinance': 'Финансы',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Операции',
  'examples.scenarioSupport': 'Поддержка',
  'examples.scenarioLegal': 'Юридический',
  'examples.scenarioEducation': 'Образование',
  'examples.scenarioPersonal': 'Личное',
  'examples.searchPlaceholder': 'Поиск примеров…',
  'examples.searchAria': 'Поиск примеров по имени',
  'examples.emptyNoSkills': 'Нет доступных навыков. Демон запущен?',
  'examples.emptyNoMatch': 'Нет примеров, соответствующих этим фильтрам.',
  'examples.openPreview': '⤢ Открыть предпросмотр',
  'examples.loadingPreview': 'Загрузка предпросмотра…',
  'examples.hoverPreview': 'Наведите для предпросмотра',
  'examples.usePrompt': 'Использовать этот запрос',
  'examples.previewModalTitle': 'Открыть полный предпросмотр (модально)',
  'examples.shareTitle': 'Поделиться этим примером',
  'examples.shareLoadFirst': 'Сначала наведите для загрузки предпросмотра',
  'examples.unavailablePlaceholder': 'Нет встроенного предпросмотра {kind} — откройте, чтобы узнать больше',
  'examples.shareUnavailable': 'Нет встроенного предпросмотра {kind} для отправки',
  'examples.shareMenu': 'Поделиться ▾',
  'examples.exportPdfAllSlides': 'Экспорт в PDF (все слайды)',
  'examples.exportPptxLocked': 'Экспорт в PPTX… (сначала откройте шаблон)',
  'examples.tagSlideDeck': 'Презентация',
  'examples.tagTemplate': 'Шаблон',
  'examples.tagDesignSystem': 'Дизайн-система',
  'examples.tagMobilePrototype': 'Мобильный прототип',
  'examples.tagDesktopPrototype': 'Десктопный прототип',
  'examples.tagImage': 'Изображение',
  'examples.tagVideo': 'Видео',
  'examples.tagAudio': 'Аудио',
  'examples.previewLabel': 'Предпросмотр',
  'ds.surfaceLabel': 'Поверхность',
  'ds.surfaceWeb': 'Веб',
  'ds.surfaceImage': 'Изображение',
  'ds.surfaceVideo': 'Видео',
  'ds.surfaceAudio': 'Аудио',
  'ds.searchPlaceholder': 'Поиск дизайн-систем…',
  'ds.emptyNoMatch': 'Нет дизайн-систем, соответствующих вашему поиску.',
  'ds.badgeDefault': 'ПО УМОЛЧАНИЮ',
  'ds.preview': 'Предпросмотр',
  'ds.previewTitle': 'Предпросмотр дизайн-системы',
  'ds.categoryAll': 'Все',
  'ds.categoryUncategorized': 'Без категории',
  'ds.showcase': 'Витрина',
  'ds.tokens': 'Токены',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Загрузка DESIGN.md…',
  'avatar.title': 'Аккаунт и настройки',
  'avatar.localCli': 'Локальный CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Использовать локальный CLI',
  'avatar.useApi': 'Использовать API · BYOK',
  'avatar.codeAgent': 'Код-агент',
  'avatar.rescan': 'Пересканировать PATH',
  'avatar.amrConsole': 'Аккаунт OpenDesign Cloud',
  'avatar.amrConsoleMeta': 'Баланс и пополнение',
  'avatar.settings': 'Настройки',
  'avatar.backToProjects': 'Назад к проектам',
  'avatar.metaActive': 'активно',
  'avatar.metaOffline': 'офлайн',
  'avatar.metaSelected': 'выбрано',
  'avatar.noAgentSelected': 'агент не выбран',
  'avatar.modelSection': 'Модель',
  'avatar.modelLabel': 'Модель',
  'avatar.reasoningLabel': 'Рассуждения',
  'avatar.serviceTierLabel': 'Уровень сервиса',
  'avatar.customSuffix': '(пользовательская)',
  'socialShare.openDesignSection': 'Поделиться OpenDesign',
  'socialShare.openDesignTitle': 'OpenDesign на GitHub',
  'socialShare.openDesignText': 'OpenDesign — это рабочее пространство с доступным исходным кодом для создания, редактирования, развёртывания и передачи дизайн-артефактов.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'ПОДЕЛИТЬСЯ В СОЦСЕТЯХ',
  'socialShare.publishPageTitle': 'Опубликовать страницу для публикации',
  'socialShare.publishPageSubtitle': 'Опубликуйте этот предпросмотр, чтобы им можно было поделиться в социальных сетях.',
  'socialShare.projectTitle': '{title} · OpenDesign',
  'socialShare.projectText': 'Создано с помощью OpenDesign: {title}. Посмотрите развёрнутый артефакт и поставьте звезду репозиторию: {repo}',
  'socialShare.projectCopyText': 'Создано с помощью OpenDesign: {title}\n{url}\nРепозиторий OpenDesign: {repo}',
  'socialShare.deployFirst': 'Развернуть, затем поделиться…',
  'socialShare.copied': 'Скопировано',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Переключить CLI / модель',
  'inlineSwitcher.chipCli': 'Локальный CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'по умолчанию',
  'inlineSwitcher.noAgent': 'агент не выбран',
  'inlineSwitcher.modeLabel': 'Режим',
  'inlineSwitcher.agentLabel': 'Агент',
  'inlineSwitcher.providerLabel': 'Провайдер',
  'inlineSwitcher.modelLabel': 'Модель',
  'inlineSwitcher.useCli': 'Использовать локальный CLI',
  'inlineSwitcher.useByok': 'Использовать собственный API-ключ',
  'inlineSwitcher.daemonOffline': 'Демон офлайн — откройте настройки',
  'inlineSwitcher.noAgentsDetected': 'CLI не найден в PATH',
  'inlineSwitcher.openSettingsForModel': 'Настройте провайдера в Настройках',
  'inlineSwitcher.missingApiKey': 'API-ключ не задан — откройте Настройки.',
  'inlineSwitcher.openFullSettings': 'Открыть настройки выполнения',
  'inlineSwitcher.customSuffix': '(пользовательская)',
  'inlineSwitcher.unlimitedBadge': 'Безлимит',
  'project.backToProjects': 'Назад к проектам',
  'project.restoreAutomaticScenario': 'Use automatic scenario',
  'project.restoreAutomaticScenarioConfirm': 'Confirm automatic scenario',
  'project.restoreAutomaticScenarioBusy': 'Restoring…',
  'project.restoreAutomaticScenarioFailed': 'Could not restore the automatic scenario. Refresh and try again.',
  'project.brandReadyTitle': 'Дизайн-система {name} готова',
  'project.brandReadyTitleGeneric': 'Ваша дизайн-система готова',
  'project.brandReadyCta': 'Просмотреть в Дизайн-системах',
  'project.brandReadyDismiss': 'Закрыть',
  'project.brandReadyRefineHint': 'Автоматическое извлечение может упустить детали. Уточните систему, прежде чем широко использовать ее в проектах.',
  'project.brandReadyAiOptimize': 'AI-оптимизация',
  'project.brandReadyEditManually': 'Редактировать вручную',
  'project.brandReadyPreviewOpened': 'Предпросмотр дизайн-системы открыт.',
  'project.previewCommentSaveFailed': 'Не удалось сохранить комментарий. Попробуйте ещё раз.',
  'project.previewCommentReorderFailed': 'Не удалось сохранить порядок комментариев — при обновлении страницы он может сброситься.',
  'project.metaFreeform': 'произвольная форма',
  'project.typePrototype': 'Прототип',
  'project.typeDeck': 'Слайды',
  'project.typeTemplate': 'Шаблон',
  'project.typeImage': 'Изображение',
  'project.typeVideo': 'Видео',
  'project.typeAudio': 'Аудио',
  'project.customInstructions': 'Инструкции проекта',
  'project.customInstructionsPlaceholder': 'Инструкции для этого проекта (добавляются к каждому сообщению)…',
  'project.resizeChatPanel': 'Изменить размер панели чата',
  'project.instructionsActive': 'Активно — добавляется в каждое сообщение',
  'project.missing': 'Этот проект удален или больше не существует.',
  'chat.tabChat': 'Чат',
  'chat.tabComments': 'Комментарии',
  'chat.commentsSoon': 'Комментарии — скоро',
  'chat.comments.attached': 'Прикреплены к чату',
  'chat.comments.emptyAttached': 'Нет прикреплённых комментариев.',
  'chat.comments.saved': 'Сохранённые комментарии',
  'chat.comments.emptySaved': 'Сохранённых комментариев нет.',
  'chat.comments.add': 'Добавить',
  'chat.comments.addAll': 'Добавить все',
  'chat.comments.remove': 'Удалить',
  'chat.comments.placeholder': 'Оставьте комментарий к этому элементу…',
  'chat.comments.addSend': 'Добавить и отправить',
  'chat.comments.updateSend': 'Обновить и отправить',
  'chat.comments.removeAttachment': 'Открепить комментарий',
  'chat.comments.removeAttachmentAria': 'Открепить комментарий для {name}',
  'chat.comments.comment': 'Комментарий',
  'chat.comments.sendToChat': 'Отправить в чат',
  'chat.comments.viewAll': 'Показать все комментарии',
  'chat.comments.sending': 'Отправка…',
  'chat.comments.edit': 'Редактировать',
  'chat.comments.select': 'Выбрать',
  'chat.comments.selectAll': 'Выбрать всё',
  'chat.comments.deselect': 'Отменить выбор',
  'chat.comments.nSelected': 'Выбрано: {n}',
  'chat.comments.pin': 'Закрепить',
  'chat.comments.addNote': 'Добавить заметку',
  'chat.comments.savedToast': 'Комментарий сохранён',
  'chat.comments.pinSavedToast': 'Закрепление сохранено',
  'chat.comments.pinAtCoords': 'в точке {x}, {y}',
  'chat.comments.capturedItems': 'Захвачено элементов: {n}',
  'chat.comments.clear': 'Очистить',
  'chat.comments.targetImage': 'Изображение',
  'chat.comments.targetControl': 'Элемент управления',
  'chat.comments.targetLink': 'Ссылка',
  'chat.comments.targetText': 'Текст',
  'chat.comments.targetSection': 'Раздел',
  'chat.comments.targetPage': 'Страница',
  'chat.comments.targetArea': 'Область',
  'chat.annotationNotePlaceholder': 'Добавьте заметку к этой пометке',
  'chat.annotationAttachImage': 'Прикрепить изображение',
  'chat.annotationAttachedImages': 'Прикреплённые изображения',
  'chat.annotationAttachedRemove': 'Удалить последнее изображение',
  'chat.annotationAddToInput': 'Добавить в ввод',
  'chat.annotationAddingToInput': 'Добавление...',
  'chat.annotationQueue': 'Очередь',
  'chat.annotationQueueing': 'Добавление в очередь...',
  'chat.annotationSubmitOptions': 'Параметры отправки',
  'chat.annotationSending': 'Отправка...',
  'chat.annotationSendDisabledReason': 'Сейчас выполняется задача',
  'chat.annotationPreviewMissing': 'Не удалось сделать предпросмотр. Попробуйте ещё раз.',
  'chat.annotationPreviewMissingInk': 'Не удалось сделать предпросмотр. Попробуйте ещё раз, чтобы не отправить только рукописные пометки.',
  'chat.annotationSentWithoutScreenshot': 'Не удалось захватить предпросмотр. Аннотация отправлена без скриншота.',
  'chat.annotationTimeout': 'Истекло время отправки аннотации. Попробуйте ещё раз.',
  'chat.annotationFailed': 'Не удалось отправить аннотацию. Попробуйте ещё раз.',
  'chat.annotationProjectCreateFailed': 'Не удалось создать проект, поэтому аннотация не была отправлена.',
  'chat.annotationUploadFailed': 'Не удалось загрузить вложение. Попробуйте ещё раз.',
  'chat.conversationsTitle': 'Разговоры',
  'chat.conversationsAria': 'История разговоров',
  'chat.newConversation': 'Новый разговор',
  'chat.newConversationsTitle': 'Новый разговор',
  'chat.conversationsHeading': 'Разговоры',
  'chat.new': 'Новый',
  'chat.emptyConversations': 'Разговоров пока нет.',
  'chat.deleteConversation': 'Удалить разговор',
  'chat.renameConversationLabel': 'Переименовать «{title}»',
  'chat.deleteConversationConfirm': 'Удалить «{title}»? Это удалит его сообщения.',
  'chat.untitledConversation': 'Разговор без названия',
  'chat.forkedConversationTitle': 'Форк {title}',
  'chat.forkConversationFailed': 'Не удалось создать форк этого разговора.',
  'chat.startTitle': 'Начать разговор',
  'chat.startHint': 'Опишите, что хотите сгенерировать, или начните с одного из этих примеров:',
  'chat.brandBrowserAssistDesktopOnly': 'Для browser assist нужно десктопное приложение, чтобы OpenDesign мог прочитать живую страницу браузера.',
  'chat.brandBrowserAssistReadFailed': 'Не удалось прочитать страницу браузера. Убедитесь, что сайт бренда открыт и полностью загрузился.',
  'chat.brandBrowserAssistMessage': 'OpenDesign нужен browser assist, чтобы завершить извлечение бренда. Используйте карточку ниже, чтобы открыть браузер, затем нажмите «Ещё», выберите «Скачать страницу», дождитесь сообщения об успешном сохранении и используйте левую карточку «Следующий шаг», чтобы продолжить извлечение.',
  'chat.brandBrowserLocalSnapshotMissing': 'Для этого URL нет сохраненного снимка страницы.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Не удалось прочитать сохраненный снимок страницы.',
  'chat.brandBrowserSnapshotSaveFailed': 'Не удалось сохранить снимок страницы из браузера.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Браузер открыт',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Шаг 1: браузер открыт. Шаг 2: нажмите «Ещё», затем «Скачать страницу». Шаг 3: дождитесь сообщения об успешном сохранении снимка. Шаг 4: вернитесь к левой карточке «Следующий шаг» и нажмите «Продолжить извлечение», чтобы продолжить программное извлечение.',
  'brandEnrichment.title': "AI-оптимизация",
  'brandEnrichment.body': "OpenDesign запустит более глубокое извлечение в фоне, автоматически применит подходящие навыки дизайн-системы и обновит эту систему на месте. Это может занять 10-20 минут; вы можете продолжать работу.",
  'brandEnrichment.cta': "AI-оптимизация",
  'brandEnrichment.busy': "Запускаем AI-оптимизацию...",
  'brandExtractionTranscript.sourceDesignMd': 'вставленный DESIGN.md',
  'brandExtractionTranscript.user': 'Извлечь дизайн-систему из {source}.',
  'brandExtractionTranscript.doneTitle': 'Программное извлечение для {name} завершено.',
  'brandExtractionTranscript.doneBody': 'Я создал и зарегистрировал дизайн-систему {designSystemId} из {source}. Она готова к предпросмотру и может использоваться в новых дизайнах.',
  'brandExtractionTranscript.next': 'Далее можно запустить AI-оптимизацию для более глубокого извлечения или создать новый дизайн с этой системой.',
  'chat.fillInputTitle': 'Нажмите, чтобы заполнить ввод',
  'chat.jumpToLatest': 'Перейти к последнему',
  'chat.scrollToLatest': 'Прокрутить к последнему',
  'chat.messageRail.aria': 'Навигация по сообщениям пользователя',
  'chat.messageRail.jumpAria': 'Перейти к сообщению пользователя {index}',
  'chat.messageRail.empty': '(Нет содержимого)',
  'chat.you': 'Вы',
  'chat.openFile': 'Открыть {name}',
  'chat.copyPrompt': 'Скопировать запрос',
  'chat.copyErrorDiagnostic': 'Скопировать диагностику ошибки',
  'chat.copyDone': 'Скопировано!',
  'chat.inspect.noEditableTargets': 'Редактируемый текст или объекты стиля не найдены.',
  'chat.inspect.noCommentTargets': 'Текст или визуальные объекты для комментирования не найдены.',
  'chat.inspect.editHint': 'Выберите текст или объект стиля в предпросмотре, чтобы отредактировать его.',
  'chat.inspect.commentHint': 'Выберите текст или область в предпросмотре, чтобы оставить комментарий.',
  'chat.composerPlaceholder': 'Опишите, что хотите сгенерировать…',
  'chat.activeFileEditingLabel': 'Редактирование',
  'chat.activeFilePlaceholder': 'Попросите OpenDesign изменить {file}...',
  'chat.designArtifactsShowMore': 'Показать еще {count} файлов дизайна',
  'chat.mode.chat.label': 'Спросить',
  'chat.mode.chat.title': 'Режим вопросов',
  'chat.mode.chat.summary': 'Для быстрых ответов, правок, планирования и обсуждения без обязательного создания дизайн-артефакта.',
  'chat.mode.chat.solves': 'Используйте его, чтобы уточнять идеи, улучшать промпты, сравнивать варианты или задавать вопросы о текущей работе.',
  'chat.mode.chat.query1': 'Суммируй этот черновик и покажи пробелы.',
  'chat.mode.chat.query2': 'Помоги выбрать лучшую структуру для этой лендинговой страницы.',
  'chat.mode.chat.query3': 'Проверь этот дизайн и предложи конкретные улучшения.',
  'chat.mode.plan.label': "План",
  'chat.mode.plan.title': "Режим планирования",
  'chat.mode.plan.summary': "Сначала создает редактируемый документ плана, а после вашей проверки передает работу в режим дизайна.",
  'chat.mode.plan.solves': "Используйте для PRD, структур презентаций, брифов прототипов, вайрфреймов, сторибордов и любых широких запросов, которым нужно подтверждение перед генерацией.",
  'chat.mode.plan.query1': "Сначала создай покадровый outline презентации.",
  'chat.mode.plan.query2': "Подготовь PRD перед генерацией прототипа.",
  'chat.mode.plan.query3': "Преврати эту идею в редактируемый дизайн-план.",
  'chat.mode.design.label': 'Дизайн',
  'chat.mode.design.title': 'Режим дизайна',
  'chat.mode.design.summary': 'Для создания или изменения конкретных результатов: страниц, прототипов, live-артефактов, слайдов, изображений, видео, HyperFrames, аудио, дашбордов и файлов проекта.',
  'chat.mode.design.solves': 'Используйте его, когда OpenDesign должен сгенерировать файлы, обновить рабочее пространство или превратить бриф в мультимодальные результаты.',
  'chat.mode.design.query1': 'Создай лендинг запуска продукта и прототип HyperFrames по этому брифу.',
  'chat.mode.design.query2': 'Сделай инвестиционный deck на 10 слайдов с заметками спикера.',
  'chat.mode.design.query3': 'Сгенерируй идеи изображений, видео и аудио для этой кампании.',
  'chat.mode.cardBestFor': 'Подходит для',
  'chat.mode.cardTry': 'Примеры запросов',
  'chat.mode.cardCost': 'Типичный расход',
  'chat.mode.chat.cost': 'Низкий',
  'chat.mode.chat.costNote': 'Только разговор — ничего не создаётся, поэтому расход минимальный.',
  'chat.mode.plan.cost': 'Стандартный',
  'chat.mode.plan.costNote': 'Сначала создаёт редактируемый документ плана, а затем переходит к генерации.',
  'chat.mode.design.cost': 'Высокий',
  'chat.mode.design.costNote': 'Создаёт файлы и мультимодальный контент, поэтому один запуск может расходовать больше всего.',
  'chat.modePicker.choose': 'Выбрать режим',
  'chat.modePicker.current': 'Режим: {name}',
  'chat.modePicker.clear': 'Сбросить режим',
  'chat.modePicker.mode': 'Режим',
  'chat.composerHint': '⌘/Ctrl + Enter для отправки · укажите цель, содержание, стиль и формат',
  'chat.cliSettingsTitle': 'Настройки CLI и модели',
  'chat.cliSettingsAria': 'Открыть настройки CLI и модели',
  'chat.attachTitle': 'Прикрепить файлы (или вставить / перетащить)',
  'chat.addContextTitle': 'Добавить контекст',
  'chat.attachAria': 'Прикрепить файлы',
  'chat.importTitle': 'Импортировать источники (скоро)',
  'chat.importLabel': 'Импорт',
  'chat.importComingSoon': 'Скоро',
  'chat.importSoon': 'Скоро',
  'chat.importFig': 'Загрузить .fig файл',
  'chat.importGitHub': 'Подключить GitHub',
  'chat.importWeb': 'Захватить веб-элемент',
  'chat.importFolder': 'Ссылка на папку с кодом',
  'chat.importSkills': 'Навыки и дизайн-системы',
  'chat.importProject': 'Сослаться на другой проект',
  'chat.importDesignSystemHeader': 'Выберите дизайн-систему',
  'chat.importDesignSystemBack': 'Назад',
  'chat.importDesignSystemSearch': 'Поиск дизайн-систем…',
  'chat.importDesignSystemEmpty': 'Нет дизайн-систем, соответствующих "{query}"',
  'chat.importDesignSystemNone': 'Нет — свободно',
  'chat.importDesignSystemNoneSub': 'Не привязываться к системе в этот раз',
  'chat.importDesignSystemActive': 'Активна',
  'chat.importDesignSystemSwitched': 'Дизайн-система переключена на {title}',
  'chat.importDesignSystemFailed': 'Не удалось сменить дизайн-систему. Попробуйте снова.',
  'chat.importDesignSystemLoadFailed': 'Не удалось загрузить дизайн-системы.',
  'browserUse.title': 'Вдохновение',
  'browserUse.summary': 'Веб-действий: {count}, с приоритетом на извлечение ресурсов, дизайн-язык, анимацию, визуальные проверки и структуру компонентов.',
  'browserUse.searchAria': 'Поиск вдохновения',
  'browserUse.searchPlaceholder': 'Поиск по скриншотам, шрифтам, цветам, a11y...',
  'browserUse.empty': 'Нет подходящего вдохновения',
  'browserUse.unavailable': 'Вдохновение здесь недоступно',
  'browserUse.added': 'Добавлено в редактор',
  // Design Browser
  'designBrowser.aria': 'Дизайн-браузер',
  'designBrowser.goBack': 'Назад',
  'designBrowser.goForward': 'Вперед',
  'designBrowser.reload': 'Обновить',

  'designBrowser.stopLoading': 'Остановить загрузку',
  'designBrowser.viewportAria': 'Область просмотра браузера',
  'designBrowser.addressPlaceholder': 'Введите URL или поисковый запрос...',
  'designBrowser.addressAria': 'Адрес браузера',
  'designBrowser.suggestion.reference': 'Референс',
  'designBrowser.suggestion.history': 'История',
  'designBrowser.menu.copyScreenshot': 'Скопировать снимок экрана',
  'designBrowser.menu.hardReload': 'Жесткая перезагрузка',
  'designBrowser.menu.copyUrl': 'Скопировать URL',
  'designBrowser.menu.openInBrowser': 'Открыть в браузере',
  'designBrowser.menu.savePageBrief': 'Сохранить бриф страницы',
  'designBrowser.menu.clearBrowsingHistory': 'Очистить историю браузера',
  'designBrowser.menu.clearCookies': 'Очистить cookies',
  'designBrowser.menu.clearAllData': 'Очистить все данные',
  'designBrowser.status.openHttpUrlFirst': 'Сначала откройте http-URL',
  'designBrowser.status.openPageBeforeScreenshot': 'Откройте страницу, прежде чем делать снимок экрана',
  'designBrowser.status.screenshotCopied': 'Снимок экрана скопирован в буфер обмена',
  'designBrowser.status.openPageBeforeBrief': 'Откройте страницу, прежде чем сохранять бриф',
  'designBrowser.status.openPageBeforeTools': 'Откройте страницу, прежде чем использовать инструменты браузера',
  'designBrowser.status.clickElementToComment': 'Нажмите на элемент, чтобы оставить комментарий',
  'designBrowser.status.clickElementToTune': 'Нажмите на элемент, чтобы настроить его',
  'designBrowser.status.noElementSelected': 'Элемент браузера не выбран',
  'designBrowser.status.addBrowserComment': 'Добавьте комментарий к странице',
  'designBrowser.status.tuneElementThenSaveHtml': 'Настройте элемент, затем сохраните HTML',
  'designBrowser.status.tuneLiveOnly': 'Настройка доступна только вживую для страниц вне проекта',
  'designBrowser.status.pickerFailed': 'Не удалось выбрать элемент в браузере',
  'designBrowser.status.applyStyleFailed': 'Не удалось применить стиль на странице браузера',
  'designBrowser.status.editTextFailed': 'Не удалось изменить текст на странице браузера',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Сохранять можно только локальные HTML-страницы проекта',
  'designBrowser.status.htmlSaved': 'Изменения HTML сохранены',
  'designBrowser.status.htmlSaveFailed': 'Не удалось сохранить HTML',
  'designBrowser.status.commentSavingUnavailable': 'Сохранение комментариев недоступно',
  'designBrowser.status.commentSaved': 'Комментарий к странице сохранен',
  'designBrowser.status.commentSendingUnavailable': 'Отправка комментариев недоступна',
  'designBrowser.comments.aria': 'Комментарии браузера',
  'designBrowser.comments.openFor': 'Открыть комментарий к элементу {label}',
  'designBrowser.comment.dialog': 'Комментарий к странице',
  'designBrowser.comment.elementFallback': 'Элемент страницы',
  'designBrowser.comment.close': 'Закрыть комментарий',
  'designBrowser.comment.noteAria': 'Текст комментария к странице',
  'designBrowser.comment.placeholder': 'Опишите изменение или проблему...',
  'designBrowser.comment.addNote': 'Добавить заметку',
  'designBrowser.comment.saveComment': 'Сохранить комментарий',
  'designBrowser.comment.sending': 'Отправляем...',
  'designBrowser.comment.sendToChat': 'Отправить в чат',
  'designBrowser.inspect.editTitle': 'Редактировать HTML-элемент',
  'designBrowser.inspect.tuneTitle': 'Настроить элемент страницы',
  'designBrowser.inspect.closeTune': 'Закрыть настройку элемента',
  'designBrowser.inspect.colors': 'Цвета',
  'designBrowser.inspect.text': 'Текст',
  'designBrowser.inspect.fill': 'Заливка',
  'designBrowser.inspect.type': 'Тип',
  'designBrowser.inspect.size': 'Размер',
  'designBrowser.inspect.weight': 'Начертание',
  'designBrowser.inspect.spacing': 'Интервалы',
  'designBrowser.inspect.pad': 'Внутренний отступ',
  'designBrowser.inspect.radius': 'Радиус',
  'designBrowser.inspect.content': 'Содержимое',
  'designBrowser.inspect.elementText': 'Текст элемента',
  'designBrowser.inspect.saving': 'Сохраняем...',
  'designBrowser.inspect.saveHtml': 'Сохранить HTML',
  'designBrowser.inspect.liveOnly': 'Только вживую',
  'designBrowser.reference.kicker': 'Браузер OpenDesign',
  'designBrowser.reference.title': 'Доска референсов',
  'designBrowser.reference.subtitle': 'Кураторская подборка референсов: вдохновение, реальные продуктовые интерфейсы, анимация, цвет, типографика, ассеты и дизайн-системы. Откройте любой сайт вживую и соберите дизайн-язык для следующего артефакта.',
  'designBrowser.reference.categoryAria': 'Категория референсов',
  'designBrowser.reference.searchPlaceholder': 'Поиск референсов...',
  'designBrowser.reference.searchAria': 'Поиск референсов',
  'designBrowser.reference.clearSearch': 'Очистить поиск',
  'designBrowser.reference.noMatches': 'Референсы по запросу «{query}» не найдены.',
  'designBrowser.reference.clearFilters': 'Сбросить фильтры',
  'designBrowser.reference.open': 'Открыть',
  'designBrowser.reference.group.inspiration': 'Вдохновение',
  'designBrowser.reference.group.interfaces': 'Реальные интерфейсы',
  'designBrowser.reference.group.motion': 'Моушн',
  'designBrowser.reference.group.color': 'Цвет',
  'designBrowser.reference.group.type': 'Типографика',
  'designBrowser.reference.group.icons': 'Иконки',
  'designBrowser.reference.group.illustration': 'Иллюстрации',
  'designBrowser.reference.group.photography': 'Фотография',
  'designBrowser.reference.group.3d': '3D и графика',
  'designBrowser.reference.group.mockups': 'Мокапы',
  'designBrowser.reference.group.systems': 'Дизайн-системы',
  'designBrowser.reference.group.components': 'Компоненты',
  'designBrowser.reference.group.guidelines': 'Гайдлайны и a11y',
  'designBrowser.reference.group.tools': 'Инструменты и ресурсы',
  'designBrowser.reference.site.dribbble.detail': 'Дизайн-шоты и UI-вдохновение.',
  'designBrowser.reference.site.behance.detail': 'Креативные портфолио и кейсы.',
  'designBrowser.reference.site.awwwards.detail': 'Отмеченный наградами веб-дизайн.',
  'designBrowser.reference.site.godly.detail': 'Кураторская подборка современного веб-дизайна.',
  'designBrowser.reference.site.land_book.detail': 'Галерея лендингов и паттернов.',
  'designBrowser.reference.site.mobbin.detail': 'Реальные экраны приложений и UI-паттерны.',
  'designBrowser.reference.site.screenlane.detail': 'Свежие UI-паттерны из приложений.',
  'designBrowser.reference.site.pageflows.detail': 'Реальные пользовательские потоки и onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Паттерны взаимодействия из топовых приложений.',
  'designBrowser.reference.site.collectui.detail': 'Ежедневная UI-коллекция по категориям.',
  'designBrowser.reference.site.gsap.detail': 'Production-движок анимации и примеры.',
  'designBrowser.reference.site.animations.detail': 'Паттерны анимации и примеры взаимодействий.',
  'designBrowser.reference.site.transitions.detail': 'Паттерны переходов для современных интерфейсов.',
  'designBrowser.reference.site.motionsites.detail': 'Премиальные референсы моушна и интеракций.',
  'designBrowser.reference.site.motion.detail': 'Вдохновение для scroll- и timeline-анимации.',
  'designBrowser.reference.site.animography.detail': 'Анимированная типографика и кинетический lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React-референсы текстовой анимации для выразительной кинетической типографики.',
  'designBrowser.reference.site.coolors.detail': 'Быстрый генератор цветовых палитр.',
  'designBrowser.reference.site.colorhunt.detail': 'Кураторские цветовые палитры.',
  'designBrowser.reference.site.realtimecolors.detail': 'Предпросмотр палитр на реальном UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Цветовой круг и правила гармонии.',
  'designBrowser.reference.site.happyhues.detail': 'Палитры, показанные в реальном контексте.',
  'designBrowser.reference.site.fonts_google.detail': 'Библиотека open-source-шрифтов.',
  'designBrowser.reference.site.fontshare.detail': 'Качественные шрифты, бесплатные для коммерческого использования.',
  'designBrowser.reference.site.typewolf.detail': 'Шрифты в реальных проектах и рекомендации по сочетаниям.',
  'designBrowser.reference.site.fontpair.detail': 'Подборки сочетаний шрифтов.',
  'designBrowser.reference.site.fontsinuse.detail': 'Типографика в реальном дизайне.',
  'designBrowser.reference.site.thesvg.detail': 'SVG-ассеты и векторные референсы.',
  'designBrowser.reference.site.svglogos.detail': 'Чистые SVG-логотипы для продуктовых и брендовых мокапов.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Иконки продуктовых и AI-брендов для интерфейсов.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source-иконок в одном месте.',
  'designBrowser.reference.site.lucide.detail': 'Чистый и единообразный открытый набор иконок.',
  'designBrowser.reference.site.heroicons.detail': 'SVG-иконки от команды Tailwind.',
  'designBrowser.reference.site.svgrepo.detail': 'Бесплатные SVG-векторы и иконки.',
  'designBrowser.reference.site.storyset.detail': 'Настраиваемые векторные иллюстрации.',
  'designBrowser.reference.site.undraw.detail': 'Open-source-иллюстрации под лицензией MIT.',
  'designBrowser.reference.site.blush.detail': 'Иллюстрации, которые можно смешивать и настраивать.',
  'designBrowser.reference.site.lummi.detail': 'Бесплатные AI-сгенерированные визуалы.',
  'designBrowser.reference.site.whirrls.detail': 'Референсы изображений в рисованной манере.',
  'designBrowser.reference.site.worldindots.detail': 'Референсы точечных карт и data-viz.',
  'designBrowser.reference.site.unsplash.detail': 'Бесплатные фотографии высокого разрешения.',
  'designBrowser.reference.site.pexels.detail': 'Бесплатные стоковые фото и видео.',
  'designBrowser.reference.site.pixabay.detail': 'Изображения и медиа без роялти.',
  'designBrowser.reference.site.cosmos.detail': 'Визуальное исследование и moodboard-доски.',
  'designBrowser.reference.site.spline.detail': '3D-дизайн прямо в браузере.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D-референсы и демо.',
  'designBrowser.reference.site.womp.detail': 'Простое создание 3D в браузере.',
  'designBrowser.reference.site.pixcap.detail': '3D-иконки, мокапы и сцены.',
  'designBrowser.reference.site.shots.detail': 'Мокапы устройств и браузеров.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop-мокапы устройств.',
  'designBrowser.reference.site.angle.detail': 'Библиотека 3D-мокапов устройств.',
  'designBrowser.reference.site.rotato.detail': 'Анимированные 3D-мокапы продуктов.',
  'designBrowser.reference.site.impeccable.detail': 'Качественные референсы стиля и интерфейсов.',
  'designBrowser.reference.site.styles_refero.detail': 'Референсы дизайн-стилей и визуальных систем.',
  'designBrowser.reference.site.brandfetch.detail': 'Брендовые ассеты, логотипы и айдентика.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Галерея публичных дизайн-систем.',
  'designBrowser.reference.site.startups.detail': 'Лучшие референсы продуктов и брендов стартапов.',
  'designBrowser.reference.site.base_ui.detail': 'Нестилизованные доступные примитивы для кастомных систем.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Компонуемые React-компоненты на Radix и Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Современная библиотека React-компонентов и дизайн-система.',
  'designBrowser.reference.site.radix_ui.detail': 'Доступные низкоуровневые UI-примитивы.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Доступные поведенческие примитивы от Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Нестилизованные доступные компоненты для Tailwind-проектов.',
  'designBrowser.reference.site.mui.detail': 'Экосистема React-компонентов на базе Material.',
  'designBrowser.reference.site.mantine.detail': 'Полнофункциональные React-компоненты и hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Доступные React-компоненты с theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise-компонентная система и паттерны.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless-компоненты для современных фреймворков.',
  'designBrowser.reference.site.daisyui.detail': 'Классы компонентов и темы для Tailwind CSS.',
  'designBrowser.reference.site.developer_apple.detail': 'Гайдлайны дизайна для платформ Apple.',
  'designBrowser.reference.site.m3_material.detail': 'Material Design 3 от Google.',
  'designBrowser.reference.site.lawsofux.detail': 'UX-принципы и эвристики.',
  'designBrowser.reference.site.webaim.detail': 'Проверка цветового контраста.',
  'designBrowser.reference.site.a11yproject.detail': 'Чек-лист и паттерны доступности.',
  'designBrowser.reference.site.toolfolio.detail': 'Дизайн-инструменты, ресурсы и коллекции.',
  'designBrowser.reference.site.getdesign.detail': 'Кураторские дизайн-ресурсы.',
  'designBrowser.reference.site.tasteskill.detail': 'Тренировка дизайн-вкуса и референсы для критики.',
  'designBrowser.reference.site.uigoodies.detail': 'Отобранные вручную дизайн-ресурсы.',
  'designBrowser.reference.site.sidebar.detail': 'Пять дизайн-ссылок каждый день.',
  'designBrowser.reference.site.github.detail': 'Референсная реализация встроенных браузерных сценариев.',
  'browserUse.category.assets': 'Извлечение ресурсов',
  'browserUse.category.tokens': 'Дизайн-язык',
  'browserUse.category.motion': 'Анимация',
  'browserUse.category.visual': 'Визуальные проверки',
  'browserUse.category.structure': 'Компоненты',
  'browserUse.category.project': 'Запуск проекта',
  'browserUse.category.general': 'Общие',
  'browserUse.input.none': 'Нет ввода',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Необязательный селектор',
  'browserUse.input.requirementSelector': 'Требование, необязательный селектор',
  'browserUse.input.selectorOptional': 'Необязательный селектор',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Селектор, scale=2',
  'browserUse.input.gridOverlay': '12 колонок, макс. 1200, отступ 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, домен или поисковые запросы',
  'browserUse.input.selector': 'Селектор',
  'browserUse.input.selectorText': 'Селектор и текст',
  'browserUse.input.scroll': 'Пиксели, верх, низ или страница',
  'browserUse.input.terminalRun': 'Команда, таймаут 120 с',
  'browserUse.input.command': 'Команда',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Лучшие кандидаты логотипа из шапки, навигации, имён классов, позиции, OG-изображения и запасного варианта favicon.',
  'browserUse.action.list_images.output': 'Все изображения img, srcset, source и фоновые изображения CSS с размерами и alt-текстом.',
  'browserUse.action.download_assets.output': 'Папка со скачанными ресурсами плюс _manifest.json с поддержкой referer и cookie.',
  'browserUse.action.extract_svgs.output': 'Встроенные SVG и связанные файлы .svg, сохранённые как отдельные SVG-файлы.',
  'browserUse.action.optimize_svgs.output': 'Оптимизированные SVG-файлы плюс коэффициент сжатия.',
  'browserUse.action.extract_colors.output': 'Взвешенная палитра плюс CSS-переменные цвета :root в виде palette.json и palette.html.',
  'browserUse.action.extract_fonts.output': 'Основные семейства шрифтов, размеры, начертания и правила @font-face в виде typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Радиус, тень, отступы и CSS-переменные в виде tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Типографическая шкала заголовков, основного текста и кнопок с размером, начертанием, высотой строки и соотношениями.',
  'browserUse.action.extract_buttons.output': 'Библиотека стилей кнопок без дубликатов в виде buttons.html и buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Контейнеры grid и flex, направление, отступы, колонки и максимальная ширина в виде layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Адаптивные точки останова медиазапросов в виде breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'CSS-градиенты в виде gradients.css, gradients.json и HTML-предпросмотра.',
  'browserUse.action.extract_shadows.output': 'Тени блоков, тени текста и отбрасываемые тени в виде shadows.json плюс предпросмотр.',
  'browserUse.action.extract_easings.output': 'Функции плавности переходов и анимаций в виде easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js и style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, правила transition и transform, обнаруженные библиотеки движения, motion.css и motion.json.',
  'browserUse.action.validate_view.output': 'Пути к снимкам экрана плюс структурированные визуальные проблемы и проблемы вёрстки.',
  'browserUse.action.audit_layout.output': 'Дефекты вёрстки, включая переполнение, границы, наложение и обрезанный текст, в виде audit.json.',
  'browserUse.action.audit_accessibility.output': 'Проблемы доступности с селекторами, метками, ролями, фокусом, контрастом и снимками экрана, где это полезно.',
  'browserUse.action.responsive_screenshots.output': 'Снимки экрана для мобильных 390, планшетов 834 и десктопа 1440.',
  'browserUse.action.screenshot_full.output': 'Снимок всей страницы за пределами области просмотра.',
  'browserUse.action.screenshot_element.output': 'Снимок одного элемента по умолчанию в масштабе 2x.',
  'browserUse.action.screenshot_with_grid.output': 'Снимок экрана с наложением сетки вёрстки.',
  'browserUse.action.screenshot_dark_mode.output': 'Снимок экрана с prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Одностраничное руководство по стилю с цветами, типографической шкалой, радиусом и тенями.',
  'browserUse.action.extract_html.output': 'Чистый автономный HTML без script, noscript или встроенных атрибутов событий.',
  'browserUse.action.extract_component_inventory.output': 'Повторяющиеся шаблоны компонентов, селекторы, количество и снимки экрана.',
  'browserUse.action.extract_copy.output': 'Заголовки, призывы к действию, основной текст и описания в виде copy.md и copy.json.',
  'browserUse.action.extract_nav.output': 'Основная навигация и ссылки в подвале в виде sitemap.md и nav.json.',
  'browserUse.action.extract_forms.output': 'Поля форм, метки, подсказки валидации и действия отправки в виде forms.json.',
  'browserUse.action.run_project.output': 'Обнаруженный URL сервера разработки, открытый на вкладке Browser.',
  'browserUse.action.detect_project.output': 'Фреймворк, менеджер пакетов, команда установки, команда запуска и порт.',
  'browserUse.action.page_info.output': 'URL, заголовок, описание, OG-изображение, цвет темы, favicon и viewport.',
  'browserUse.action.snapshot.output': 'До 120 видимых интерактивных и текстовых элементов с тегом, меткой, href и координатами.',
  'browserUse.action.navigate.output': 'Открыть страницу и вернуть page_info.',
  'browserUse.action.click.output': 'Нажать на первый подходящий элемент после прокрутки к нему.',
  'browserUse.action.type_text.output': 'Заполнить поле ввода и отправить события input и change.',
  'browserUse.action.scroll.output': 'Текущая и максимальная позиция прокрутки.',
  'browserUse.action.extract_og_metadata.output': 'Meta-заголовок, описание, канонический URL, карточки OG/Twitter, изображение для соцсетей и цвет темы.',
  'browserUse.action.terminal_run.output': 'stdout, stderr и код выхода.',
  'browserUse.action.terminal_run_background.output': 'Идентификатор фоновой задачи и недавний вывод.',
  'browserUse.action.terminal_read.output': 'Недавний вывод общего терминала.',
  'chat.designToolbox.title': 'Дизайн-инструменты',
  'chat.designToolbox.tooltip': 'Дизайн-инструменты',
  'chat.designToolbox.aria': 'Открыть дизайн-инструменты',
  'chat.designToolbox.searchPlaceholder': 'Поиск навыков / MCP / плагинов / коннекторов / файлов дизайна...',
  'chat.designToolbox.searchAria': 'Поиск ресурсов в дизайн-инструментах',
  'chat.designToolbox.followupSection': 'Уточнение',
  'chat.designToolbox.resourcesSection': 'Глобальные ресурсы',
  'chat.designToolbox.selected': 'Выбрано',
  'chat.designToolbox.noResources': 'Ресурсы по запросу «{query}» не найдены.',
  'chat.designToolbox.badge.video': 'Видео',
  'chat.designToolbox.badge.image': 'Изображение',
  'chat.designToolbox.badge.motion': 'Анимация',
  'chat.designToolbox.badge.polish': 'Доработка',
  'chat.designToolbox.action.auto-match.title': 'Подобрать следующий шаг',
  'chat.designToolbox.action.auto-match.badge': 'Подобрать',
  'chat.designToolbox.action.auto-match.description': 'Сначала задайте планку вкуса, затем подберите навыки, MCP, плагины, коннекторы и файлы.',
  'chat.designToolbox.action.asset-search.title': 'Найти изображения / референсы',
  'chat.designToolbox.action.asset-search.badge': 'Ассеты',
  'chat.designToolbox.action.asset-search.description': 'Найдите пригодные изображения, скриншоты-референсы, мудборды и исходные материалы для текущего дизайна.',
  'chat.designToolbox.action.icon-workflow.title': 'Найти / заменить иконки',
  'chat.designToolbox.action.icon-workflow.badge': 'Иконки',
  'chat.designToolbox.action.icon-workflow.description': 'Найдите, сгенерируйте или замените иконографику, SVG, Lucide-иконки и визуальные символы в едином стиле.',
  'chat.designToolbox.action.image-replace.title': 'Заменить изображения на странице',
  'chat.designToolbox.action.image-replace.badge': 'Замена',
  'chat.designToolbox.action.image-replace.description': 'Проверьте текущие изображения и замените слабые hero-, секционные, фоновые или карточные изображения более сильными ассетами.',
  'chat.designToolbox.action.reference-extract.title': 'Извлечь визуальные референсы',
  'chat.designToolbox.action.reference-extract.badge': 'Рефы',
  'chat.designToolbox.action.reference-extract.description': 'Проанализируйте референсный скриншот или сайт: палитру, типографику, характер компоновки, движение и направление ассетов.',
  'chat.designToolbox.action.motion.title': 'Добавить анимацию / движение',
  'chat.designToolbox.action.motion.badge': 'Анимация',
  'chat.designToolbox.action.motion.description': 'Добавьте анимацию появления, прокрутки, перехода состояний и микровзаимодействий к текущему HTML или элементу страницы.',
  'chat.designToolbox.action.motion-polish.title': 'Доработать анимацию',
  'chat.designToolbox.action.motion-polish.badge': 'Тайминг',
  'chat.designToolbox.action.motion-polish.description': 'Проверьте тайминг, плавность, производительность и резервные варианты для reduced-motion в существующей анимации.',
  'chat.designToolbox.action.transition-motion.title': 'Спроектировать переходы',
  'chat.designToolbox.action.transition-motion.badge': 'Переход',
  'chat.designToolbox.action.transition-motion.description': 'Спроектируйте переходы страниц, сцен, загрузки и состояний со сдержанным таймингом и fallback для reduced motion.',
  'chat.designToolbox.action.threejs-scene.title': '3D / сцена Three.js',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Добавьте или спланируйте интерактивный визуал на Three.js, Spline, Vanta, частицах, WebGL, карте или в стиле deck.gl.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Убрать ИИ-ощущение',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Вкус',
  'chat.designToolbox.action.anti-ai-polish.description': 'Уберите шаблонность, ИИ-градиенты, дешёвые стопки карточек и расплывчатые формулировки.',
  'chat.designToolbox.action.visual-polish.title': 'Доработка дизайна / готово к выпуску',
  'chat.designToolbox.action.visual-polish.badge': 'Доработка',
  'chat.designToolbox.action.visual-polish.description': 'Проверьте визуальную иерархию, типографику, отступы, адаптивность, доступность и качество поставки.',
  'chat.designToolbox.action.image-gen.title': 'Сгенерировать изображения / визуальные референсы',
  'chat.designToolbox.action.image-gen.badge': 'Изображение',
  'chat.designToolbox.action.image-gen.description': 'Сгенерируйте референсы секций, ассеты, иконки, изображения для соцсетей или мудборд для текущей страницы.',
  'chat.designToolbox.action.chart-gen.title': 'Сгенерировать графики / диаграммы',
  'chat.designToolbox.action.chart-gen.badge': 'Графики',
  'chat.designToolbox.action.chart-gen.description': 'Сгенерируйте ECharts, React Flow, диаграммы, дашборды, карты связей или data-viz-ассеты.',
  'chat.designToolbox.action.logo-gen.title': 'Сгенерировать логотип / айдентику',
  'chat.designToolbox.action.logo-gen.badge': 'Логотип',
  'chat.designToolbox.action.logo-gen.description': 'Создайте направления логотипа, wordmark, lockup, знак и промпты для системы айдентики текущего бренда.',
  'chat.designToolbox.action.plan-outline.title': "Создать outline презентации из идеи",
  'chat.designToolbox.action.plan-outline.badge': "План",
  'chat.designToolbox.action.plan-outline.description': "Превратите черновую идею в редактируемый Markdown-outline презентации до создания слайдов.",
  'chat.designToolbox.action.video-gen.title': 'Сгенерировать видео / сценарий движения',
  'chat.designToolbox.action.video-gen.badge': 'Видео',
  'chat.designToolbox.action.video-gen.description': 'Превратите дизайн в короткое видео, раскадровку Remotion / Hyperframes или готовый к генерации промпт.',
  'chat.designToolbox.kind.skill': 'Навык',
  'chat.designToolbox.kind.plugin': 'Плагин',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Шаблон MCP',
  'chat.designToolbox.kind.connector': 'Коннектор',
  'chat.designToolbox.kind.designFile': 'Файл дизайна',
  'chat.designToolbox.context.browser': 'Браузер',
  'chat.designToolbox.context.designFiles': 'Файлы дизайна',
  'chat.designToolbox.context.designSystem': 'Дизайн-система',
  'chat.designToolbox.context.folder': 'Папка',
  'chat.designToolbox.context.terminal': 'Терминал',
  'chat.designToolbox.context.sideChat': 'Боковой чат',
  'chat.designToolbox.context.liveArtifact': 'Живой артефакт',
  'chat.designToolbox.context.file': 'Файл',
  'chat.designToolbox.prompt.contextGeneric': 'Текущая цель: открытый в данный момент HTML / файл дизайна / веб-элемент.',
  'chat.designToolbox.prompt.contextSpecific': 'Текущая цель: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Сохраните намерение, уже заданное в редакторе: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Выбранный навык: {skill}. Используйте его как основной рабочий процесс для этого хода.',
  'chat.designToolbox.prompt.noSkill': 'Если конкретный навык не подошёл, сначала выберите оптимальную комбинацию из доступных навыков, MCP, плагинов, коннекторов и файлов дизайна.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Выступите в роли оркестратора креативного директора и завершите рабочий процесс дизайна:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Сначала определите, что значит «хороший дизайн»: аудитория, бизнес-цель, ощущение бренда, референсы стиля, плотность информации, стандарты цвета/типографики/анимации/ассетов, а также шаблоны AI/заготовок, которых следует избегать.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Выполните поиск и подбор по всему индексу ресурсов выше. Не используйте только рекомендации дизайн-инструментов; при необходимости сочетайте навыки, MCP, плагины, коннекторы и файлы дизайна.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. Если цель или эстетическая планка всё ещё неясны, проведите меня через структурированную форму вопросов, включите рекомендуемые значения по умолчанию и сделайте каждый вопрос с конечным набором вариантов редактируемым через поле пользовательского ответа. Если всё достаточно ясно, сразу выполните следующий шаг.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Завершите процесс в таком порядке: диагностика -> направление стиля -> выбор ресурсов -> конкретное редактирование/генерация -> проверка. На каждом шаге объясняйте, почему выбраны эти ресурсы и что нужно подтвердить далее.',
  'chat.designToolbox.prompt.assetSearch': 'Найдите лучшие изображения и референсные ассеты для текущего дизайна. Проверьте доступные файлы, коннекторы, MCP, браузерные захваты и инструменты генерации. Верните конкретных кандидатов с примечаниями по использованию, лицензии и источнику, если это важно; если пригодных ассетов нет, дайте fallback-промпт для генерации.',
  'chat.designToolbox.prompt.iconWorkflow': 'Улучшите иконочную систему текущего дизайна: найдите отсутствующие иконки, замените слабые, сохраните согласованность stroke/fill/radius/weight, по возможности используйте существующие библиотеки и генерируйте SVG/icon-промпты только там, где библиотечной иконки недостаточно.',
  'chat.designToolbox.prompt.imageReplace': 'Проверьте каждый видимый слот изображения в текущем дизайне, найдите слабые или placeholder-визуалы, затем замените или точно опишите лучшие hero-, секционные, фоновые, карточные и social-изображения. Сохраните layout и укажите точный файл, промпт или источник.',
  'chat.designToolbox.prompt.referenceExtract': 'Используйте текущее референсное изображение, сайт или файл дизайна как визуальный ввод. Извлеките палитру, type scale, ритм layout, характер компонентов, motion cues и стиль ассетов, затем примените выводы к текущему дизайну без дословного копирования защищенных брендовых ассетов.',
  'chat.designToolbox.prompt.motion': 'Добавьте качественное движение к текущему HTML или элементу страницы: выберите 1-2 наиболее полезных момента появления, прокрутки, перехода состояния, scene transition, Rive/Lottie-style движения иконок или GSAP/Motion-микровзаимодействия. Держите движение сдержанным, предпочитайте transform / opacity и добавьте fallback для prefers-reduced-motion.',
  'chat.designToolbox.prompt.planOutline': "Создайте или обновите Markdown-документ планирования для outline PPT/deck по этой идее. Финальную презентацию пока не генерируйте. Включите названия слайдов, цели, пункты содержания, визуальное направление, нужные данные/ассеты и открытые вопросы. Сохраните его как `.md` в Design Files и скажите, какой файл нужно проверить.",
  'chat.designToolbox.prompt.motionPolish': 'Проверьте и доработайте существующие тайминги анимации, плавность, производительность и доступность. Уберите резкую, дешёвую или ухудшающую читаемость анимацию; при необходимости используйте более выверенную временную шкалу.',
  'chat.designToolbox.prompt.transitionMotion': 'Спроектируйте качественные переходы для текущего дизайна: смену страниц/сцен, мосты загрузки, изменения состояний и переходы между секциями. Используйте GSAP/Motion/CSS там, где уместно, сохраняйте производительность и добавьте поведение для reduced motion.',
  'chat.designToolbox.prompt.threejsScene': 'Спланируйте или реализуйте сфокусированный Three.js/WebGL-визуал для текущего дизайна. Рассмотрите Three.js, сцены в духе Spline, Vanta-фоны, системы частиц, Mapbox/deck.gl data layers или эффекты browser portal, но оставьте сцену полезной и проверьте, что она рендерится.',
  'chat.designToolbox.prompt.antiAiPolish': 'Сделайте один проход доработки против «AI-ощущения»: уберите шаблонные макеты, дешёвые градиенты/свечения, бессмысленные стопки карточек и расплывчатые формулировки. Сохраните информацию и сделайте так, чтобы это выглядело работой настоящего дизайнера.',
  'chat.designToolbox.prompt.visualPolish': 'Доработайте этот дизайн до состояния готовности к выпуску: проверьте иерархию, типографику, отступы, адаптивное поведение, состояния кнопок, пустые состояния, состояния загрузки и ошибок, а также доступность; сразу исправьте самые важные проблемы.',
  'chat.designToolbox.prompt.imageGen': 'Создайте следующий план визуальных ресурсов для этого дизайна: референсы секций, hero-ресурсы, иллюстрации, иконки, изображения для соцсетей или мудборд. Сначала определите, какого изображения не хватает, затем предоставьте исполнимые промпты для генерации / план файлов.',
  'chat.designToolbox.prompt.chartGen': 'Сгенерируйте подходящий график, диаграмму или data visualization для текущего дизайна. В зависимости от данных и цели пользователя выберите ECharts, React Flow, SVG/CSS-диаграммы, radar charts, карты связей, дашборды или deck.gl/map-визуализации.',
  'chat.designToolbox.prompt.logoGen': 'Создайте направления логотипа и айдентики для текущего бренда. Подготовьте несколько маршрутов для wordmark, символа, lockup, палитры, правил использования и промптов генерации; убедитесь, что результат оригинален и применим в текущем артефакте.',
  'chat.designToolbox.prompt.videoGen': 'Разверните этот дизайн в сторону видео: создайте раскадровку короткого видео, структуру кадров Hyperframes / Remotion или готовый промпт для Sora/fal. Предпочтительно, чтобы существующий HTML / содержимое страницы естественно превращалось в кадры.',
  'chat.designToolbox.prompt.useSkill': 'Используйте {skill} в текущем дизайне.',
  'chat.designToolbox.prompt.skillInstruction': 'Сначала определите лучшую следующую цель, затем выполните один конкретный проход. Если это зависит от внешних ресурсов или API, предоставьте работоспособный запасной вариант или укажите, что мне нужно предоставить.',
  'chat.designToolbox.prompt.selectedResource': 'Выбранный ресурс: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Описание ресурса: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Используйте этот плагин как основной контекст для текущего процесса проектирования. Если он предоставляет вводные данные или GenUI, при необходимости подскажите мне, что выбрать; если он не подходит к цели, выберите более подходящий глобальный ресурс и объясните почему.',
  'chat.designToolbox.prompt.mcpResource': 'Отдавайте предпочтение этой возможности MCP для следующего шага проектирования. Когда нужны внешние ресурсы, веб-захват, генерация изображений/видео или данные, сначала определите, способна ли она справиться с задачей, затем предоставьте исполнимый план.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Этот MCP — настраиваемый шаблон. Если это самый полезный инструмент для данного шага проектирования, сначала помогите с настройкой; если уже есть настроенная альтернатива, продолжайте с ней.',
  'chat.designToolbox.prompt.connectorResource': 'Используйте этот коннектор, когда нужны реальные данные, ресурсы, содержимое аккаунта или доступ к внешнему рабочему процессу. Перед использованием объясните, что будет прочитано или записано, и при необходимости запросите подтверждение.',
  'chat.designToolbox.prompt.fileResource': 'Используйте этот файл дизайна как текущую цель проектирования или референсный ресурс и выполните из него следующий шаг. Если нужно сравнить другие файлы, продолжайте поиск по всем файлам дизайна.',
  'chat.designToolbox.prompt.resourceIndex': 'Индекс глобальных ресурсов: навыки ({skills}), плагины ({plugins}), MCP (включено: {mcpEnabled} / шаблонов: {mcpTemplates}), коннекторы (подключено: {connectors}), файлы дизайна ({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Доступные для поиска навыки',
  'chat.designToolbox.prompt.searchablePlugins': 'Доступные для поиска плагины',
  'chat.designToolbox.prompt.availableMcp': 'Доступные MCP',
  'chat.designToolbox.prompt.connectedConnectors': 'Подключённые коннекторы',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Референсные файлы дизайна',
  'chat.designToolbox.prompt.mcpTemplateName': 'Шаблон {name}',
  'chat.designToolbox.prompt.processRule': 'Правило процесса: сначала определите эстетическую цель и ограничения, затем ищите и сопоставляйте ресурсы; когда нужен выбор пользователя, создавайте структурированную форму вопросов с редактируемыми пользовательскими ответами и продолжайте после подтверждения.',
  'chat.designToolbox.prompt.moreSuffix': ', ещё +{count}',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Области упоминаний',
  'chat.mentionTabAll': 'Все',
  'chat.mentionTabTabs': 'Вкладки',
  'chat.mentionTabPlugins': 'Плагины',
  'chat.mentionTabSkills': 'Навыки',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Коннекторы',
  'chat.mentionTabFiles': 'Файлы дизайна',
  'chat.mentionNoResults': 'Нет результатов по запросу «{query}».',
  'chat.mentionSearchPrompt': 'Поиск по файлам дизайна, вкладкам, плагинам, навыкам, серверам MCP и коннекторам.',
  'chat.mentionSectionTabs': 'Вкладки',
  'chat.mentionSectionPlugins': 'Плагины',
  'chat.mentionSectionSkills': 'Навыки',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Коннекторы',
  'chat.mentionSectionFiles': 'Файлы дизайна',
  'chat.mentionActiveSkill': 'Активно',
  'chat.mentionUseMcpTitle': 'Использовать {name}',
  'chat.mentionUseConnectorTitle': 'Использовать {name}',
  'chat.mentionPluginOfficial': 'Официальный',
  'chat.mentionPluginMine': 'Мой плагин',
  'chat.linkedFolderRemoveAria': 'Удалить связанную папку {path}',
  'chat.linkedFolderNotFound': 'Папка не существует',
  'chat.linkedFolderAlready': 'Эта папка уже связана',
  'chat.linkedFolderPickError': 'Не удалось открыть выбор папки',
  'chat.queuedHeader': 'В очереди',
  'chat.queuedToSend': 'для отправки',
  'chat.queuedEditQueuedTaskAria': 'Изменить задачу в очереди',
  'chat.queuedSave': 'Сохранить',
  'chat.queuedCancel': 'Отмена',
  'chat.queuedReorder': 'Перетащите для изменения порядка',
  'chat.queuedEdit': 'Изменить',
  'chat.queuedMore': 'ещё в очереди',
  'chat.queuedFollowUpFallback': 'Продолжение в очереди',
  'chat.send': 'Отправить',
  'chat.stop': 'Остановить',
  'chat.removeAria': 'Удалить {name}',
  'chat.example1Title': 'Редакционная презентация',
  'chat.example1Tag': 'Журнал',
  'chat.example1Prompt': '10-слайдовая редакционная презентация для дизайн-студии, привлекающей посевной раунд — швейцарская сетка, крупные заголовки с засечками и жирными буквицами, моноширинные номера секций, много негативного пространства и полноформатные фотослайды, чередующиеся с текстовыми. Обложка, видение, рынок, продукт, тракция, команда, запрос, контакт.',
  'chat.example2Title': 'SaaS аналитическая панель',
  'chat.example2Tag': 'Данные',
  'chat.example2Prompt': 'Насыщенная аналитическая панель для SaaS-инструментов разработчика — полоса KPI с динамикой неделя к неделе, две составные линейные диаграммы (MRR и активные рабочие пространства), мировая тепловая карта использования, когортная матрица удержания, таблица лидеров по ключевым клиентам и лента событий в реальном времени. Тёмная тема, табличные моноширинные цифры, акцентные мини-графики.',
  'chat.example3Title': 'Годовой отчет с длинной прокруткой',
  'chat.example3Tag': 'Редакционный',
  'chat.example3Prompt': 'Интерактивный годовой отчёт для климатической некоммерческой организации — редакционный макет с длинной прокруткой, сочетающий крупные цитатные блоки, визуализации данных (составные столбчатые диаграммы, анимированные счётчики, хороплетную карту проектных площадок), фотографические разделители, стену доноров и финальный призыв к действию. Современный serif для основного текста, sans-serif для подписей графиков и землистая бумажная палитра.',
  'home.recommendation.eyebrow': 'Рекомендовано для вас',
  'home.recommendation.primaryCta': 'Начать создание',
  'home.recommendation.change': 'Попробовать другой',
  'home.recommendation.browseAll': 'Все типы',
  'home.recommendation.defaultProjectName': 'Новый проект',
  'home.recommendation.startFailed': 'Не удалось начать создание. Попробуйте снова.',
  'studio.firstArtifactHint.title': 'Ваш первый дизайн готов',
  'studio.firstArtifactHint.body': 'Попробуйте отредактировать и добавить пометки — экспортируйте или поделитесь, когда будете довольны.',
  'studio.firstArtifactHint.dismiss': 'Понятно',
  'home.starter.product_ui_prototype.title': 'Начните с редактируемого прототипа продукта',
  'home.starter.product_ui_prototype.desc': 'Исходя из вашей цели, начните с кликабельного интерфейса, который можно доработать.',
  'home.starter.product_ui_prototype.firstPrompt': 'Спроектируйте редактируемый прототип продукта для [ваш продукт] с ключевыми экранами и понятным основным сценарием.',
  'home.starter.product_ui_component.title': 'Начните с переиспользуемого компонента',
  'home.starter.product_ui_component.desc': 'Сначала создайте один компонент, затем соберите из него полноценные экраны.',
  'home.starter.product_ui_component.firstPrompt': 'Спроектируйте переиспользуемый компонент [название компонента] с его основными состояниями и вариантами.',
  'home.starter.product_ui_lowfi.title': 'Начните с прототипа низкой детализации',
  'home.starter.product_ui_lowfi.desc': 'Сначала набросайте структуру, затем повышайте детализацию.',
  'home.starter.product_ui_lowfi.firstPrompt': 'Создайте низкодетализированный каркас основных экранов для [ваш продукт].',
  'home.starter.marketing_landing.title': 'Начните с целевой страницы',
  'home.starter.marketing_landing.desc': 'Превратите свою кампанию в целевую страницу, готовую к запуску.',
  'home.starter.marketing_landing.firstPrompt': 'Спроектируйте целевую страницу для [ваш продукт] с hero-блоком, ключевыми преимуществами и понятным призывом к действию.',
  'home.starter.marketing_multivariant.title': 'Начните с нескольких вариантов целевой страницы',
  'home.starter.marketing_multivariant.desc': 'Сгенерируйте несколько версий для сравнения, прежде чем принять решение.',
  'home.starter.marketing_multivariant.firstPrompt': 'Создайте 3 варианта целевой страницы для [ваш продукт] с разными hero-сообщениями для сравнения.',
  'home.starter.internal_dashboard.title': 'Начните с внутренней панели',
  'home.starter.internal_dashboard.desc': 'Начните с макета панели для вашего рабочего процесса.',
  'home.starter.internal_dashboard.firstPrompt': 'Спроектируйте внутреннюю панель, показывающую [ключевые метрики] с фильтрами и таблицей данных.',
  'home.starter.internal_report.title': 'Начните с отчёта',
  'home.starter.internal_report.desc': 'Опишите данные и поля, которые вы хотите видеть.',
  'home.starter.internal_report.firstPrompt': 'Создайте страницу отчёта, обобщающую [опишите данные, поля и метрики, которые вас интересуют].',
  'home.starter.general_menu.title': 'Начните с вашего первого проекта',
  'home.starter.general_menu.desc': 'Опишите, что вы хотите, и мы сгенерируем редактируемую первую версию.',
  'home.starter.general_menu.firstPrompt': 'Создайте редактируемую первую версию [опишите, что вы хотите сделать].',
  'chat.example4Title': 'Продуктовое motion-видео',
  'chat.example4Tag': 'Моушн',
  'chat.example4Prompt': 'Создайте сториборд 15-секундного motion-видео для запуска приложения продуктивности: вступительный хук, крупные планы UI, кинетическая типографика, переходы функций, финальный логотип и CTA. Укажите тайминг, сцены, движение камеры и экранный текст.',
  'preview.usePlugin': 'Использовать плагин',
  'preview.usePluginOnly': 'Использовать без промпта',
  'preview.usePluginOnlyDesc': 'Использовать структуру плагина без загрузки примерного промпта',
  'preview.replicateContent': 'Использовать',
  'preview.replicateContentDesc': 'Использовать пример промпта, чтобы воспроизвести превью',
  'preview.duplicateTemplate': 'Ремикс',
  'preview.duplicateTemplateDesc': 'Сделать ремикс этого примера в новый редактируемый проект',
  'preview.shareMenu': 'Поделиться',
  'preview.exportMenu': 'Экспорт',
  'preview.shareTemplateBadge': 'Шаблон',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Скопировать ссылку на шаблон',
  'preview.copyShareText': 'Скопировать текст для публикации',
  'preview.shareSocialGroup': 'Поделиться в соцсетях',
  'preview.shareCopyGroup': 'Копировать',
  'preview.shareExportGroup': 'Экспортировать файлы',
  'preview.shareCopied': 'Скопировано',
  'preview.shareCopyFailed': 'Не удалось скопировать',
  'preview.shareTextDefault': 'Шаблон OpenDesign: {title}',
  'preview.openInNewTab': 'Открыть в новой вкладке',
  'preview.exit': '⤓ Выход',
  'preview.fullscreen': '⤢ Полноэкранный',
  'preview.closeTitle': 'Закрыть (Esc)',
  'preview.loading': 'Загрузка {label}…',
  'preview.errorTitle': 'Не удалось загрузить этот пример.',
  'preview.errorBody': 'Не удалось получить HTML примера. Убедитесь, что OpenDesign запущен, и повторите попытку.',
  'preview.retry': 'Повторить',
  'preview.unavailableTitle': 'Для {noun} нет встроенного предпросмотра.',
  'preview.unavailableBody': 'Запустите запрос в чате, чтобы сгенерировать {kind}-вывод.',
  'preview.nounSkill': 'этого навыка',
  'preview.nounPlugin': 'этого плагина',
  'preview.nounTemplate': 'этого шаблона',
  'preview.showSidebar': 'Показать {label}',
  'preview.hideSidebar': 'Скрыть {label}',
  'misc.savedTemplate': 'Сохраненный шаблон',
  'misc.primary': 'Основной',
  'misc.designSystem': 'Дизайн-система',
  'workspace.designFiles': 'Файлы дизайна',
  'workspace.focusMode': 'Фокус на рабочей области',
  'workspace.showChat': 'Показать чат',
  'workspace.closeTab': 'Закрыть вкладку',
  'workspace.fileSyncDownloading': 'Загрузка от команды…',
  'workspace.fileSyncUploading': 'Синхронизация с командой…',
  'workspace.deleteFileConfirm': 'Удалить «{name}» из папки проекта?',
  'workspace.readonlyNotice': 'Это общий проект — вы можете просматривать и комментировать, но не можете изменять артефакты через Чат или инструменты редактирования.',
  'workspace.readonlyNoticeBy': 'Это общий проект, созданный {owner} — вы можете просматривать и комментировать, но не можете изменять артефакты через Чат или инструменты редактирования.',
  'workspace.deleteSelectedFilesConfirm': 'Удалить {n} выбранных файла(ов) из папки проекта?',
  'workspace.deleteSelectedFilesPartial': 'Не удалось удалить {n} файл(ов).',
  'workspace.openFromDesignFiles': 'Открыть файл из',
  'workspace.designFilesLink': 'Файлы дизайна',
  'workspace.loadingSketch': 'Загрузка эскиза…',
  'workspace.newTab': 'Новая вкладка',
  'workspace.searchFilesPlaceholder': 'Поиск файлов…',
  'workspace.openTabs': 'Открыть вкладки',
  'workspace.searchTabs': 'Search tabs',
  'workspace.noTabsFound': 'No tabs found',
  'workspace.openFile': 'Открыть файл',
  'workspace.noFilesMatch': 'Нет подходящих файлов',
  'workspace.allFiles': 'Все',
  'workspace.createNew': 'Создать',
  'workspace.tabOpen': 'Открыт',
  'workspace.sideChatContextBanner': 'Контекст текущего разговора интегрирован',
  'workspace.sideChatDefaultTitle': 'Боковой чат',
  'workspace.newTerminal': 'Новый терминал',
  'workspace.newTerminalDescription': 'Открыть оболочку в каталоге проекта в новой вкладке',
  'workspace.newBrowser': 'Новый браузер',
  'workspace.newBrowserDescription': 'Открыть встроенную вкладку браузера для справочных сайтов и задач',
  'workspace.newSketchDescription': 'Набросайте черновые макеты и заметки как дизайн-контекст для агента',
  'workspace.terminalStarting': 'Запуск терминала…',
  'workspace.terminalStartingDescription': 'Подготавливаем оболочку проекта. Обычно это занимает несколько секунд.',
  'workspace.terminalSessionEnded': 'Сеанс завершён',
  'workspace.terminalReconnecting': 'Переподключение…',
  'workspace.terminalStartFailed': 'Не удалось запустить сеанс терминала',
  'workspace.terminalRestart': 'Перезапустить',
  'designFiles.title': 'Файлы дизайна',
  'designFiles.upload': 'Загрузить файлы',
  'designFiles.pasteText': 'Вставить как текстовый файл',
  'designFiles.newSketch': 'Новый эскиз',
  'designFiles.newDocument': 'Новый документ',
  'designFiles.newDocumentTitle': 'Создать новый документ Markdown',
  'designFiles.empty': 'Здесь появятся ваши работы',
  'designFiles.syncing': 'Синхронизация файлов, которыми поделилась команда…',
  'designFiles.refresh': 'Обновить',
  'designFiles.delete': 'Удалить',
  'designFiles.searchPlaceholder': 'Поиск файлов…',
  'designFiles.up': 'Вверх',
  'designFiles.back': 'Назад',
  'designFiles.crumbs': 'проект',
  'designFiles.rowMenu': 'Меню строки',
  'designFiles.openInTab': 'Открыть во вкладке',
  'designFiles.download': 'Скачать',
  'designFiles.downloadSelected': 'Скачать {n} как ZIP',
  'designFiles.deleteSelected': 'Удалить {n}',
  'designFiles.clearSelection': 'Очистить выделение',
  'designFiles.selectPage': 'Выбрать всё на странице',
  'designFiles.selectAll': 'Выбрать всё',
  'designFiles.dropTitle': '⤓ Перетащите файлы сюда',
  'designFiles.dropDesc': 'Изображения, документы, референсы или папки — агент будет использовать их как контекст.',
  'designFiles.dropLabel': 'Перетащите файлы сюда',
  'designFiles.upload.title': 'Загрузить файлы',
  'designFiles.paste.title': "Вставить текст как файл",
  'designFiles.upload.label': 'Загрузить',
  'designFiles.paste.label': "Вставить",
  'designFiles.documentTemplate.titleFallback': 'Документ',
  'designFiles.documentTemplate.goalHeading': 'Цель',
  'designFiles.documentTemplate.goalBody': 'Опишите, что OpenDesign должен сгенерировать, отредактировать или решить на основе этого документа.',
  'designFiles.documentTemplate.capabilitiesHeading': 'Как использовать этот документ',
  'designFiles.documentTemplate.capabilityMarkdown': 'Используйте любой Markdown-формат: заголовки, таблицы, чек-листы, ссылки, цитаты, блоки кода и изображения.',
  'designFiles.documentTemplate.capabilityAgent': 'Агент OpenDesign может читать, редактировать и использовать этот файл как контекст проекта.',
  'designFiles.documentTemplate.capabilityImages': 'Вставляйте изображения или перетаскивайте файлы изображений в редактор; загруженные изображения вставляются в позицию курсора.',
  'designFiles.documentTemplate.scenarioHeading': 'Гайд по сценариям',
  'designFiles.documentTemplate.scenario.prototype': 'Для прототипов опишите цель продукта, целевых пользователей, потоки, экраны, модули, состояния взаимодействия, адаптивные брейкпоинты и дизайн-токены: цвет, типографику, отступы, радиусы и движение.',
  'designFiles.documentTemplate.scenario.wireframe': 'Для вайрфреймов опишите пользовательский поток, список экранов, иерархию макета, контентные блоки, ограничения низкой детализации и вопросы, на которые структура должна ответить до визуального дизайна.',
  'designFiles.documentTemplate.scenario.mobile': 'Для мобильных приложений перечислите целевые платформы, экраны, модель навигации, жесты, нативные паттерны, размеры устройств, состояния и мобильные дизайн-токены.',
  'designFiles.documentTemplate.scenario.slideDeck': 'Для слайдов напишите постраничный outline PPT: по одному разделу на слайд с заголовком, целью, ключевым сообщением, доказательствами, визуальным направлением, заметками спикера и требованиями к экспорту.',
  'designFiles.documentTemplate.scenario.document': 'Для документов определите аудиторию, тон, структуру разделов, исходные материалы, цитаты или данные, ожидания к верстке и требования к PDF/экспорту.',
  'designFiles.documentTemplate.scenario.image': 'Для изображений укажите объект, соотношение сторон, композицию, визуальный стиль, бренд-токены, референсные файлы и негативные ограничения.',
  'designFiles.documentTemplate.scenario.video': 'Для видео набросайте сториборд со сценами, таймингом, титрами, движением, ассетами, заметками по аудио и форматом результата.',
  'designFiles.documentTemplate.scenario.hyperframes': 'Для HyperFrames опишите HTML motion-piece: сцены, таймлайн, титры, аудиореактивные моменты, переходы и требования к захвату/экспорту.',
  'designFiles.documentTemplate.scenario.audio': 'Для аудио определите направление голоса или музыки, длительность, настроение, сценарий или текст, темп, заметки по произношению и финальное использование.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'Для live-артефактов опишите источники данных, частоту обновления, виджеты, фильтры, взаимодействия, пустые/загрузочные/ошибочные состояния и любые оповещения или автоматизации.',
  'designFiles.documentTemplate.scenario.designSystem': 'Для дизайн-систем перечислите цели бренда, токены, типографику, цвет, отступы, компоненты, ассеты, референсы и правила, которых нужно придерживаться или избегать.',
  'designFiles.documentTemplate.scenario.default': 'Опишите аудиторию, результат, нужный контент, референсы, ограничения и критерии готовности.',
  'designFiles.documentTemplate.nextHeading': 'Следующий шаг',
  'designFiles.documentTemplate.nextBody': 'Проверьте и отредактируйте этот документ, затем попросите OpenDesign сгенерировать, доработать или выполнить работу на его основе.',

  'designFiles.projectMenu': 'Действия проекта',
  'designFiles.createDesignSystemFromProject': 'Создать дизайн-систему из этого проекта',
  'designFiles.duplicateProject': 'Дублировать проект',

  'designFiles.previewOpen': 'Открыть',
  'designFiles.previewClose': 'Закрыть предпросмотр',
  'designFiles.modified': 'Изменено {time} · {size}',
  'designFiles.weeksAgo': '{n} нед. назад',
  'designFiles.groupBy': 'Группировать по',
  'designFiles.groupByKind': 'Тип',
  'designFiles.groupByModified': 'Изменено',
  'designFiles.filterBy': 'Фильтр по типу',
  'designFiles.filterClear': 'Очистить',
  'designFiles.filterCount': 'типов: {n}',
  'designFiles.expandGroup': 'Развернуть',
  'designFiles.collapseGroup': 'Свернуть',
  'designFiles.sectionPages': 'Страницы',
  'designFiles.sectionScripts': 'Скрипты',
  'designFiles.sectionImages': 'Изображения',
  'designFiles.sectionSketches': 'Эскизы',
  'designFiles.sectionLiveArtifacts': 'Live-артефакты',
  'designFiles.sectionOther': 'Другое',
  'designFiles.modifiedToday': 'Сегодня',
  'designFiles.modifiedYesterday': 'Вчера',
  'designFiles.modifiedPrevious7Days': 'Последние 7 дней',
  'designFiles.modifiedPrevious30Days': 'Последние 30 дней',
  'designFiles.modifiedOlder': 'Старше',
  'designFiles.showMore': 'Показать ещё +{n}',
  'designFiles.kindHtml': 'HTML страница',
  'designFiles.kindImage': 'Изображение',
  'designFiles.kindSketch': 'Эскиз',
  'designFiles.kindText': 'Текст',
  'designFiles.kindCode': 'Скрипт',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Документ',
  'designFiles.kindPresentation': 'Презентация',
  'designFiles.kindSpreadsheet': 'Таблица',
  'designFiles.kindLiveArtifact': 'Live-артефакт',
  'designFiles.kindBinary': 'Бинарный',
  'designFiles.kindFolder': 'Папка',
  'designFiles.folderCount': '{n} файлов',
  'designFiles.newFolderTitle': 'Новая папка',
  'designFiles.newFolderLabel': 'Имя папки',
  'designFiles.moveTitle': 'Переместить в папку',
  'designFiles.moveLabel': 'Папка назначения',
  'designFiles.moveRoot': 'Корень проекта',
  'designFiles.moveNewFolder': 'Новая папка…',
  'designFiles.move': 'Переместить',
  'designFiles.copyPath': 'Скопировать путь',
  'designFiles.copiedPath': 'Путь скопирован',
  'designFiles.copyLocalPath': 'Скопировать локальный путь к файлу',
  'designFiles.copiedLocalPath': 'Локальный путь к файлу скопирован',
  'designFiles.deleteFolderConfirm': 'Удалить папку «{name}» со всем содержимым?',
  'designFiles.folderCreated': 'Папка «{name}» создана',
  'designFiles.folderDeleted': 'Папка «{name}» удалена',
  'designFiles.filesMoved': 'Перемещено {n} в {dest}',
  'designFiles.colName': 'Имя',
  'designFiles.colKind': 'Тип',
  'designFiles.colModified': 'Изменён',
  'designFiles.perPage': 'Показать',
  'designFiles.all': 'Все',
  'designFiles.prev': 'Назад',
  'designFiles.next': 'Вперёд',
  'designFiles.jumpToPage': 'Перейти на страницу',
  'designFiles.pageInfo': '{start}–{end} из {total}',
  'designFiles.sectionFolders': 'Папки',
  'designFiles.sectionStylesheets': 'Таблицы стилей',
  'designFiles.sectionDocuments': 'Документы',
  'designFiles.kindStylesheet': 'Таблица стилей',
  'designFiles.modifiedExt': 'Изменено {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Полезная информация',
  'designFiles.usefulInfoTip': 'Дважды щёлкните по любому файлу, чтобы открыть его в отдельной вкладке.',
  'designFiles.usefulInfoTip2': 'Введите @ в чате, чтобы добавить файл как контекст.',
  'designFiles.usefulInfoTip4': 'Выберите дизайн-систему — результат будет в стиле бренда.',
  'designFiles.usefulInfoTip5': 'Нет идей? Попробуйте шаблон плагина в разделе «Сообщество» на главной.',
  'designFiles.usefulInfoTip6': 'Вопросы или идеи? Присоединяйтесь к нам в Discord.',
  'designFiles.usefulInfoTip7': 'Нравится OpenDesign? Поставьте звезду на GitHub.',
  'designFiles.usefulInfoTip8': 'Подписывайтесь на @OpenDesignHQ в X, чтобы не пропустить новинки.',
  'designFiles.usefulInfoTip9': 'Перетащите изображения, документы или целые папки в эту панель — агент использует их как контекст.',
  'designFiles.usefulInfoTip10': 'Нажмите «Новый эскиз», нарисуйте макет — агент сгенерирует дизайн по нему.',
  'designFiles.usefulInfoTip11': 'Выделите любой элемент в предпросмотре и оставьте комментарий — агент внесёт точечные правки.',
  'designFiles.usefulInfoTip12': 'Не нравится результат? Обвести элемент быстрее, чем описывать заново.',
  'designFiles.usefulInfoTip13': 'Любой дизайн экспортируется в PDF, изображение или автономный HTML в один клик.',
  'designFiles.usefulInfoTip14': 'Довольны проектом? Сохраните его как шаблон через меню «Поделиться».',
  'designFiles.usefulInfoTip15': 'После деплоя можно сразу создать карточки для соцсетей.',
  'designFiles.usefulInfoTip16': 'Подписывайтесь на @opendesign.ai в Threads, чтобы видеть новости из-за кулис.',
  'designFiles.usefulInfoTip17': 'Подписывайтесь на @opendesign.ai в Instagram за дизайн-вдохновением.',
  'designFiles.usefulInfoTip18': 'Подпишитесь на OpenDesign на YouTube ради туториалов и демо.',
  'designFiles.usefulInfoTip19': 'Подписывайтесь на OpenDesign в LinkedIn за новостями продукта.',
  'designFiles.usefulInfoTip20': 'Подписывайтесь на OpenDesign в Xiaohongshu за советами и вдохновением.',
  'quickSwitcher.placeholder': 'Открыть файл…',
  'quickSwitcher.empty': 'В проекте нет файлов',
  'quickSwitcher.noMatches': 'Нет совпадений',
  'quickSwitcher.navigate': 'навигация',
  'quickSwitcher.open': 'открыть',
  'quickSwitcher.close': 'закрыть',
  'pasteDialog.title': 'Вставить текст',
  'pasteDialog.hint': 'Сохраняется в папку проекта. Выберите любое имя.',
  'pasteDialog.fileNameLabel': 'Имя файла',
  'pasteDialog.namePlaceholder': 'заметки.txt',
  'pasteDialog.contentLabel': 'Содержимое',
  'pasteDialog.contentPlaceholder': 'Вставьте что угодно…',
  'pasteDialog.save': 'Сохранить',
  'pasteDialog.cancel': 'Отмена',
  'sketch.save': 'Сохранить эскиз',
  'sketch.cancel': 'Отмена',
  'sketch.saving': 'Сохранение…',
  'sketch.saved': 'Сохранено',
  'sketch.tooltipMainMenu': 'Главное меню: сохранение, экспорт, справка и настройки холста',
  'sketch.tooltipLock': "Оставить текущий инструмент рисования активным для повторного использования",
  'sketch.tooltipHand': "Перемещать холст, не выбирая объекты",
  'sketch.tooltipSelection': "Выбирать, перемещать, изменять размер или редактировать объекты на холсте",
  'sketch.tooltipRectangle': "Нарисовать прямоугольник или область карточки",
  'sketch.tooltipDiamond': "Нарисовать ромб для решения или ветвления структуры",
  'sketch.tooltipEllipse': "Нарисовать круг или эллипс",
  'sketch.tooltipArrow': "Нарисовать направленный коннектор или стрелку потока",
  'sketch.tooltipLine': "Нарисовать прямой разделитель или соединительную линию",
  'sketch.tooltipFreedraw': "Рисовать линии от руки на холсте",
  'sketch.tooltipText': "Добавить редактируемый текст на холст",
  'sketch.tooltipImage': "Вставить изображение на холст",
  'sketch.tooltipEraser': "Стереть объекты с холста",
  'sketch.tooltipFrame': "Создать фрейм для группировки области холста",
  'sketch.tooltipEmbeddable': "Web Embed поддерживает только корректные ссылки https:// или http://",
  'sketch.tooltipLaser': "Временно указать на содержимое холста, не изменяя его",
  'sketch.tooltipMoreTools': "Открыть дополнительные инструменты: фрейм, web embed и лазерную указку",
  'sketch.tooltipDirty': 'Несохраненные изменения',
  'sketch.tooltipClean': 'Сохранено',
  'fileViewer.empty': 'Выберите файл для просмотра.',
  'fileViewer.loading': 'Загрузка…',
  'fileViewer.exportPptx': 'Экспорт в PPTX',
  'fileViewer.openInNewTab': 'Открыть в новой вкладке',
  'fileViewer.copyPath': 'Копировать путь',
  'fileViewer.copied': 'Скопировано!',
  'fileViewer.share': 'Поделиться',
  'fileViewer.binaryMeta': 'Бинарный · {size}',
  'fileViewer.binaryNote': 'Бинарный файл ({size} байт). Скачайте или откройте с диска для просмотра.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Документ',
  'fileViewer.presentationMeta': 'Презентация',
  'fileViewer.spreadsheetMeta': 'Таблица',
  'fileViewer.previewUnavailable': 'Предпросмотр недоступен. Скачайте или откройте файл для просмотра.',
  'fileViewer.download': 'Скачать',
  'fileViewer.open': 'Открыть',
  'fileViewer.imageMeta': 'Изображение · {size}',
  'fileViewer.reactMeta': 'React-компонент · {size}',
  'fileViewer.sketchMeta': 'Эскиз · {size}',
  'fileViewer.markdownStreamingMeta': 'Потоковый предпросмотр…',
  'fileViewer.markdownErrorMeta': 'Предпросмотр может быть неполным (ошибка генерации).',
  'fileViewer.markdownStreamingStatus': 'Потоковая передача… показан частичный Markdown.',
  'fileViewer.markdownErrorStatus': 'Ошибка генерации. Показано последнее доступное содержимое.',
  'fileViewer.markdownSaving': "Сохраняем...",
  'fileViewer.markdownSaveFailed': "Не удалось сохранить",
  'fileViewer.markdownSaved': "Сохранено",
  'fileViewer.markdownAutoSaved': "Автосохранено · {time}",
  'fileViewer.markdownAutoSaveHint': "Автосохранение включено",
  'fileViewer.markdownViewMode': "Режим просмотра Markdown",
  'fileViewer.split': "Разделить",
  'fileViewer.markdownEditor': "Markdown-редактор",
  'fileViewer.markdownEditorPlaceholder': "Введите заметки, требования или инструкции для этого документа...",
  'fileViewer.markdownPreview': "Предпросмотр Markdown",
  'fileViewer.videoMeta': 'Видео · {size}',
  'fileViewer.audioMeta': 'Аудио · {size}',
  'fileViewer.reload': 'Перезагрузить',
  'fileViewer.reloadDisk': 'Перезагрузить с диска',
  'fileViewer.copy': 'Копировать',
  'fileViewer.copyTitle': 'Копировать содержимое файла',
  'fileViewer.saveDisabled': 'Сохранить (только для чтения)',
  'fileViewer.save': 'Сохранить',
  'fileViewer.preview': 'Предпросмотр',
  'fileViewer.source': 'Исходный код',
  'fileViewer.tweaks': 'Настройки',
  'fileViewer.tweaksUnavailable': 'В этом артефакте нет панели настроек',
  'fileViewer.jsxModuleTitle': 'Нет отдельного предпросмотра',
  'fileViewer.jsxModuleBody': 'Этот файл является модулем компонента, который загружает другая страница.',
  'fileViewer.jsxModuleCta': 'Откройте страницу, которая его отображает:',
  'fileViewer.comment': 'Комментарий',
  'fileViewer.edit': 'Редактировать',
  'fileViewer.draw': 'Рисовать',
  'fileViewer.mark': 'Пометить',
  'fileViewer.markTool': 'Инструмент пометки',
  'fileViewer.boxSelect': 'Выбрать область',
  'fileViewer.textTool': 'Текст',
  'fileViewer.textAnnotationRemove': 'Удалить текст',
  'fileViewer.screenshot': 'Скриншот',
  'fileViewer.versions.entry': 'Версии',
  'fileViewer.versions.entryFull': 'История версий',
  'fileViewer.versions.title': 'Версии',
  'fileViewer.versions.countOne': '1 версия',
  'fileViewer.versions.countMany': '{count} версий',
  'fileViewer.versions.current': 'Текущая',
  'fileViewer.versions.sourceAi': 'AI-правка',
  'fileViewer.versions.sourceManual': 'Ручная правка',
  'fileViewer.versions.sourceRestore': 'Восстановлено',
  'fileViewer.versions.restoredFrom': 'Восстановлено из v{version}',
  'fileViewer.versions.versionLabel': 'Версия {version}',
  'fileViewer.versions.listAria': 'Версии файла',
  'fileViewer.versions.loading': 'Загрузка версий...',
  'fileViewer.versions.empty': 'Версий пока нет.',
  'fileViewer.versions.loadFailed': 'Не удалось загрузить версии.',
  'fileViewer.versions.previewFailed': 'Не удалось загрузить предпросмотр этой версии.',
  'fileViewer.versions.previewLoading': 'Загрузка предпросмотра версии...',
  'fileViewer.versions.noPrompt': 'Промпт не записан',
  'fileViewer.versions.noPromptBody': 'Для этой версии промпт не записан.',
  'fileViewer.versions.promptTitle': 'Промпт',
  'fileViewer.versions.copyPrompt': 'Скопировать промпт',
  'fileViewer.versions.fullscreen': 'Полноэкранный предпросмотр',
  'fileViewer.versions.open': 'Открыть предпросмотр в новом окне',
  'fileViewer.versions.currentHelp': 'Это уже текущая версия.',
  'fileViewer.versions.restoreHelp': 'Переключение восстановит этот HTML как новую текущую версию.',
  'fileViewer.versions.restore': 'Переключиться на эту версию',
  'fileViewer.versions.restoreConfirmTitle': 'Переключиться на эту версию?',
  'fileViewer.versions.restoreConfirmCta': 'Переключить',
  'fileViewer.versions.restoring': 'Переключение...',
  'fileViewer.versions.restoreFailed': 'Не удалось переключиться на эту версию.',
  'fileViewer.versions.restoreSuccess': 'Переключено на эту версию.',
  'fileViewer.editScreenshotToChat': 'Скриншот в чат',
  'manualEdit.layers': 'Слои',
  'manualEdit.editableCount': 'редактируемых: {count}',
  'manualEdit.hiddenBadge': 'Скрыто',
  'manualEdit.title': 'Ручной редактор',
  'manualEdit.fallbackTitle': 'Редактировать',
  'manualEdit.movePanel': 'Переместить панель редактирования',
  'manualEdit.editParams': 'Изменить параметры',
  'manualEdit.closePanel': 'Закрыть панель редактирования',
  'manualEdit.selectLayer': 'Выберите слой',
  'manualEdit.empty': 'Щёлкните элемент в предпросмотре или выберите слой.',
  'manualEdit.noEditableLayers': 'Редактируемые слои не найдены.',
  'manualEdit.noClass': 'без класса',
  'manualEdit.tabsAria': 'Вкладки ручного редактирования',
  'manualEdit.tabContent': 'Содержимое',
  'manualEdit.tabStyle': 'Стиль',
  'manualEdit.tabAttributes': 'Атрибуты',
  'manualEdit.tabHtml': 'HTML',
  'manualEdit.tabSource': 'Исходный код',
  'manualEdit.attributesJson': 'Атрибуты JSON',
  'manualEdit.selectedHtml': 'HTML выбранного элемента',
  'manualEdit.fullSource': 'Полный исходный код артефакта',
  'manualEdit.applyContent': 'Применить содержимое',
  'manualEdit.applyStyle': 'Применить стиль',
  'manualEdit.applyAttributes': 'Применить атрибуты',
  'manualEdit.applyHtml': 'Применить HTML',
  'manualEdit.applySource': 'Применить исходный код',
  'manualEdit.invalidAttributes': 'Некорректный JSON атрибутов.',
  'manualEdit.changes': 'Изменения',
  'manualEdit.undo': 'Отменить',
  'manualEdit.redo': 'Повторить',
  'manualEdit.noChanges': 'Ручных изменений пока нет.',
  'manualEdit.imageUrl': 'URL изображения',
  'manualEdit.altText': 'Замещающий текст',
  'manualEdit.label': 'Метка',
  'manualEdit.text': 'Текст',
  'manualEdit.href': 'Ссылка (href)',
  'manualEdit.textColor': 'Цвет текста',
  'manualEdit.background': 'Фон',
  'manualEdit.fontSize': 'Размер шрифта',
  'manualEdit.weight': 'Насыщенность',
  'manualEdit.align': 'Выравнивание',
  'manualEdit.textAlignLeft': 'По левому краю',
  'manualEdit.textAlignCenter': 'По центру',
  'manualEdit.textAlignRight': 'По правому краю',
  'manualEdit.padding': 'Внутренние отступы',
  'manualEdit.margin': 'Внешние отступы',
  'manualEdit.radius': 'Скругление',
  'manualEdit.referenceValues': 'Эталонные значения',
  'manualEdit.referenceValuesEmpty': 'Нет подходящих эталонных значений',
  'manualEdit.referenceValuesLoading': 'Загрузка…',
  'manualEdit.lineHeight': 'Высота строки',
  'manualEdit.letterSpacing': 'Межбуквенный интервал',
  'manualEdit.borderStyle': 'Стиль границы',
  'manualEdit.borderStyleSolid': 'Сплошная',
  'manualEdit.borderStyleDashed': 'Штриховая',
  'manualEdit.borderStyleDotted': 'Пунктирная',
  'manualEdit.borderStyleDouble': 'Двойная',
  'manualEdit.borderStyleNone': 'Нет',
  'manualEdit.border': 'Граница',
  'manualEdit.width': 'Ширина',
  'manualEdit.minHeight': 'Мин. высота',
  'manualEdit.deleteElement': 'Удалить элемент',
  'manualEdit.deleteElementConfirm': 'Удалить выбранный элемент? Это действие можно отменить через «Отменить».',
  'manualEdit.alignCenter': "Center",
  'manualEdit.opacity': "Opacity",
  'manualEdit.uploadImage': 'Загрузить изображение',
  'manualEdit.uploadingImage': 'Загрузка изображения…',
  'manualEdit.uploadImageFailed': 'Не удалось загрузить изображение.',
  'manualEdit.focusSlides': 'Фокус на слайдах',
  'manualEdit.showPanels': 'Показать панели',
  'manualEdit.parameters': "Parameters",
  'manualEdit.fontFamily': "Font",
  'manualEdit.borderColor': "Border color",
  'manualEdit.borderWidth': "Border width",
  'manualEdit.height': "Height",
  'manualEdit.sideTop': "Top",
  'manualEdit.sideBottom': "Bottom",
  'manualEdit.sideLeft': "Left",
  'manualEdit.sideRight': "Right",
  'manualEdit.layoutDirection': "Direction",
  'manualEdit.distribution': "Distribution",
  'manualEdit.gap': "Gap",
  'manualEdit.layoutUnavailable': "Layout controls are available for flex or grid containers.",
  'manualEdit.directionRow': "Horizontal",
  'manualEdit.directionRowReverse': "Horizontal reverse",
  'manualEdit.directionColumn': "Vertical",
  'manualEdit.directionColumnReverse': "Vertical reverse",
  'manualEdit.justifyStart': "Start",
  'manualEdit.justifyCenter': "Center",
  'manualEdit.justifyEnd': "End",
  'manualEdit.justifyBetween': "Space between",
  'manualEdit.justifyAround': "Space around",
  'manualEdit.justifyEvenly': "Space evenly",
  'manualEdit.alignStart': "Start",
  'manualEdit.alignEnd': "End",
  'manualEdit.alignStretch': "Stretch",
  'manualEdit.alignBaseline': "Baseline",
  'fileViewer.zoomOut': 'Уменьшить',
  'fileViewer.zoomIn': 'Увеличить',
  'fileViewer.resetZoom': 'Сбросить масштаб',
  'fileViewer.viewportAria': 'Область предпросмотра',
  'fileViewer.viewportDesktop': 'Десктоп',
  'fileViewer.viewportDesktopTitle': 'Полноширинный десктопный предпросмотр',
  'fileViewer.viewportTablet': 'Планшет',
  'fileViewer.viewportTabletTitle': 'Предпросмотр на планшете при 820 × 1180 (современный базовый портретный формат)',
  'fileViewer.viewportMobile': 'Мобильный',
  'fileViewer.viewportMobileTitle': 'Предпросмотр на мобильном при 390 × 844',
  'fileViewer.reloadAria': 'Перезагрузить',
  'fileViewer.previousSlide': 'Предыдущий слайд',
  'fileViewer.nextSlide': 'Следующий слайд',
  'fileViewer.slideNavAria': 'Навигация по слайдам',
  'fileViewer.speakerNotes': 'Заметки докладчика',
  'fileViewer.speakerNotesSlide': 'Слайд {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'Для этого слайда нет заметок докладчика.',
  'fileViewer.speakerNotesEdit': 'Изменить',
  'fileViewer.speakerNotesSave': 'Сохранить заметки',
  'fileViewer.speakerNotesSaving': 'Сохранение…',
  'fileViewer.speakerNotesSaved': 'Сохранено',
  'fileViewer.speakerNotesSaveFailed': 'Не удалось сохранить заметки докладчика.',
  'fileViewer.speakerNotesPlaceholder': 'Добавьте заметки докладчика для этого слайда…',
  'fileViewer.previewAssetBlockedTitle': 'Ресурс предпросмотра заблокирован',
  'fileViewer.previewAssetBlockedDetail': 'Не удалось загрузить {filePath}. Замените внешние символические ссылки файлами внутри этого проекта.',
  'fileViewer.presenterReset': 'Сбросить',
  'fileViewer.present': 'Презентация',
  'fileViewer.presentInTab': 'В этой вкладке',
  'fileViewer.presentFullscreen': 'Полноэкранный',
  'fileViewer.presentNewTab': 'Новая вкладка',
  'fileViewer.presentFromBeginning': 'Начать с начала',
  'fileViewer.presentFromCurrentSlide': 'Начать с текущего слайда',
  'fileViewer.presenterMode': 'Режим докладчика',
  'fileViewer.exitPresentation': 'Выйти из презентации',
  'fileViewer.shareLabel': 'Поделиться',
  'fileViewer.shareMenuShareLink': 'ПОДЕЛИТЬСЯ',
  'fileViewer.shareMenuPublishOnline': 'ПОДЕЛИТЬСЯ НА СВОЁМ ХОСТИНГЕ',
  'fileViewer.shareMenuDownload': 'СКАЧАТЬ',
  'fileViewer.shareMenuPresentation': 'Презентация',
  'fileViewer.shareMenuSourceFiles': 'Исходные файлы',
  'fileViewer.shareMenuSave': 'СОХРАНИТЬ',
  'fileViewer.shareMenuPublishViaOd': 'БЫСТРЫЙ ДОСТУП · OPENDESIGN',
  'fileViewer.unifiedShareAria': 'Share and export actions',
  'fileViewer.unifiedShareTab': 'Share',
  'fileViewer.unifiedExportTab': 'Export',
  'fileViewer.unifiedSendTab': 'Send to...',
  'fileViewer.openFileForHistory': 'Open a file to view version history',
  'fileViewer.workspaceShareTitle': 'Share project in workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Only you can access this project. Choose workspace members to share it with the team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Members of this workspace can access this project.',
  'fileViewer.workspaceAccessPrivate': 'Only me',
  'fileViewer.workspaceAccessMembers': 'Workspace members',
  'fileViewer.publishSingleFileTitle': 'Получить ссылку для доступа',
  'fileViewer.publishSingleFileDescription': 'Любой, у кого есть ссылка, может открыть её онлайн. Пока можно поделиться только одним файлом — встроенные локальные ресурсы, например изображения, ещё не поддерживаются.',
  'fileViewer.openFileRequired': 'Open a file to use this.',
  'fileViewer.publishFile': 'Publish file',
  'fileViewer.publishingFile': 'Создание ссылки…',
  'fileViewer.unpublishFile': 'Прекратить доступ',
  'fileViewer.shareEmptyStateTitle': 'Пока нечем делиться',
  'fileViewer.shareEmptyStateDescription': 'Создайте команду или присоединитесь к ней, чтобы поделиться этим файлом с коллегами',
  'fileViewer.shareEmptyStateCreateTeam': 'Создать команду',
  'fileViewer.shareTeamMissingTitle': 'Пока нет команды, чтобы поделиться',

  'fileViewer.publishFileRequiresTeam': 'Для публикации общедоступной ссылки нужно командное рабочее пространство. Переключитесь на командное пространство или опубликуйте файл через «Развернуть».',
  'fileViewer.publishFileRequiresWorkspace': 'Для ссылки нужен вход в рабочее пространство. Войдите в OpenDesign Cloud или поделитесь файлом через деплой.',
  'fileViewer.publishFileFailed': 'Не удалось создать ссылку. Повторите попытку или используйте вариант деплоя ниже.',
  'fileViewer.workspaceShareSuccess': 'Shared with workspace members',
  'fileViewer.workspaceShareFailed': 'Could not share with workspace',
  'fileViewer.workspaceUnshareSuccess': 'Moved back to private',
  'fileViewer.workspaceUnshareFailed': 'Could not move back to private',
  'fileViewer.readonlySharedNoExport': 'Shared project is read-only: you can comment, but cannot edit or export.',
  'fileViewer.copyShareLink': 'Скопировать ссылку для доступа',
  'fileViewer.openSharePage': 'Открыть страницу доступа',
  'fileViewer.shareLinkRequiresDeploy': 'Сначала опубликуйте онлайн, чтобы получить ссылку',
  'fileViewer.shareLinkPublishGuide': 'Опубликуйте онлайн выше, чтобы включить доступ ↑',
  'fileViewer.shareAfterGenerationComplete': 'Доступ станет возможен после завершения генерации',
  'fileViewer.copyProviderLink': 'Скопировать ссылку {provider}',
  'fileViewer.copyCloudflareLink': 'Скопировать ссылку Cloudflare',
  'fileViewer.screenshotCopying': 'Копирование снимка экрана...',
  'fileViewer.screenshotCopied': 'Снимок экрана скопирован в буфер обмена',
  'fileViewer.screenshotClipboardDenied': 'Браузер заблокировал доступ к буферу обмена',
  'fileViewer.screenshotPreviewLoading': 'Предпросмотр ещё загружается. Повторите попытку через мгновение.',
  'fileViewer.screenshotCaptureFailed': 'Не удалось сделать снимок предпросмотра. Пожалуйста, попробуйте снова.',
  'fileViewer.exportPdf': 'Экспорт в PDF',
  'fileViewer.exportPdfAllSlides': 'Экспорт в PDF (все слайды)',
  'fileViewer.exportPptxBusy': 'Дождитесь окончания текущего хода.',
  'fileViewer.exportPptxHint': 'Отправьте запрос агенту для конвертации этого дизайна в PPTX.',
  'fileViewer.exportPptxNa': 'Экспорт PPTX здесь недоступен.',
  'fileViewer.exportDaemonUnreachable': 'Не удалось подключиться к daemon. Повторите попытку.',
  'fileViewer.exportZip': 'Скачать как .zip',
  'fileViewer.exportHtml': 'Экспорт как HTML',
  'fileViewer.exportMd': 'Экспорт в Markdown',
  'fileViewer.exportImage': 'Экспорт как изображение',
  'fileViewer.exportPptxImages': 'Экспорт в PPTX (изображения)',
  'fileViewer.exportPptxEditable': 'Экспорт в PPTX (редактируемый)',
  'fileViewer.exportPptxEditableHint': 'Нативные редактируемые фигуры и текст (не pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Выберите способ экспорта, затем скачайте файл.",
  'fileViewer.exportPptxScreenshot': "PPTX из снимков",
  'fileViewer.exportPptxScreenshotHint': "Одно изображение на слайд — pixel-perfect, но без редактирования.",
  'fileViewer.exportPptxConfirm': "Экспортировать",
  'fileViewer.exportPptxRecommended': "Рекомендуется",
  'fileViewer.exportingProgress': 'Экспорт…',
  'fileViewer.exportSlideProgress': 'Экспорт слайда {current}/{total}…',
  'fileViewer.exportingElapsed': 'Экспорт… {seconds}с',
  'fileViewer.exportSlideEta': 'Слайд {current}/{total} · осталось ~{seconds}с',
  'fileViewer.exportFailed': 'Не удалось экспортировать. Повторите попытку.',
  'fileViewer.exportDone': 'Экспорт завершён',
  'fileViewer.exportImageFailed': 'Не удалось сделать снимок. Попробуйте ещё раз или воспользуйтесь инструментом скриншотов вашего браузера.',
  'fileViewer.exportImageModalSubtitle': 'Выберите формат, затем скачайте текущий предпросмотр как изображение.',
  'fileViewer.exportImageFormatLabel': 'Формат',
  'fileViewer.exportImageSaving': 'Сохранение изображения…',
  'fileViewer.exportImageSaved': 'Изображение сохранено',
  'fileViewer.exportImageDownloadStarted': 'Загрузка началась',
  'fileViewer.exportImageDownloadDetails': '{filename} находится в загрузках браузера, если окно «Сохранить как» не появилось.',
  'fileViewer.exportJsx': 'Экспорт как JSX',
  'fileViewer.exportReactHtml': 'Экспорт предпросмотра как HTML',
  'fileViewer.exportStarted': 'Экспорт начат',
  'fileViewer.saveAsTemplate': 'Сохранить как шаблон…',
  'fileViewer.savingTemplate': 'Сохранение шаблона…',
  'fileViewer.savedTemplate': 'Сохранено как «{name}»',
  'fileViewer.savedTemplateFail': 'Не удалось сохранить шаблон — попробуйте снова.',
  'fileViewer.templateNamePrompt': 'Название шаблона',
  'fileViewer.templateNameDefault': 'Шаблон без названия',
  'fileViewer.templateDescPrompt': 'Краткое описание (необязательно — чем полезен этот шаблон?)',
  'liveArtifact.refresh.button': 'Обновить',
  'liveArtifact.refresh.buttonTitle': 'Обновить этот live-артефакт',
  'liveArtifact.refresh.loadingTitle': 'Загрузка live-артефакта…',
  'liveArtifact.refresh.noSourceTitle': 'Пока нет одобренного источника обновления только для чтения.',
  'liveArtifact.refresh.running': 'Обновление…',
  'liveArtifact.refresh.runningMessage': 'Обновляем данные и предпросмотр. Это может занять немного времени.',
  'liveArtifact.refresh.runningAction': 'Предыдущий предпросмотр остается видимым, пока обновление не завершится успешно.',
  'liveArtifact.refresh.successOne': 'Обновление завершено. Данные обновлены.',
  'liveArtifact.refresh.successMany': 'Обновление завершено. Данные обновлены.',
  'liveArtifact.refresh.successAction': 'Предпросмотр перезагружен с последними сохраненными данными.',
  'liveArtifact.refresh.previousFailure': 'Предыдущее обновление завершилось ошибкой: {message}',
  'liveArtifact.refresh.failureAction': 'Проверьте историю обновлений, исправьте проблему с источником или правами и повторите попытку.',
  'liveArtifact.refresh.networkFailure': 'Не удалось отправить запрос на обновление. Проверьте подключение и попробуйте снова.',
  'liveArtifact.refresh.genericFailure': 'Не удалось обновить.',
  'liveArtifact.refresh.statusNever': 'Не обновляется',
  'liveArtifact.refresh.statusReady': 'Готов к обновлению',
  'liveArtifact.refresh.statusSucceeded': 'Актуально',
  'liveArtifact.refresh.statusFailed': 'Обновление не удалось',
  'liveArtifact.refresh.statusRunning': 'Обновление',
  'liveArtifact.refresh.statusRunningDescription': 'Сейчас выполняется обновление.',
  'liveArtifact.refresh.statusSucceededDescription': 'Последнее обновление завершилось успешно.',
  'liveArtifact.refresh.statusFailedDescription': 'Последняя попытка обновления завершилась неудачно.',
  'liveArtifact.refresh.statusReadyDescription': 'Обновляемые источники настроены, но обновление не выполняется.',
  'liveArtifact.refresh.statusNeverDescription': 'У этого живого артефакта пока нет источника обновления.',
  'liveArtifact.refresh.eventStarted': 'Начато',
  'liveArtifact.refresh.eventSucceeded': 'Успешно',
  'liveArtifact.refresh.eventFailed': 'Не удалось',
  'liveArtifact.refresh.eventStartedDetail': 'Обновление запущено…',
  'liveArtifact.refresh.sourcesUpdatedOne': 'Обновлён {n} источник',
  'liveArtifact.refresh.sourcesUpdatedMany': 'Обновлено источников: {n}',
  'liveArtifact.refresh.timelineEmpty': 'В этой сессии ещё не было активности обновления. Запустите обновление, чтобы записать хронологию, или дождитесь автоматических запусков.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Последнее обновление',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Никогда',
  'liveArtifact.refresh.justNow': 'только что',
  'liveArtifact.refresh.factCreated': 'Создано',
  'liveArtifact.refresh.factLastUpdated': 'Последнее обновление',
  'liveArtifact.refresh.factUnknown': 'Неизвестно',
  'liveArtifact.refresh.persistedTitle': 'Сохранённая история обновлений',
  'liveArtifact.refresh.persistedHint': 'Записи, загруженные из refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Сохранённой истории обновлений пока нет.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'успешно',
  'liveArtifact.refresh.persistedStatusRunning': 'выполняется',
  'liveArtifact.refresh.persistedStatusFailed': 'не удалось',
  'liveArtifact.refresh.persistedStatusCancelled': 'отменено',
  'liveArtifact.refresh.persistedStatusSkipped': 'пропущено',
  'liveArtifact.refresh.sessionTitle': 'Активность сессии',
  'liveArtifact.refresh.sessionHint': 'События, зафиксированные пока эта вкладка открыта',
  'liveArtifact.refresh.docSourceTitle': 'Источник документа',
  'liveArtifact.refresh.docSourceHint': 'Источник настроен',
  'liveArtifact.refresh.docSourceType': 'Тип',
  'liveArtifact.refresh.docSourceTool': 'Инструмент',
  'liveArtifact.refresh.docSourceConnector': 'Коннектор',
  'liveArtifact.refresh.debugSummary': 'Расширенные отладочные метаданные',
  'liveArtifact.refresh.debugNote': 'Может включать ID коннекторов, имена файлов, метаданные источников и внутренние пути артефактов.',
  'liveArtifact.viewer.tabPreview': 'Предпросмотр',
  'liveArtifact.viewer.tabCode': 'Код',
  'liveArtifact.viewer.tabData': 'Данные',
  'liveArtifact.viewer.tabRefreshHistory': 'История обновлений',
  'liveArtifact.viewer.dataEmpty': 'Кэш data.json недоступен.',
  'liveArtifact.viewer.code.templateHeading': 'HTML шаблона',
  'liveArtifact.viewer.code.renderedHeading': 'Сгенерированный HTML',
  'liveArtifact.viewer.code.templateHelp': 'Редактируемый шаблон, используемый с data.json для создания предпросмотра.',
  'liveArtifact.viewer.code.renderedHelp': 'Сгенерированный index.html, который сейчас загружен в предпросмотре.',
  'liveArtifact.viewer.code.variantAria': 'Вариант кода',
  'liveArtifact.viewer.code.variantTemplate': 'Шаблон',
  'liveArtifact.viewer.code.variantRendered': 'Сгенерировано',
  'liveArtifact.viewer.code.loading': 'Загрузка кода…',
  'liveArtifact.viewer.code.unavailable': 'Код пока недоступен.',
  'liveArtifact.viewer.code.empty': 'Этот файл кода пуст.',
  'fileViewer.deployToVercel': 'Развернуть на Vercel',
  'fileViewer.redeployToVercel': 'Развернуть повторно',
  'fileViewer.deployingToVercel': 'Развёртывание на Vercel…',
  'fileViewer.deployProviderLabel': 'Провайдер',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'Цель',
  'fileViewer.deployTargetPreview': 'Предпросмотр',
  'fileViewer.deployTargetProduction': 'Продакшен',
  'fileViewer.deployToProvider': 'Развернуть на {provider}',
  'fileViewer.redeployToProvider': 'Развернуть повторно на {provider}',
  'fileViewer.deployingToProvider': 'Развёртывание на {provider}…',
  'fileViewer.preparingPublicLink': 'Подготовка публичной ссылки…',
  'fileViewer.copyDeployLink': 'Скопировать ссылку',
  'fileViewer.deployModalTitle': 'Развернуть',
  'fileViewer.deployModalSubtitle': 'Используйте аккаунт выбранного провайдера, чтобы развернуть этот HTML-просмотр.',
  'fileViewer.vercelToken': 'Токен Vercel',
  'fileViewer.vercelTokenGetLink': 'Получить токен Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Вставьте токен Vercel',
  'fileViewer.vercelTokenReuseHint': 'Будет использован сохранённый токен. Введите новый, чтобы заменить его.',
  'fileViewer.vercelTokenRequired': 'Сначала введите и сохраните токен Vercel.',
  'fileViewer.cloudflareApiToken': 'Токен API Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Получить токен API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Вставьте токен API Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'Будет использован сохранённый токен API Cloudflare. Введите новый, чтобы заменить его.',
  'fileViewer.cloudflareApiTokenRequired': 'Сначала введите и сохраните токен API Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'При создании токена API выберите Pages Edit; для пользовательских доменов нужны Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'ID команды',
  'fileViewer.vercelTeamSlug': 'Слаг команды',
  'fileViewer.cloudflareAccountId': 'ID аккаунта',
  'fileViewer.cloudflareAccountIdHint': 'ID аккаунта можно найти в панели Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Сначала введите и сохраните Cloudflare Account ID.',
  'fileViewer.cloudflareZoneLabel': 'Домен',
  'fileViewer.cloudflareZonePlaceholder': 'Сохраните настройки Cloudflare, чтобы загрузить домены',
  'fileViewer.cloudflareZoneRequired': 'Сначала выберите домен Cloudflare.',
  'fileViewer.cloudflareZonesLoading': 'Загрузка доменов Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'Обновить домены',
  'fileViewer.cloudflareZonesLoadFailed': 'Не удалось загрузить домены Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'Для этого аккаунта не найдено активных полных доменов Cloudflare.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Префикс поддомена',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Используйте только одну метку DNS: строчные буквы, цифры и дефисы.',
  'fileViewer.cloudflareHostnamePreview': 'Предпросмотр пользовательского домена: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Необязательно: привяжите пользовательский домен. Если оставить поле пустым, всё равно будет создана ссылка pages.dev.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Пользовательский домен',
  'fileViewer.optional': 'Необязательно',
  'fileViewer.vercelPreviewOnly': 'Пока поддерживаются только Preview-развёртывания.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages использует Direct Upload.',
  'fileViewer.savingConfig': 'Сохранение…',
  'fileViewer.deployConfigSaveFailed': 'Не удалось сохранить настройки Vercel.',
  'fileViewer.deployFailed': 'Развёртывание не удалось. Проверьте настройки Vercel и попробуйте снова.',
  'fileViewer.deployProviderConfigSaveFailed': 'Не удалось сохранить настройки {provider}.',
  'fileViewer.deployProviderFailed': 'Развёртывание на {provider} не удалось. Проверьте настройки и попробуйте снова.',
  'fileViewer.deployResultLabel': 'URL развёрнутого сайта',
  'fileViewer.deployLinkReady': 'Готово',
  'fileViewer.deploySuccessToast': 'Развёртывание успешно загружено',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Публичная ссылка готовится',
  'fileViewer.deployLinkDelayed': 'Сайт развёрнут. Провайдер всё ещё готовит публичную ссылку.',
  'fileViewer.deployLinkFailed': 'Пользовательский домен не настроен',
  'fileViewer.deployLinkProtectedLabel': 'Защита развёртывания включена',
  'fileViewer.deployLinkProtected': 'Сайт развёрнут, но эта ссылка предпросмотра требует аутентификации. Отключите Deployment Protection или используйте собственный домен.',
  'fileViewer.retryLink': 'Повторить',
  'questionForm.submit': 'Отправить',
  'questionForm.skip': 'Пропустить',
  'questionForm.locked': 'Отвечено',
  'conv.switch': 'Переключить разговор',
  'conv.label': 'Разговор',
  'conv.heading': 'Разговоры',
  'conv.new': '+ Новый',
  'conv.empty': 'Разговоров пока нет.',
  'conv.untitled': 'Разговор без названия',
  'conv.renameTooltip': 'Дважды кликните для переименования',
  'conv.delete': 'Удалить разговор',
  'conv.deleteConfirm': 'Удалить «{title}»? Это удалит его сообщения.',
  'agentPicker.label': 'Агент',
  'agentPicker.modeChoose': 'Выберите режим выполнения',
  'agentPicker.localCli': 'Локальный CLI',
  'agentPicker.daemonOff': 'демон выключен',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Выберите обнаруженный CLI код-агента',
  'agentPicker.noAgents': 'нет агентов в PATH',
  'agentPicker.notInstalled': 'не установлено',
  'agentPicker.rescan': 'Пересканировать локальный PATH для агентов',
  'tool.openInTab': 'Открыть {name} во вкладке',
  'tool.open': 'открыть',
  'tool.todos': 'Задачи',
  'tool.todosExpand': 'Показать задачи',
  'tool.todosCollapse': 'Скрыть задачи',
  'tool.todosDone': 'Готово',
  'tool.todosDismiss': 'Закрыть список задач',
  'tool.write': 'Записать',
  'tool.edit': 'Редактировать',
  'tool.read': 'Читать',
  'tool.delete': 'Удалить',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Fetch',
  'tool.search': 'Поиск',
  'tool.lines': '{n} строк',
  'tool.changeSingular': 'изменение',
  'tool.changePlural': 'изменения',
  'tool.in': 'в {path}',
  'tool.hide': 'скрыть',
  'tool.output': 'вывод',
  'tool.running': 'выполняется…',
  'tool.error': 'ошибка',
  'tool.done': 'готово',
  'assistant.role': 'Ассистент',
  'assistant.workingLabel': 'Работает',
  'assistant.doneLabel': 'Готово',
  'assistant.canceledLabel': 'Отменено',
  'assistant.copyMarkdown': 'Скопировать Markdown ответа',
  'assistant.forkConversation': 'Создать форк отсюда',
  'assistant.forkingConversation': 'Создание форка…',
  'assistant.shareToOpenDesign': 'Поделиться в OpenDesign',
  'assistant.shareToOpenDesignBusy': 'Готовим пакет…',
  'assistant.feedbackPrompt': 'Отзыв',
  'assistant.feedbackPositive': 'Полезно',
  'assistant.feedbackNegative': 'Не полезно',
  'assistant.feedbackReasonTitle': 'Расскажите почему',
  'assistant.feedbackReasonPositiveMatched': 'Понял мой запрос',
  'assistant.feedbackReasonPositiveVisual': 'Выглядит хорошо',
  'assistant.feedbackReasonPositiveUseful': 'Удобная структура',
  'assistant.feedbackReasonPositiveEasy': 'Легко продолжать редактирование',
  'assistant.feedbackReasonPositiveDesignSystem': 'Следовал дизайн-системе',
  'assistant.feedbackReasonNegativeMissed': 'Не учёл мой запрос',
  'assistant.feedbackReasonNegativeVisual': 'Визуальное качество требует доработки',
  'assistant.feedbackReasonNegativeIncomplete': 'Неполный результат',
  'assistant.feedbackReasonNegativeHard': 'Сложно использовать',
  'assistant.feedbackReasonNegativeDesignSystem': 'Не следовал дизайн-системе',
  'assistant.feedbackReasonOther': 'Другое',
  'assistant.feedbackReasonPlaceholder': 'Добавьте короткую заметку...',
  'assistant.feedbackReasonSubmit': 'Отправить',
  'assistant.emptyResponseLabel': 'Нет результата',
  'assistant.emptyResponseMessage': 'Провайдер завершил запрос, не вернув текст или артефакт. Попробуйте другую модель или провайдера, проверьте квоту или повторите попытку.',
  'assistant.unfinishedLabel': 'Остановлено с незавершенной работой',
  'assistant.unfinishedSummary': 'Осталось задач: {n}',
  'assistant.unfinishedMore': '+{n} еще',
  'assistant.continueRemaining': 'Продолжить оставшиеся задачи',
  'chat.resumeRunCta': 'Продолжить выполнение',
  'assistant.outTokens': '{n} токенов вывода',
  'assistant.producedFiles': 'Файлы из этого хода',
  'assistant.openFile': 'Открыть',
  'assistant.downloadFile': 'Скачать',
  'nextStep.title': 'Следующий шаг',
  'nextStep.more': 'Ещё',
  'nextStep.share': 'Поделиться',
  'nextStep.download': 'Скачать',
  'nextStep.createDesignSystemTitle': 'Создать дизайн-систему',
  'nextStep.createDesignSystemBody': 'Дублировать этот проект в рабочее пространство дизайн-системы и запустить агентный проход по всем текущим файлам и референсам.',
  'nextStep.createDesignSystemBusy': 'Создаем дизайн-систему...',
  'nextStep.contribute': 'Внести вклад',
  'nextStep.planGenerateTitle': "Сгенерировать из документа",
  'nextStep.planGenerateBody': "Использовать утвержденный Markdown-план как источник истины для следующего дизайн-запуска.",
  'nextStep.planImproveTitle': "Улучшить документ",
  'nextStep.planImproveBody': "Уточнить текущий план перед генерацией финального артефакта.",
  'nextStep.planGeneratePrompt': "Используйте `{file}` как источник истины. Сначала прочитайте документ, сохраните его решения, затем сгенерируйте финальный дизайн-артефакт, который ему соответствует. Если это outline слайдов — создайте презентацию; если PRD или план прототипа — создайте прототип или вайрфреймы; если сториборд или креативный бриф — создайте соответствующий визуальный/медиа-артефакт. Перед генерацией явно отметьте блокирующие TODO или противоречия, которые нельзя разрешить самостоятельно.",
  'nextStep.planImprovePrompt': "Прочитайте `{file}` и улучшите его на месте как редактируемый документ плана. Уточните scope, усилите слабые разделы, добавьте недостающие acceptance checks и оставьте TODO/open questions там, где нужен ввод пользователя. Финальный дизайн-артефакт пока не генерируйте.",
  'nextStep.planImproveArtifactTitle': "Улучшить артефакт",
  'nextStep.planImproveArtifactBody': "Продолжить итерации по сгенерированному артефакту, не возвращаясь к планированию.",
  'nextStep.planImproveArtifactPrompt': "Улучшите `{artifact}` на месте. Сохраните существующий рабочий артефакт и внесите самые полезные продуктовые, визуальные, интерактивные и контентные улучшения. Не ломайте уже работающее поведение, затем кратко перечислите измененные файлы и оставшиеся риски.",
  'nextStep.planMergeTitle': "Согласовать документ и артефакт",
  'nextStep.planMergeBody': "Сверить план и сгенерированный артефакт, чтобы они развивались синхронно.",
  'nextStep.planMergePrompt': "Прочитайте `{document}` и `{artifact}` вместе. Считайте документ намерением, а артефакт — текущей реализацией. Согласуйте их: обновите артефакт по подтвержденным решениям, обновляйте документ только там, где он устарел, и оставьте явные TODO/open questions для нерешенных мест. Сохраните уже работающее поведение и резюмируйте изменения в обоих файлах.",

  'nextStep.projectContinueTitle': 'Продолжить работу',
  'nextStep.projectGenerateArtifactTitle': 'Сгенерировать артефакт',
  'nextStep.designSystemAiRefineTitle': 'AI-уточнение дизайн-системы',
  'nextStep.designSystemAuditKitTitle': 'Проверить токены и kit',

  'nextStep.brandAiOptimizeTitle': 'Уточнить извлеченную дизайн-систему',
  'nextStep.brandAiOptimizeBody': 'Запускает агентный проход с расходом токенов модели: источник извлекается повторно, а дизайн-система обновляется на месте.',
  'nextStep.brandCreateDesignTitle': 'Создать с этой дизайн-системой',
  'nextStep.brandCreateDesignBody': 'Начать новый дизайн на основе извлеченных цветов, типографики, ассетов и системных рекомендаций.',
  'nextStep.brandCreateDesignPrompt': 'Создайте новый дизайн с дизайн-системой {designSystem}.',

  'nextStep.brandContinueExtractionTitle': 'Продолжить извлечение',
  'nextStep.brandContinueExtractionBody': 'Когда вкладка браузера пройдет все проверки, прочитайте ее и продолжите заполнять сохраненный кит.',
  'nextStep.brandContinueExtractionBusy': 'Продолжаем извлечение...',
  'nextStep.brandContinueAiExtractionTitle': 'Продолжить с агентом',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Используйте выбранного агента для извлечения из сохраненного черновика, если программный проход всё еще не может завершиться.',
  'nextStep.brandContinueAiExtractionAiBody': 'Возобновите выбранного агента с текущего каркаса бренда и завершите ту же дизайн-систему.',
  'nextStep.brandContinueAiExtractionBusy': 'Продолжаем с агентом...',
  'nextStep.createDesignBusy': 'Создаём дизайн...',
  'assistant.thinking': 'Думает',
  'assistant.thought': 'Подумал',
  'assistant.thoughtFor': 'Думал {s}с',
  'assistant.systemReminder': 'Системное напоминание',
  'assistant.possiblePromptInjection': 'Возможная инъекция промпта',
  'assistant.waitingFirstOutput': 'Ожидание первого ответа',
  'assistant.statusBootingAgent': 'Загрузка агента',
  'assistant.statusPreparing': 'Подготовка...',
  'assistant.statusStarting': 'Запуск',
  'assistant.statusRequesting': 'Отправка запроса',
  'assistant.statusThinking': 'Думает',
  'assistant.statusStreaming': 'Потоковая передача',
  'assistant.slowHint': 'Занимает больше времени, чем обычно. Форма обычно появляется через 5–10с — вы можете остановить и перефразировать.',
  'assistant.verbEditing': 'Редактирование',
  'assistant.verbWriting': 'Запись',
  'assistant.verbReading': 'Чтение',
  'assistant.verbSearching': 'Поиск',
  'assistant.verbRunning': 'Выполнение',
  'assistant.verbTodos': 'Задачи',
  'assistant.verbFetching': 'Получение',
  'assistant.verbCalling': 'Вызов',
  'qf.answered': 'отвечено',
  'qf.choose': 'Выберите…',
  'qf.customLabel': 'Свой ответ',
  'qf.customPlaceholder': 'Введите свой ответ...',
  'qf.otherOption': 'Другое',
  'qf.required': 'обязательно',
  'qf.lockedSubmitted': 'Ответы отправлены — агент будет использовать их до конца сессии.',
  'qf.lockedPrev': 'Эта форма из предыдущего хода.',
  'qf.hint': 'Выберите подходящее. Пропустите необязательные поля, которые вам не важны — агент будет использовать разумные значения по умолчанию.',
  'qf.submitDefault': 'Отправить ответы',
  'qf.submitDisabledTitle': 'Сначала заполните обязательные поля',
  'qf.submitTitle': 'Отправить ответы',
  'qf.cardSelected': 'выбрано',
  'qf.cardRefs': 'Ссылки:',
  'qf.cardSampleText': 'Быстрая коричневая лиса · 0123',
  'questions.tabLabel': 'Вопросы',
  'questions.banner': 'Не против, если я задам пару коротких вопросов?',
  'questions.bannerAnswered': 'На вопросы дан ответ',
  'questions.strategyBlockedNotice': "Эта задача остановлена контролем качества стратегии, поэтому эту форму больше нельзя отправить. Чтобы продолжить, начните новый запрос.",
  'questions.continue': 'Продолжить',
  'questions.generating': 'Генерация вопросов…',
  'questions.skipAll': 'Пропустить всё',
  'questions.autoSkipHint': 'Автоматически продолжается по истечении таймера',
  'questions.submitting': 'Отправка…',
  'sketch.toolSelect': 'Выбор (без действий)',
  'sketch.toolPen': 'Ручка',
  'sketch.toolText': 'Текст',
  'sketch.toolRect': 'Прямоугольник',
  'sketch.toolArrow': 'Стрелка',
  'sketch.toolEraser': 'Ластик',
  'sketch.color': 'Цвет',
  'sketch.strokeSize': 'Размер штриха',
  'sketch.undo': 'Отменить',
  'sketch.clear': 'Очистить',
  'sketch.close': 'Закрыть',
  'sketch.closeConfirm': 'Закрыть набросок и отменить несохранённые изменения?',
  'sketch.textPrompt': 'Текст:',
  'sketch.textModalTitle': 'Добавить текст',
  'critiqueTheater.userFacingName': 'Дизайн-жюри',
  'critiqueTheater.roleDesigner': 'Дизайнер',
  'critiqueTheater.roleCritic': 'Критик',
  'critiqueTheater.roleBrand': 'Бренд',
  'critiqueTheater.roleA11y': 'Доступность',
  'critiqueTheater.roleCopy': 'Текст',
  'critiqueTheater.roundLabel': 'Раунд {n} из {m}',
  'critiqueTheater.mustFix': '{n} обязательных исправлений',
  'critiqueTheater.composite': 'Сводная оценка',
  'critiqueTheater.threshold': 'Порог',
  'critiqueTheater.consensus': 'Консенсус',
  'critiqueTheater.interrupt': 'Прервать',
  'critiqueTheater.interrupting': 'Прерывание…',
  'critiqueTheater.interrupted': 'Прервано',
  'critiqueTheater.degradedHeading': 'Панель недоступна в этом запуске',
  'critiqueTheater.degradedReasonMalformed': 'Некорректный вывод панели (парсер отклонил блок).',
  'critiqueTheater.degradedReasonOversize': 'Вывод панели превысил безопасный лимит в байтах.',
  'critiqueTheater.degradedReasonAdapter': 'Адаптер {adapter} не поддерживает протокол Critique.',
  'critiqueTheater.degradedReasonProtocol': 'Адаптер {adapter} отправил неподдерживаемую версию протокола.',
  'critiqueTheater.degradedReasonMissingArtifact': 'Запуск завершён без финального артефакта.',
  'critiqueTheater.replay': 'Воспроизвести заново',
  'critiqueTheater.replaySpeed': 'Скорость воспроизведения',
  'critiqueTheater.readOnly': 'Только для чтения',
  'critiqueTheater.shippedSummary': 'Отправлено на раунде {round} · итоговая оценка {composite}',
  'critiqueTheater.interruptedSummary': 'Прервано на раунде {round} · лучшая итоговая оценка {composite}',
  'critiqueTheater.shippedBadge': 'Отправлено',
  'critiqueTheater.belowThresholdBadge': 'Ниже порога',
  'critiqueTheater.timedOutBadge': 'Время истекло',
  'critiqueTheater.failedHeading': 'Сбой запуска',
  'critiqueTheater.failedReasonCliExit': 'Agent CLI завершился с ненулевым кодом, прежде чем панель смогла закончить.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Раунд превысил отведённое время.',
  'critiqueTheater.failedReasonTotalTimeout': 'Полный запуск превысил общий лимит времени.',
  'critiqueTheater.failedReasonOrchestrator': 'Внутренняя ошибка оркестратора.',
  'critiqueTheater.transcriptEmpty': 'Пока нет записи для воспроизведения. Запустите критику, чтобы записать её.',
  'critiqueTheater.transcriptLoading': 'Загрузка стенограммы…',
  'critiqueTheater.transcriptError': 'Не удалось загрузить запись: {error}',
  'critiqueTheater.replaySpeedPaused': 'Приостановлено',
  'critiqueTheater.replaySpeedInstant': 'Мгновенно',
  'critiqueTheater.replaySpeedLive': 'В реальном времени',
  'critiqueTheater.replaySpeedFast': 'Быстро',
  'critiqueTheater.settingsNav': 'Жюри дизайна',
  'critiqueTheater.settingsNavHint': 'Обзор дизайна из пяти панелей для ваших запусков',
  'critiqueTheater.settingsEnabledLabel': 'Показывать Жюри дизайна во время запусков Agent',
  'critiqueTheater.settingsEnabledDescription': 'Когда включено, обзор из пяти панелей появляется рядом с генерациями Agent и оценивает результат перед отправкой. Вы можете прервать процесс в любой момент.',
  'critiqueTheater.settingsEnabledProjectHint': 'Сохранено для этого проекта. Новые запуски в этом проекте будут проходить через Жюри дизайна на стороне сервера.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Откройте проект, чтобы сохранить это на стороне сервера. До этого момента изменяется только настройка в браузере.',
  'pet.title': 'Питомцы',
  'pet.subtitle': 'Заведите маленького спутника, который парит над вашей рабочей областью.',
  'pet.navTitle': 'Питомцы',
  'pet.navHint': 'Завести или настроить',
  'pet.tabBuiltIn': 'Встроенные',
  'pet.tabBuiltInHint': 'Подобранные питомцы в комплекте OpenDesign — выберите и забирайте.',
  'pet.builtInEmpty': 'Встроенные питомцы сейчас недоступны. Обновите вкладку «Сообщество», когда демон снова запустится.',
  'pet.tabCustom': 'Свой',
  'pet.tabCustomHint': 'Своё имя, глиф, цвет или загруженный спрайт.',
  'pet.tabCommunity': 'Сообщество',
  'pet.tabCommunityHint': 'Питомцы из Codex — заведите своего или сгенерируйте нового через ИИ.',
  'pet.tabsAria': 'Источник питомца',
  'pet.adopt': 'Завести',
  'pet.adoptedBadge': 'Заведён',
  'pet.adoptCallout': 'Завести питомца',
  'pet.changePet': 'Сменить питомца',
  'pet.wake': 'Разбудить',
  'pet.tuck': 'Спрятать',
  'pet.wakeTitle': 'Разбудить питомца — показать оверлей.',
  'pet.tuckTitle': 'Спрятать питомца — скрыть оверлей.',
  'pet.settingsTitle': 'Открыть настройки питомца',
  'pet.useCustom': 'Использовать своего',
  'pet.customTitle': 'Создайте своего',
  'pet.customHint': 'Выберите имя, символ и акцентный цвет — оверлей обновляется на лету.',
  'pet.customGreetingPlaceholder': 'Приветствие от вашего питомца…',
  'pet.fieldName': 'Имя',
  'pet.fieldGlyph': 'Символ',
  'pet.fieldGlyphHint': 'Один эмодзи подходит лучше всего (например 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Приветствие',
  'pet.fieldAccent': 'Акцентный цвет',
  'pet.fieldAccentCustom': 'Свой цвет',
  'pet.fieldAccentDefault': 'Цвет акцента по умолчанию',
  'pet.overlayAria': 'Питомец-компаньон',
  'pet.spriteAria': '{name} — тащите, чтобы переместить, кликните, чтобы пообщаться',
  'pet.spriteTitle': 'Привет от {name}! Кликните, чтобы пообщаться.',
  'pet.taskSummarySingle': 'Выполняется {count} задача Agent.',
  'pet.taskSummaryMultiple': 'Выполняется {count} задач Agent в {projects} проектах.',
  'pet.taskSummaryRecentSingle': 'Недавно завершена {count} задача Agent.',
  'pet.taskSummaryRecentMultiple': 'Недавно завершено {count} задач Agent.',
  'pet.taskListAria': 'Активные задачи Agent',
  'pet.taskOpenProject': 'Открыть {project}',
  'pet.taskGroup.running': 'Выполняется',
  'pet.taskGroup.queued': 'Ожидание',
  'pet.taskGroup.recent': 'Недавно завершённые',
  'pet.idleQuote.leonardo.text': 'Учение никогда не истощает ум.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Я увидел ангела в мраморе и высекал, пока не освободил его.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Есть два средства, которые могут помочь скульптору: свет и тень.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Когда человек пишет картину, он не думает.',
  'pet.idleQuote.raphael.author': 'Raphael',
  'pet.idleQuote.caravaggio.text': 'Все произведения, что бы и кем бы они ни были написаны, — не более чем безделицы и детские пустяки, если они не созданы и не написаны с натуры.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'Главное — быть тронутым, любить, надеяться, трепетать, жить.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Питомцы — разбудить, спрятать или выбрать',
  'pet.composerMenuTitle': 'Питомцы',
  'pet.composerMenuHint': 'совет: введите /pet, чтобы переключить',
  'pet.composerOpenSettings': 'Управление питомцами',
  'pet.welcomeTeaserTitle': 'Заведите питомца',
  'pet.welcomeTeaserBody': 'Маленький спутник, парящий над воркспейсом.',
  'pet.welcomeTeaserCta': 'Выбрать',
  'pet.imageUpload': 'Загрузить спрайт',
  'pet.imageReplace': 'Заменить спрайт',
  'pet.imageRemove': 'Использовать emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF или SVG. Спрайтшит? Загрузите горизонтальную ленту и укажите число кадров.',
  'pet.imageHintActive': 'Показан ваш спрайт. Установите кадры > 1, чтобы анимировать горизонтальный спрайтшит.',
  'pet.fieldFrames': 'Кадры',
  'pet.fieldFramesHint': '1 = статично. > 1 = горизонтальный спрайтшит.',
  'pet.fieldFps': 'Скорость (fps)',
  'pet.fieldFpsHint': 'Скорость смены кадров.',
  'pet.atlasImport': 'Импорт спрайта Codex',
  'pet.atlasImportTitle': 'Импортируйте атлас hatch-pet 8x9 / 192x208 (PNG или WebP).',
  'pet.atlasPickerTitle': 'Выберите ряд анимации',
  'pet.atlasPickerHint': 'У Codex-петов 9 рядов анимаций. По умолчанию мы оставляем весь атлас — питомец меняет ряд при наведении, направлении перетаскивания и долгом простое. Можно зафиксировать и один цикл.',
  'pet.atlasCancel': 'Отменить атлас',
  'pet.atlasAdopt': 'Зафиксировать этот ряд',
  'pet.atlasAdoptFull': 'Использовать весь атлас (анимация)',
  'pet.atlasAdoptFullTitle': 'Сохранить все ряды, чтобы питомец реагировал на наведение, направление перетаскивания и долгое бездействие.',
  'pet.atlasAdoptRowTitle': 'Вырезать только выделенный ряд в отдельную циклическую полоску.',
  'pet.atlasActiveHint': 'Анимированный атлас включён — питомец выбирает ряд по вашему взаимодействию (наведение, перетаскивание, бездействие).',
  'pet.atlasRow.idle': 'Покой',
  'pet.atlasRow.running-right': 'Бег вправо',
  'pet.atlasRow.running-left': 'Бег влево',
  'pet.atlasRow.waving': 'Машет',
  'pet.atlasRow.jumping': 'Прыжок',
  'pet.atlasRow.failed': 'Неудача',
  'pet.atlasRow.waiting': 'Ожидание',
  'pet.atlasRow.running': 'Бежит',
  'pet.atlasRow.review': 'Анализ',
  'pet.hatchTitle': 'Вырастить нового пета с ИИ',
  'pet.hatchHint': 'Запустите встроенный навык hatch-pet в чате, чтобы получить спрайтшит в стиле Codex, а затем импортируйте его здесь.',
  'pet.hatchConcept': 'Концепт пета (по желанию)',
  'pet.hatchConceptPlaceholder': 'напр.: маленький пиксель-арт сиба-ину в уютном свитере',
  'pet.hatchCopy': 'Скопировать промпт',
  'pet.hatchCopied': 'Скопировано!',
  'pet.hatchFoot': 'Когда навык сохранит пета, вернитесь и нажмите «Импорт спрайта Codex».',
  'pet.slashPopoverAria': 'Слэш-команды',
  'pet.slashPopoverTitle': 'Команды',
  'pet.slashPopoverHint': '↑↓ навигация · enter выбрать · esc закрыть',
  'pet.slashPet': 'Переключить, выбрать или открыть настройки пета.',
  'pet.slashMcp': 'Open MCP server settings or insert a server tool hint.',
  'pet.slashPetWake': 'Разбудить плавающего пета.',
  'pet.slashPetTuck': 'Спрятать пета на время.',
  'pet.slashHatch': 'Создать Codex-пета через навык hatch-pet.',
  'pet.slashHatchArg': '<концепт>',
  'pet.slashSearch': 'Искать в вебе через команду OD research.',
  'pet.slashSearchArg': '<запрос>',
  'pet.codexTitle': 'Недавно вылупленные',
  'pet.codexSubtitle': 'Петы, упакованные навыком hatch-pet, появятся здесь для усыновления в один клик.',
  'pet.codexSubtitleWithDir': 'Сканируем {dir} в поисках пакетов hatch-pet.',
  'pet.codexEmpty': 'Пока нет вылупленных петов. Наберите /hatch в чате, чтобы создать.',
  'pet.codexLoading': 'Ищем вылупленных петов…',
  'pet.codexRefresh': 'Обновить',
  'pet.codexAdopt': 'Усыновить',
  'pet.codexAdopting': 'Усыновляем…',
  'pet.communitySync': 'Скачать сообщество питомцев',
  'pet.communitySyncing': 'Загрузка…',
  'pet.communitySyncTitle': 'Синхронизировать свежих питомцев из Codex Pet Share + j20 Hatchery в ~/.codex/pets/.',
  'pet.communitySyncDone': 'Синхронизировано {wrote} новых питомцев (всего {total}).',
  'pet.communitySyncFailed': 'Ошибка синхронизации: {error}',
  'pet.codexBundled': 'Встроен',
  'pet.codexBundledTitle': 'Поставляется с OpenDesign — загрузка не нужна.',
  'settings.systemPrefsTitle': 'Системные настройки',
  'settings.systemPrefsHint': 'Звук завершения, уведомления браузера и оповещения о статусе задач.',
  'settings.notifications': 'Уведомления',
  'settings.notificationsHint': 'Звук и уведомление при завершении задачи',
  'settings.notifyCompletionSound': 'Звук завершения',
  'settings.notifyCompletionSoundHint': 'Воспроизводится по завершении хода. По умолчанию выключено.',
  'settings.notifySuccessSound': 'Звук успеха',
  'settings.notifyFailureSound': 'Звук ошибки',
  'settings.notifyDesktop': 'Уведомление на рабочем столе',
  'settings.notifyDesktopHint': 'Отправляется, когда окно не активно.',
  'settings.notifyDesktopBlocked': 'Уведомления заблокированы браузером. Разрешите их в настройках сайта.',
  'settings.notifyDesktopUnsupported': 'Уведомления на рабочем столе недоступны в этой среде.',
  'settings.notifyTest': 'Отправить тест',
  'settings.notifyTestSent': 'Тестовое уведомление отправлено. Если баннер не появился, проверьте настройки уведомлений браузера и системы.',
  'settings.notifyTestFailed': 'Вызов уведомления не удался. Проверьте настройки уведомлений браузера и системы.',
  'settings.notifySoundDing': 'Динь',
  'settings.notifySoundChime': 'Колокольчик',
  'settings.notifySoundTwoToneUp': 'Двухтон вверх',
  'settings.notifySoundPluck': 'Щипок',
  'settings.notifySoundBuzz': 'Жужжание',
  'settings.notifySoundTwoToneDown': 'Двухтон вниз',
  'settings.notifySoundThud': 'Глухой удар',
  'settings.skills': 'Навыки',
  'settings.skillsHint': 'Функциональные навыки, которые агент может вызывать во время задачи',
  'settings.skillsNew': 'Новый навык',
  'settings.skillsEmpty': 'Выберите навык слева или создайте новый.',
  'settings.skillsEdit': 'Изменить',
  'settings.skillsDelete': 'Удалить',
  'settings.skillsDeleteConfirm': 'Подтвердить удаление',
  'settings.skillsName': 'Имя',
  'settings.skillsTriggers': 'Триггеры (через запятую или с новой строки)',
  'settings.skillsDescription': 'Описание',
  'settings.skillsBody': 'Содержимое SKILL.md',
  'settings.skillsCreate': 'Создать',
  'settings.skillsSave': 'Сохранить',
  'settings.skillsSaving': 'Сохранение…',
  'settings.skillsOverrideCreate': 'Создать пользовательское переопределение',
  'settings.skillsOverrideSave': 'Сохранить как пользовательское переопределение',
  'settings.skillsBuiltInOverrideWarning': 'Редактирование этого встроенного навыка создаёт пользовательское переопределение. Встроенная запись будет скрыта из списка, пока вы не удалите переопределение. Продолжить?',
  'settings.skillsFiles': 'Файлы',
  'settings.skillsNoFiles': 'В папке этого навыка нет файлов.',
  'settings.skillsNameRequired': 'Имя навыка обязательно.',
  'settings.skillsBodyRequired': 'Содержимое навыка обязательно.',
  'settings.designSystems': 'Дизайн-системы',
  'settings.designSystemsHint': 'Просматривайте и переключайте доступные дизайн-системы',
  'settings.designSystemsInstalled': 'Установлено',
  'settings.designSystemsAdd': 'Добавить дизайн-систему',
  'settings.designSystemsHiddenCount': '{count} скрыто из домашней галереи',
  'settings.designSystemsShowAll': 'Показать все',
  'settings.designSystemsShowHidden': 'Показать скрытые',
  'settings.designSystemsSource': 'Источник',
  'settings.designSystemsSourceLocal': 'Локально',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Ссылка на реестр shadcn',
  'settings.designSystemsImportShadcn': 'Импортировать из shadcn',
  'settings.designSystemsStructure': 'Структура',
  'settings.designSystemsModeHybrid': 'Гибридно',
  'settings.designSystemsModeNormalized': 'Нормализовано',
  'settings.designSystemsModeVerbatim': 'Без изменений',
  'settings.designSystemsCraft': 'Мастерство',
  'settings.designSystemsCraftColor': 'Цвет',
  'settings.designSystemsCraftAccessibility': 'Доступность',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'Путь проекта',
  'settings.designSystemsImportGithub': 'Импортировать из GitHub',
  'settings.designSystemsImportProject': 'Импортировать из проекта',
  'settings.designSystemsImportedStatus': 'Импортировано: {title}',
  'settings.designSystemsViewImported': 'Открыть импортированную дизайн-систему',
  'settings.designSystemsCategory': 'Категория',
  'settings.designSystemsAllCategories': 'Все категории',
  'settings.designSystemsShowInHomeGallery': 'Показывать в домашней галерее',
  'settings.projectLocations': 'Расположения проектов',
  'settings.projectLocationsHint': 'Корни хранения рабочих пространств',
  'settings.projectLocationsDescription': 'Добавьте рабочие базы, которые могут содержать несколько папок проектов OpenDesign. Новые проекты сохраняются как папка внутри выбранной базы.',
  'settings.projectLocationsSaveError': 'Не удалось сохранить расположения проектов. Проверьте, что каждый путь является доступной папкой.',
  'settings.projectLocationsSaved': 'Расположения проектов сохранены.',
  'settings.projectLocationsScanError': 'Не удалось просканировать расположения проектов.',
  'settings.projectLocationsScanComplete': 'Сканирование завершено: импортировано {imported}, уже зарегистрировано {existing}.',
  'settings.projectLocationsNoFolderSelected': 'Папка не выбрана.',
  'settings.projectLocationsDuplicate': 'Эта рабочая база уже добавлена.',
  'settings.projectLocationsWorkBaseMeta': 'Рабочая база · проекты создаются здесь как подпапки',
  'settings.projectLocationsAddFolder': 'Добавить папку…',
  'settings.projectLocationsDefaultBadge': 'Расположение по умолчанию',
  'settings.projectLocationsMakeDefault': 'Сделать по умолчанию',
  'settings.projectLocationsDefaultSaved': 'Расположение проекта по умолчанию обновлено.',
  'settings.librarySkills': 'Навыки',
  'settings.libraryDesignSystems': 'Системы дизайна',
  'settings.librarySearch': 'Поиск...',
  'settings.libraryAll': 'Все',
  'settings.libraryPreview': 'Предпросмотр',
  'settings.libraryPreviewClose': 'Закрыть',
  'settings.libraryLoading': 'Загрузка...',
  'settings.libraryNoResults': 'Ничего не найдено по вашему запросу.',
  'settings.libraryEnabled': 'Включено',
  'settings.libraryDisabled': 'Отключено',
  'settings.connectorsNavHint': 'Подключения к внешним системам',
  'settings.connectorsHint': 'Управляйте настройками коннекторов и провайдеров инструментов для этого устройства.',
  'settings.connectorsComposioApiKey': 'API-ключ Composio',
  'settings.connectorsSavedTitle': 'Сохранено в локальном daemon',
  'settings.connectorsSavedWithTail': 'Сохранено · ••••{tail}',
  'settings.connectorsSaved': 'Сохранено',
  'settings.connectorsGetApiKey': 'Получить API-ключ',
  'settings.connectorsReplaceKeyPlaceholder': 'Вставьте новый ключ, чтобы заменить сохранённый',
  'settings.connectorsApiKeyPlaceholder': 'Вставьте API-ключ Composio',
  'settings.connectorsClear': 'Очистить',
  'settings.connectorsClearConfirmTitle': 'Очистить сохранённый ключ Composio API?',
  'settings.connectorsClearConfirmBody': 'Удаление ключа отключит все коннекторы Composio, привязанные к этому рабочему пространству. Подключённые аккаунты, разрешения OAuth и доступ к инструментам будут удалены.',
  'settings.connectorsClearConfirmContinue': 'Продолжить',
  'settings.connectorsClearFinalTitle': 'Это отключит все коннекторы',
  'settings.connectorsClearFinalBody': 'Отменить нельзя. После вставки нового ключа каждую интеграцию придётся подключать заново.',
  'settings.connectorsClearFinalConfirm': 'Удалить ключ и отключить',
  'settings.connectorsClearArming': 'Минуточку…',
  'settings.connectorsClearCancel': 'Отмена',
  'settings.connectorsSaveKey': 'Сохранить ключ',
  'settings.connectorsSaveKeyTitle': 'Отправить ключ локальному демону',
  'settings.connectorsKeySaving': 'Сохранение…',
  'settings.connectorsKeySaved': 'Сохранено ✓',
  'settings.connectorsKeyError': 'Не удалось сохранить ключ. Убедитесь, что локальный демон запущен, и попробуйте снова.',
  'settings.connectorsHelpSaved': 'Ваш ключ открывает каталог ниже и остаётся в локальном daemon. Вставьте новый ключ для замены или очистите, чтобы удалить.',
  'settings.connectorsHelpUnsaved': 'Несохранённые изменения — нажмите «Сохранить ключ», чтобы передать его локальному демону и открыть каталог ниже.',
  'settings.connectorsHelpEmpty': 'Добавьте ключ, чтобы открыть каталог ниже. Ключи хранятся локально в daemon и никогда не передаются через переменные окружения.',
  'settings.connectorsLoadingSavedKey': 'Проверка сохранённого ключа в локальном daemon…',
  'settings.autosaveSaving': 'Сохранение…',
  'settings.autosaveSaved': 'Все изменения сохранены',
  'settings.autosaveError': 'Не удалось сохранить изменения. Возможно, локальный демон не в сети.',
  'settings.libraryToggleLabel': 'Переключить',
  'settings.memory': 'Память',
  'settings.memoryHint': 'Личные факты, автоматически извлечённые из чатов',
  'settings.customInstructionsTitle': 'Глобальные правила',
  'settings.customInstructionsHint': 'Постоянные инструкции, которым OpenDesign должен следовать в каждом чате. Сохраняйте факты, предпочтения и контекст проекта в виде памяти.',
  'settings.customInstructionsPlaceholder': 'например, «Всегда используй TypeScript. Предпочитай функциональные компоненты. Делай ответы краткими.»',
  'settings.memoryDescription': 'Факты о ваших предпочтениях, автоматически извлечённые из чатов, сохранены как Markdown-файлы и подмешиваются в каждый новый чат.',
  'settings.memoryEnabled': 'Включено',
  'settings.memoryDisabled': 'Выключено',
  'settings.memoryEnableLabel': 'Включить вставку памяти',
  'settings.memoryDisabledBanner': 'Память сейчас выключена. Существующие факты сохраняются на диске, но не подмешиваются в новые чаты.',
  'settings.memoryNew': 'Новая запись',
  'settings.memoryEdit': 'Изменить',
  'settings.memoryDelete': 'Удалить',
  'settings.memoryPreview': 'Просмотр',
  'settings.memoryEmpty': 'Пока нет записей.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Я предпочитаю тёмную тему',
  'settings.memoryName': 'Название',
  'settings.memoryDesc': 'Однострочное описание',
  'settings.memoryBody': 'Содержимое (поддерживается Markdown)',
  'settings.memoryBodyHint': 'Сначала правило, затем строки Why и How to apply.',
  'settings.memoryStartersLabel': 'Нужна отправная точка? Нажмите, чтобы заполнить форму:',
  'settings.memoryStarterUserName': 'Моя роль',
  'settings.memoryStarterUserDesc': 'Я фронтенд-инженер, работаю над SaaS-инструментом для дизайна',
  'settings.memoryStarterUserBody': '- Роль: ведущий frontend-инженер\n- Стек: React, TypeScript, Vite\n- Область: инструменты для дизайна / совместной работы\n- Часовой пояс: GMT+8 (Asia/Shanghai)\n\nКогда применять: в любом чате — приводите примеры в контексте веб-фронтенда.',
  'settings.memoryStarterFeedbackName': 'Настройки интерфейса',
  'settings.memoryStarterFeedbackDesc': 'Тёмная тема, крупный основной текст, низкая плотность информации',
  'settings.memoryStarterFeedbackBody': '- Тема: тёмная по умолчанию\n- Основной текст: ≥ 18px\n- Плотность информации: предпочитайте свободное пространство, меньше элементов на экране\n\nПочему: меньше нагрузки на глаза во время долгих сессий.\nКогда применять: всякий раз, когда вы создаёте интерфейс, веб-страницы или слайды.',
  'settings.memoryStarterProjectName': 'Текущий проект',
  'settings.memoryStarterProjectDesc': 'OpenDesign v0.5 — редактор дизайна с управлением через чат',
  'settings.memoryStarterProjectBody': '- Цель: выпустить редактор с управлением через чат в этом квартале\n- Приоритеты: потоковый рендеринг, локальная мультимодальность, offline-first\n- Стек: Next.js 16, демон Express, SQLite\n\nКогда применять: в любом разговоре об этом проекте.',
  'settings.memorySaveHint': 'Не сохраняется автоматически — нажмите «Создать» / «Сохранить», чтобы применить.',
  'settings.memoryIndexSaveHint': 'Изменения индекса не сохраняются автоматически — нажмите «Сохранить индекс», чтобы применить.',
  'settings.memoryIndexUnsaved': 'Несохранённые изменения',
  'settings.memoryFlashCreated': '✓ MEMORY.md создан',
  'settings.memoryFlashSaved': '✓ MEMORY.md сохранён',
  'settings.memoryFlashDeleted': '✓ MEMORY.md удалён',
  'settings.memoryFlashIndexSaved': '✓ Индекс сохранён',
  'settings.memoryFlashPathCopied': '✓ Путь скопирован',
  'settings.memoryNameLabel': 'Заголовок',
  'settings.memoryTypeLabel': 'Тип',
  'settings.memoryDescLabel': 'Описание',
  'settings.memoryBodyLabel': 'Содержимое',
  'settings.memoryTypeUser': 'Пользователь',
  'settings.memoryTypeFeedback': 'Отзыв',
  'settings.memoryTypeProject': 'Проект',
  'settings.memoryTypeReference': 'Ссылка',
  'artifact.odCardTaskBriefChip': 'Память применена · открыть бриф',
  'artifact.odCardScorecardTitle': 'Самопроверка',
  'artifact.odCardScorecardStatusPass': 'Пройдено',
  'artifact.odCardScorecardStatusPartial': 'Частично',
  'artifact.odCardScorecardStatusFail': 'Требует доработки',
  'artifact.odCardRuleKicker': 'Предлагаемое правило',
  'artifact.odCardRuleNameLabel': 'Название',
  'artifact.odCardRuleDescriptionLabel': 'Описание',
  'artifact.odCardRuleAssertionLabel': 'Должно выполняться',
  'artifact.odCardRuleCheckLabel': 'Как проверить',
  'artifact.odCardRuleRationaleLabel': 'Почему',
  'artifact.odCardRuleKeep': 'Оставить',
  'artifact.odCardRuleEdit': 'Изменить',
  'artifact.odCardRuleDone': 'Готово',
  'artifact.odCardRuleDiscard': 'Отклонить',
  'artifact.odCardRuleSaving': 'Сохранение…',
  'artifact.odCardRuleSaved': 'Правило «{name}» сохранено',
  'artifact.odCardRuleError': 'Не удалось сохранить правило. Попробуйте снова.',
  'artifact.odCardBrandAssistDone': 'Browser assist подтвержден',
  'artifact.odCardBrandAssistKicker': 'Нужен browser assist: {reason}',
  'artifact.odCardBrandAssistBody': 'Откройте браузер и пройдите все ручные проверки. Затем нажмите «Ещё», выберите «Скачать страницу», дождитесь успешного сохранения снимка и используйте левую карточку «Следующий шаг», чтобы продолжить извлечение.',
  'artifact.odCardBrandAssistError': 'Не удалось запустить browser assist. Попробуйте еще раз.',
  'artifact.odCardBrandAssistWorking': 'Запускаем...',
  'artifact.odCardBrandAssistConfirm': 'Открыть browser assist',
  'settings.memoryTypeProfile': 'Профиль',
  'settings.memoryTypeRule': 'Правило',
  'settings.memoryTabMemories': 'Воспоминания',
  'settings.memoryTabMemoriesCaption': 'Просмотр и управление сохранённой памятью',
  'settings.memoryTabHow': 'Как это работает',
  'settings.memoryTabHowCaption': 'Два цикла и их элементы управления',
  'settings.memoryAddDisclosure': 'Добавить или импортировать воспоминания',
  'settings.memoryAddDisclosureHint': 'Профиль, ручной ввод или подключённые приложения',
  'settings.memoryProfileTab': 'Рабочий профиль',
  'settings.memoryProfileTabCaption': 'Кто вы и ваши настройки по умолчанию',
  'settings.memoryProfileTitle': 'Ваш рабочий профиль',
  'settings.memoryProfileHint':
    'Несколько фактов о вас и ваших настройках по умолчанию. Память подмешивает их перед каждой задачей, чтобы агент понимал, что вы имеете в виду, даже из короткого запроса.',
  'settings.memoryProfileName': 'Рабочий профиль',
  'settings.memoryProfileDescription':
    'Роль, компания, область, аудитория, вкус и настройки по умолчанию, которые ассистент должен использовать.',
  'settings.memoryProfileSave': 'Сохранить профиль',
  'settings.memoryProfileSaving': 'Сохранение…',
  'settings.memoryProfileSaved': 'Профиль сохранён',
  'settings.memoryProfileRole': 'Роль',
  'settings.memoryProfileRolePlaceholder': 'напр. основатель, дизайнер, PM',
  'settings.memoryProfileCompany': 'Компания / Команда',
  'settings.memoryProfileCompanyPlaceholder': 'напр. Acme, команда роста',
  'settings.memoryProfileDomain': 'Область',
  'settings.memoryProfileDomainPlaceholder': 'напр. B2B SaaS, финтех, devtools',
  'settings.memoryProfileAudience': 'Основная аудитория',
  'settings.memoryProfileAudiencePlaceholder': 'напр. руководители, инженеры, конечные пользователи',
  'settings.memoryProfileAesthetic': 'Эстетика / вкус',
  'settings.memoryProfileAestheticPlaceholder':
    'напр. чисто и по-редакторски, светлый фон, много воздуха',
  'settings.memoryProfileDeliverables': 'Результаты по умолчанию',
  'settings.memoryProfileDeliverablesPlaceholder': 'напр. лендинги, презентации, one-pager',
  'settings.memoryProfileLocale': 'Локаль / Язык',
  'settings.memoryProfileLocalePlaceholder': 'напр. English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Текущие цели',
  'settings.memoryProfileGoalsPlaceholder':
    'напр. выпустить новую страницу тарифов, повысить конверсию пробного потока',
  'settings.memoryHooksTitle': 'Хуки памяти',
  'settings.memoryHooksHint':
    'Выберите, какие части памяти запускаются автоматически. Главный переключатель выше отключает их все.',
  'settings.memoryHooksProfileLabel': 'Использовать мой профиль',
  'settings.memoryHooksProfileDesc': 'Подмешивать ваш рабочий профиль в каждую задачу.',
  'settings.memoryHooksRewriteLabel': 'Переписывать короткие запросы',
  'settings.memoryHooksRewriteDesc': 'PRE: расширить короткий запрос до полного брифа задачи.',
  'settings.memoryHooksVerifyLabel': 'Самопроверка результата',
  'settings.memoryHooksVerifyDesc': 'POST: сверить результат с вашими правилами и показать оценочную карту.',
  'settings.memoryHooksExtractionLabel': 'Учиться из чатов',
  'settings.memoryHooksExtractionDesc': 'Собирать полезные факты и предпочтения из реплик в чате.',
  'settings.memoryIndex': 'MEMORY.md (индекс)',
  'settings.memoryIndexSave': 'Сохранить индекс',
  'settings.memoryIndexReset': 'Сбросить',
  'settings.memoryToastChanged': 'Память обновлена',
  'settings.memoryToastClickHint': 'Открыть',
  'settings.memoryAll': 'Все',
  'settings.memoryExtractions': 'История извлечений',
  'settings.memoryExtractionsHint': 'Сначала выполняется Regex, LLM работает в фоне.',
  'settings.memoryExtractionsEmpty': 'Извлечений пока нет. Список заполнится при следующем ответе в чате.',
  'settings.memoryExtractionsRefresh': 'Обновить',
  'settings.memoryExtractionsRefreshing': 'Обновление…',
  'settings.memoryExtractionPhaseRunning': 'Выполнение…',
  'settings.memoryExtractionPhaseSuccess': 'Успешно',
  'settings.memoryExtractionPhaseSkipped': 'Пропущено',
  'settings.memoryExtractionPhaseFailed': 'Не удалось',
  'settings.memoryExtractionSkipNoProvider': 'API key для извлечения памяти через LLM не настроен.',
  'settings.memoryExtractionSkipUnsupportedProvider': 'A saved media provider is not supported for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'Память отключена.',
  'settings.memoryExtractionSkipEmpty': 'Пустое сообщение пользователя — извлекать нечего.',
  'settings.memoryExtractionSkipNoMatch': 'В этом ответе не совпал ни один regex-шаблон.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'окружение',
  'settings.memoryExtractionProviderMediaConfig': 'настройки медиа',
  'settings.memoryExtractionProviderOverride': 'настройки памяти',
  'settings.memoryExtractionProposed': 'предложено',
  'settings.memoryExtractionWritten': 'записано',
  'settings.memoryExtractionDuration': 'за',
  'settings.memoryExtractionDelete': 'Удалить',
  'settings.memoryExtractionsClear': 'Очистить',
  'settings.memoryExtractionsClearTitle': 'Очистить всю историю извлечений',
  'settings.memoryExtractionsClearConfirm': 'Очистить всю историю извлечений? Это действие нельзя отменить.',
  'settings.memoryNoProviderBannerTitle': 'Извлечение памяти через LLM не выполняется',
  'settings.memoryNoProviderBannerBody': 'API key для извлечения памяти не найден. Добавьте ключ OpenAI в разделе «Media providers» или задайте ANTHROPIC_API_KEY / OPENAI_API_KEY в окружении, чтобы включить извлечение на базе LLM. Эвристическое извлечение через regex по-прежнему активно.',
  'settings.memoryUnsupportedProviderBannerBody': 'A media provider key is saved, but Memory can only reuse text-capable providers: OpenAI, MiniMax, AIHubMix, and SenseAudio. Configure one of those under Media providers, set ANTHROPIC_API_KEY / OPENAI_API_KEY, or choose a Memory model in Advanced.',
  'settings.libraryInstall': 'Установить',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Локальный путь',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Установить',
  'settings.libraryUninstall': 'Удалить',
  'settings.libraryBuiltIn': 'Встроенный',
  'settings.libraryInstalled': 'Установлен',
  'notify.successTitle': 'Задача выполнена',
  'notify.failureTitle': 'Задача завершилась с ошибкой',
  'notify.successBody': 'Ход завершён.',
  'notify.failureBody': 'Задача завершилась с ошибкой.',
  'updater.available': 'Доступно обновление',
  'updater.activeRunsTitle': 'OpenDesign всё ещё работает',
  'updater.activeRunsBody': 'Ещё выполняется активных задач: {count}. Перезапуск прервёт их.',
  'updater.activeRunsUnknownBody': 'OpenDesign не удалось проверить наличие активных задач. Перезапуск может прервать текущую работу.',
  'updater.availableBody': 'OpenDesign {version} доступен. Он будет загружен перед открытием установщика.',
  'updater.checking': 'Проверка обновлений',
  'updater.download': 'Скачать обновление',
  'updater.downloading': 'Загрузка обновления',
  'updater.downloadingPercent': 'Загрузка обновления {percent}%',
  'updater.done': 'Готово',
  'updater.failed': 'Обновление не удалось',
  'updater.installerOpenBody': 'Установщик открыт. OpenDesign закрывается, чтобы вы могли завершить обновление.',
  'updater.installerOpened': 'Установщик открыт',
  'updater.later': 'Позже',
  "updater.allowSilentUpdates": "Разрешить автоустановку будущих обновлений в приложении",
  'updater.openFailedFallback': 'Не удалось открыть установщик.',
  'updater.installRestart': 'Установить и перезапустить',
  'updater.installingRestart': 'Устанавливаем и перезапускаем...',
  'updater.openInstaller': 'Установить обновление',
  'updater.opening': 'Открытие установщика...',
  'updater.dialogAvailableGeneric': 'Доступна новая версия.\nСкачайте её, чтобы установить обновление.',
  'updater.dialogAvailableVersion': 'Доступна версия v{version}.\nСкачайте её, чтобы установить обновление.',
  'updater.dialogCheckFailed': 'Не удалось проверить обновления.\nПовторите попытку чуть позже.',
  'updater.dialogReadyGeneric': 'Новая версия готова.\nБольше удобства, умнее дизайн.',
  'updater.dialogReadyVersion': 'Версия v{version} готова.\nБольше удобства, умнее дизайн.',
  'updater.dialogUnsupported': 'Обновление внутри приложения здесь недоступно.\nСкачайте последнюю версию со страницы релизов.',
  'updater.payloadReadyGeneric': 'Новое обновление OpenDesign готово. OpenDesign закроется и перезапустится автоматически.',
  'updater.payloadReadyVersion': 'OpenDesign {version} готов. OpenDesign закроется и перезапустится автоматически.',
  'updater.quitButton': 'Закрыть OpenDesign',
  'updater.quitFailedBody': 'Установщик открыт, но OpenDesign не удалось закрыть. Закройте OpenDesign перед заменой приложения.',
  'updater.quitFailedTitle': 'Не удалось закрыть',
  'updater.quitting': 'Закрытие...',
  'updater.ready': 'Обновление готово',
  'updater.readyGeneric': 'Новая версия готова. OpenDesign закроется и откроет установщик.',
  'updater.readyVersion': 'OpenDesign {version} готов. OpenDesign закроется и откроет установщик.',
  'updater.reinstallLearnMore': 'Подробнее',
  'updater.reinstallReadyGeneric': 'Это обновление требует полной переустановки. OpenDesign закроется и откроет установщик.',
  'updater.reinstallReadyVersion': 'OpenDesign {version} требует полной переустановки. OpenDesign закроется и откроет установщик.',
  'updater.restartAnyway': 'Всё равно перезапустить',
  'updater.upToDate': 'У вас уже установлена последняя версия.',
  'updater.viewVersionFeatures': 'Что нового в этой версии',
  'updater.manualDownload': 'Скачать вручную',
  'whatsNew.updatedTitle': 'OpenDesign {version} уже здесь',
  'whatsNew.cta': 'Посмотреть примечания к выпуску',
  'newsletter.label': 'Рассылка (необязательно)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Модель памяти',
  'settings.memoryModelInlineSameAsChat': 'Как в чате',
  'settings.memoryModelInlineSameAsChatWithModel': 'Как в чате ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Как в чате ({provider})',
  'settings.memoryModelInlineHintCli': 'Необязательно. Извлекатель памяти использует env-переменную или API-ключ media providers у этого провайдера; закрепленная здесь модель только переопределяет авто-выбор.',
  'settings.memoryModelInlineHintCliConstrained': 'Необязательно. Память будет обращаться к {provider}; нужен env-var или API-ключ media providers для этого провайдера, либо выберите модель ниже, чтобы переопределить.',
  'settings.memoryModelInlineHintByok': 'Необязательно. Переиспользует ваш API-ключ чата у того же провайдера; выбор другой, обычно более дешевой, модели меняет только тело запроса.',
  'settings.memoryModelInlineFlashSaved': 'Сохранено',
  'settings.memoryModelInlineFlashCleared': 'Очищено',
  'settings.orbit.eyebrow': 'Автоматизация',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Ежедневная сводка коннекторов',
  'settings.orbit.lede': 'Собирать активность коннекторов по расписанию и публиковать результат как обновляемый live artifact.',
  'settings.orbit.statusOnTitle': 'Ежедневные запуски по расписанию включены',
  'settings.orbit.statusOffTitle': 'Ежедневные запуски по расписанию выключены',
  'settings.orbit.statusActive': 'Активно',
  'settings.orbit.statusOff': 'Выкл.',
  'settings.orbit.runTitle': 'Запустить Orbit и открыть живой диалог',
  'settings.orbit.running': 'Выполняется…',
  'settings.orbit.runOpen': 'Запустить сейчас',
  'settings.orbit.dailySummaryTitle': 'Ежедневная сводка',
  'settings.orbit.dailySummarySub': 'Выполняется раз в день в назначенное локальное время.',
  'settings.orbit.on': 'Вкл.',
  'settings.orbit.off': 'Выкл.',
  'settings.orbit.runTimeTitle': 'Время запуска',
  'settings.orbit.runTimeSub': 'По умолчанию 08:00. Сохраните, чтобы применить расписание daemon.',
  'settings.orbit.runTimeAria': 'Время ежедневного запуска Orbit',
  'settings.orbit.nextRun': 'Следующий запуск',
  'settings.orbit.nextRunScheduledAfterSave': 'Будет запланировано после сохранения',
  'settings.orbit.schedule': 'Расписание',
  'settings.orbit.pausedManualOnly': 'Пауза — только ручные запуски',
  'settings.orbit.templateTitle': 'Шаблон prompt',
  'settings.orbit.templateMissing': 'Шаблон {id} не установлен.',
  'settings.orbit.templateMissingOption': '{id} (отсутствует)',
  'settings.orbit.templateMissingInstall': 'Установите skill Orbit, чтобы направлять prompt.',
  'settings.orbit.templateMissingPickAnother': 'Выберите другой шаблон в списке.',
  'settings.orbit.templateResetTitle': 'Сбросить на {id}',
  'settings.orbit.templateReset': 'Сбросить',
  'settings.orbit.templateHelp': 'Направляйте Orbit с помощью skill — пример prompt выбранного шаблона добавляется в каждый запуск Orbit, чтобы сводки следовали этой форме.',
  'settings.orbit.templateAria': 'Шаблон prompt Orbit',
  'settings.orbit.templatesLoading': 'Загрузка шаблонов…',
  'settings.orbit.templatesOptgroup': 'Шаблоны skills Orbit',
  'settings.orbit.lastRun': 'Последний запуск',
  'settings.orbit.triggerManual': 'Вручную',
  'settings.orbit.triggerScheduled': 'По расписанию',
  'settings.orbit.meterAria': '{succeeded} успешно, {skipped} пропущено, {failed} с ошибкой из {checked} проверено',
  'settings.orbit.countChecked': 'Проверено',
  'settings.orbit.countSucceeded': 'Успешно',
  'settings.orbit.countSkipped': 'Пропущено',
  'settings.orbit.countFailed': 'С ошибкой',
  'settings.orbit.runError': 'Не удалось запустить Orbit. Убедитесь, что локальный daemon запущен, а коннекторы настроены.',
  'settings.orbit.gateAriaLabel': 'Для работы Orbit нужны коннекторы',
  'settings.orbit.gateEyebrow': 'Требуется настройка',
  'settings.orbit.gateTitle': 'Подключите инструмент для работы Orbit',
  'settings.orbit.gateBody': 'Orbit обобщает активность ваших коннекторов. Вы ещё ничего не подключили — добавьте хотя бы одну интеграцию, чтобы Orbit мог о чём-то сообщить.',
  'settings.orbit.gateBodyNoKey': 'Orbit обобщает активность коннекторов, а коннекторы работают через Composio. Добавьте ключ API Composio в разделе «Коннекторы», чтобы открыть каталог и выбрать первую интеграцию.',
  'settings.orbit.gateAction': 'Открыть коннекторы',
  'settings.orbit.gateActionNoKey': 'Настроить Composio',
  'settings.orbit.gateLoading': 'Проверка коннекторов…',
  'settings.orbit.controlsLockedBadge': 'Заблокировано',
  'settings.orbit.controlsLockedHint': 'Подключите инструмент, чтобы разблокировать расписание и шаблон Orbit.',
  'settings.orbit.artifactKickerLive': 'живой артефакт',
  'settings.orbit.artifactKickerLegacy': 'Устаревшая сводка',
  'settings.orbit.artifactTitle': 'Ежедневная сводка активности Orbit',
  'settings.orbit.artifactMetaLive': 'Обновляемый HTML-артефакт, созданный из активности коннекторов.',
  'settings.orbit.artifactMetaLegacy': 'Создано до включения поддержки live artifact — запустите Orbit снова, чтобы опубликовать один.',
  'settings.orbit.copyMarkdownTitle': 'Скопировать сводку Markdown в буфер обмена',
  'settings.orbit.copied': 'Скопировано',
  'settings.orbit.copy': 'Копировать',
  'settings.orbit.openArtifact': 'Открыть артефакт',
  'settings.orbit.sourceMarkdown': 'Исходный Markdown',
  'settings.memoryModelInlineHintByokNeutral': 'Память использует отдельную от чата модель. По умолчанию — ваша модель чата.',
  'diagnostics.exportTitle': 'Экспорт диагностики',
  'diagnostics.exportButton': 'Экспорт диагностики',
  'diagnostics.exportHint': 'Упаковывает недавние журналы приложения и сведения о машине в zip для отправки команде.',
  'diagnostics.exporting': 'Экспортирование…',
  'diagnostics.exportSuccess': 'Диагностика сохранена: {path}',
  'diagnostics.exportFailed': 'Не удалось экспортировать диагностику: {message}',
  'automations.eyebrow': 'Запланированные сессии Agent',
  'automations.title': 'Автоматизации',
  'automations.lede': 'Планируйте повторяющиеся беседы для работы над проектами, дайджестов Orbit и живых артефактов.',
  'automations.summaryAria': 'Сводка по автоматизациям',
  'automations.metricActive': 'Активные',
  'automations.metricPaused': 'Приостановленные',
  'automations.metricTemplates': 'Шаблоны',
  'automations.newAutomation': 'Новая автоматизация',
  'automations.yourAutomations': 'Ваши автоматизации',
  'automations.loading': 'Загрузка',
  'automations.emptyTitle': 'Автоматизаций пока нет',
  'automations.emptyBody': 'Создайте автоматизацию из шаблона или начните с пустого расписания.',
  'automations.targetNewEachRun': 'Новый проект при каждом запуске',
  'automations.targetCreateEachRun': 'Новый проект при каждом запуске',
  'automations.lastRun': 'Последний запуск {time}',
  'automations.openResult': 'Открыть результат',
  'automations.run': 'Запустить',
  'automations.runNowTitle': 'Запустить сейчас и открыть беседу',
  'automations.history': 'История',
  'automations.hideHistory': 'Скрыть историю',
  'automations.edit': 'Изменить',
  'automations.pause': 'Приостановить',
  'automations.resume': 'Возобновить',
  'automations.deleteAria': 'Удалить автоматизацию',
  'automations.deleteTitle': 'Удалить эту автоматизацию',
  'automations.deleteConfirm': 'Удалить эту автоматизацию? Прошлые запуски и их проекты сохранятся.',
  'automations.proposalsTitle': 'Предложения по развитию',
  'automations.proposalsSub': 'Просмотрите результаты автоматизации, прежде чем они изменят память, навыки или дизайн-системы.',
  'automations.proposalsPending': '{n} в ожидании',
  'automations.apply': 'Применить',
  'automations.reject': 'Отклонить',
  'automations.proposalsDismissReason': 'Отклонено в Автоматизациях',
  'automations.templatesTitle': 'Шаблоны',
  'automations.templatesSub': 'Orbit и живые артефакты — это шаблоны в рамках того же процесса автоматизации.',
  'automations.templatesCount': '{filtered} из {total}',
  'automations.templateFiltersAria': 'Фильтры шаблонов',
  'automations.templatesEmptyTitle': 'В этой категории пока нет шаблонов.',
  'automations.templatesEmptyBody': 'Попробуйте другой фильтр или начните с пустой автоматизации.',
  'automations.useTemplate': 'Использовать шаблон',
  'automations.runHistoryLoading': 'Загрузка истории запусков...',
  'automations.runHistoryEmpty': 'Запусков пока нет.',
  'automations.runHistoryTitle': 'История запусков',
  'automations.runHistoryLatest': 'Последние 10',
  'automations.crystallize': 'Кристаллизовать',
  'automations.crystallizing': 'Кристаллизация',
  'automations.crystallizeTitle': 'Создать черновики предложений по навыкам и памяти из этого запуска',
  'automations.crystallizeFailed': 'Кристаллизация не удалась: {error}',
  'automations.crystallizePartialSuccess': 'Кристаллизация создала предложения, но Automations не смогли обновить список. Проверьте видимые предложения или попробуйте обновить.',
  'automations.crystallizeRefreshFailed': 'Кристаллизация завершена, но Automations не смогли обновить предложения. Обновите список перед повторным запуском.',
  'automations.crystallizeNoProposals': 'Кристаллизация завершена, но предложения не вернулись. Попробуйте обновить или проверьте детали запуска.',
  'automations.openConversation': 'Открыть беседу',
  'automations.runHistoryAria': 'История запусков автоматизации',
  'automations.proposalsAria': 'Предложения по развитию автоматизации',
  'automations.templatesAria': 'Шаблоны автоматизаций',
  'automations.runInProgress': 'Выполняется',
  'automations.promptPlaceholder': 'Собрать вчерашнюю активность в GitHub и Linear и обобщить изменения.',
  'automations.scheduleStatusPaused': 'Приостановлено',
  'automations.nextRunManualOnly': 'Только вручную',
  'automations.nextRunScheduled': 'По расписанию',
  'automations.nextRunAt': 'Следующий {time}',
  'automations.statusSucceeded': 'Успешно',
  'automations.statusFailed': 'Ошибка',
  'automations.statusRunning': 'Выполняется',
  'automations.statusQueued': 'В очереди',
  'automations.statusCanceled': 'Отменено',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Живой артефакт',
  'automations.kindAutomation': 'Автоматизация',
  'automations.proposalTargetMemory': 'Память',
  'automations.proposalTargetDesignSystem': 'Дизайн-система',
  'automations.proposalTargetSkill': 'Навык',
  'automations.proposalTargetTemplate': 'Шаблон автоматизации',
  'automations.proposalActionCreate': 'Создать',
  'automations.proposalActionUpdate': 'Обновить',
  'automations.proposalActionMerge': 'Объединить',
  'automations.proposalActionMove': 'Переместить',
  'automations.proposalActionDelete': 'Удалить',
  'automations.proposalActionPromote': 'Повысить',
  'automations.filterAll': 'Все',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Живые артефакты',
  'automations.filterMemory': 'Память',
  'automations.filterDesignSystems': 'Дизайн-системы',
  'automations.filterSkills': 'Навыки',
  'automations.filterConnectors': 'Коннекторы',
  'automations.filterCompression': 'Сжатие',
  'automations.filterRelease': 'Релиз',
  'automations.filterQuality': 'Качество',
  'automations.tpl.memoryRefresh.title': 'Обновить память проекта на основе недавней работы.',
  'automations.tpl.memoryRefresh.desc': 'Превращает повторяющиеся решения, предпочтения и отзывы в многократно используемые обновления памяти.',
  'automations.tpl.designSystemRefresh.title': 'Обновить дизайн-системы на основе выпущенных артефактов.',
  'automations.tpl.designSystemRefresh.desc': 'Находит переиспользуемые токены, компоненты и правила в недавней дизайн-работе.',
  'automations.tpl.liveArtifactRegistry.title': 'Проверить живые артефакты и обновить устаревшие версии.',
  'automations.tpl.liveArtifactRegistry.desc': 'Поддерживает актуальность постоянных дашбордов, отчётов и превью вместо их дублирования.',
  'automations.tpl.orbitDashboard.title': 'Создать дашборд активности коннекторов.',
  'automations.tpl.orbitDashboard.desc': 'Объединяет выбранные коннекторы в живой дашборд в стиле Orbit.',
  'automations.tpl.releaseNotes.title': 'Составить заметки о релизе на основе выпущенной дизайн-работы.',
  'automations.tpl.releaseNotes.desc': 'Связывает объединённые PR, артефакты и видимые пользователю изменения в заметки о релизе.',
  'automations.tpl.qualityRegressionWatch.title': 'Отслеживать регрессии в дизайне и реализации.',
  'automations.tpl.qualityRegressionWatch.desc': 'Сравнивает недавние изменения с эталонами, трассировками и принятыми образцами.',
  'automations.tpl.orbitDaily.title': 'Ежедневный дайджест коннекторов.',
  'automations.tpl.orbitDaily.desc': 'Обновляет дайджест активности коннекторов по расписанию.',
  'automations.tpl.liveStatusBoard.title': 'Поддерживать актуальность живого артефакта статуса.',
  'automations.tpl.liveStatusBoard.desc': 'Обновляет один постоянный артефакт вместо создания нового отчёта при каждом запуске.',
  'dsManager.areaAria': 'Раздел дизайн-систем',
  'dsManager.tabDesignSystem': 'Дизайн-система',
  'dsManager.tabTemplate': 'Шаблон',
  'dsManager.sourceAria': 'Источник дизайн-системы',
  'dsManager.templateSourceAria': 'Источник шаблона',
  'dsManager.yourSystems': 'Ваши системы',
  'dsManager.officialPresets': 'Официальные пресеты',
  'dsManager.shareToTeam': 'Share to team',
  'dsManager.shareToTeamFailed': 'Couldn\'t share to team',
  'dsManager.syncToTeam': 'Синхронизировать с командой',
  'dsManager.syncToTeamFailed': 'Не удалось синхронизировать с командой',
  'dsManager.unshareFromTeam': 'Remove from team',
  'dsManager.unshareFromTeamFailed': 'Couldn\'t remove from team',
  'dsManager.teamSyncedReadOnly': 'Only the sharer or a workspace admin can change this',
  'dsManager.enterprise': 'Корпоративные',
  'dsManager.yourTemplates': 'Ваши шаблоны',
  'dsManager.yourSystemsAria': 'Ваши дизайн-системы',
  'dsManager.eyebrowDesignSystems': 'Дизайн-системы',
  'dsManager.yourSystemsHeading': 'Ваши системы',
  'dsManager.filterAria': 'Фильтровать дизайн-системы',
  'dsManager.filterAll': 'Все',
  'dsManager.filterPublished': 'Опубликованные',
  'dsManager.filterDraft': 'Черновик',
  'dsManager.createTitle': 'Создать новую дизайн-систему',
  'dsManager.createBody': 'Обучите OpenDesign вашему бренду, продукту, коду, ресурсам и дизайн-референсам.',
  'dsManager.createAction': 'Создать',
  'dsManager.emptyMine': 'Дизайн-систем пока нет. Создайте систему из реального контекста продукта, проверьте черновик и опубликуйте её для будущих проектов.',
  'dsManager.badgeDefault': 'По умолчанию',
  'dsManager.rowMetaUpdated': 'Вы · обновлено {date}',
  'dsManager.edit': 'Изменить',
  'dsManager.openSystem': 'Открыть',
  'dsManager.editWithAgent': 'Редактировать с Agent',
  'dsManager.downloadTitle': 'Скачать дизайн-систему (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'Скачать {title} как .zip',
  'dsManager.downloadFailed': 'Не удалось скачать дизайн-систему. Повторите попытку.',
  'dsManager.deleteConfirm': 'Удалить «{title}»? Черновик дизайн-системы будет удален с этого устройства.',
  'dsManager.makeDefault': 'Сделать по умолчанию',
  'dsManager.statusPublished': 'Опубликовано',
  'dsManager.statusDraft': 'Черновик',
  'dsManager.openSystemAria': 'Открыть {title}',
  'dsManager.deleteSystemAria': 'Удалить {title}',
  'dsManager.deletePermissionDenied': 'У вас нет прав на удаление этой дизайн-системы.',
  'dsManager.presetsAria': 'Официальные пресеты дизайн-систем',
  'dsManager.eyebrowLibrary': 'Библиотека',
  'dsManager.eyebrowTemplates': 'Шаблоны',
  'dsManager.yourTemplatesAria': 'Ваши шаблоны',
  'dsManager.emptyTemplates': 'Шаблонов пока нет. Создайте шаблон из любого сгенерированного проекта через «Поделиться», когда публикация шаблонов будет включена.',
  'dsManager.templateDescFallback': 'Создано из проекта',
  'dsManager.comingSoonBadge': 'Скоро',
  'dsManager.enterpriseDsTitle': 'Корпоративные дизайн-системы',
  'dsManager.enterpriseDsBody': 'Общие командные дизайн-системы и управляемые библиотеки бренда появятся скоро.',
  'dsManager.enterpriseTplTitle': 'Корпоративные шаблоны',
  'dsManager.enterpriseTplBody': 'Утверждённые командой шаблоны и публикация в масштабах организации появятся скоро.',
  'settings.instructionsTitle': 'Инструкции и правила',
  'settings.instructionsSubtitle': 'Фиксированное поведение, которому должен следовать ассистент',
  'settings.instructionsNavSub': 'Фиксированное поведение ассистента',
  'settings.customInstructionsDesc': 'Фиксированные инструкции, которым OpenDesign следует в каждом чате. Это не сохранённые воспоминания; используйте Память для фактов, предпочтений и контекста проекта.',
  'mcpClient.forwardedToLabel': 'Перенаправляется в:',
  'mcpClient.notForwardedToLabel': 'Не перенаправляется в:',
  'mcpClient.forwardedAcpNote': 'Адаптеры ACP, помеченные как stdio, получают из этого списка только серверы stdio MCP; записи HTTP и SSE отбрасываются при запуске.',
  'mcpClient.notForwardedNote': 'Для этих Agent настройте серверы MCP в собственном файле конфигурации агента (например, ~/.codex/config.toml, ~/.gemini/settings.json); указанные ниже серверы там молча не используются.',

  // Brands library + extraction
  'brand.libraryTitle': 'Бренд-кит',
  'brand.librarySubtitle': 'Научите OpenDesign вашим бренд-китам: извлеките один с сайта и применяйте в любом чате.',
  'brand.newBrand': 'Новый бренд-кит',
  'brand.searchPlaceholder': 'Поиск по бренд-китам…',
  'brand.empty': 'Бренд-китов пока нет. Извлеките один с сайта, чтобы начать.',
  'brand.colorsCount': 'Цветов: {count}',
  'brand.extracting': 'Извлекаем…',
  'brand.failed': 'Извлечение не удалось',
  'brand.needsInput': 'Нужны данные',
  'brand.needsInputHint': 'Извлечение приостановлено — откройте проект, чтобы завершить проверку или ответить на вопрос.',
  'brand.appliedToChat': 'Используется {name}',
  'brand.previewEmpty': 'Выберите бренд для предпросмотра',
  'brand.viewDetails': 'Подробнее',
  'newBrand.title': 'Новый бренд',
  'newBrand.subtitle': 'Вставьте сайт или выберите бренд ниже — мы извлечём его цвета, шрифты и логотип.',
  'newBrand.urlLabel': 'Сайт бренда',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Извлечь бренд',
  'newBrand.cancel': 'Отмена',
  'newBrand.close': 'Закрыть',
  'newBrand.stage1': 'Загружаем сайт и анализируем его дизайн',
  'newBrand.stage2': 'Собираем предпросмотр бренда',
  'newBrand.stage3': 'Выводим и регистрируем дизайн-систему',
  'newBrand.measured': 'Цветов: {colors} · шрифтов: {fonts} · логотипов: {logos}',
  'newBrand.done': 'Бренд готов',
  'brandDetail.identity': 'Айдентика',
  'brandDetail.designLanguage': 'Дизайн-язык',
  'brandDetail.colors': 'Цвета',
  'brandDetail.fonts': 'Шрифты',
  'brandDetail.tone': 'Тон',
  'brandDetail.aesthetic': 'Эстетика',
  'brandDetail.tagline': 'Слоган',
  'brandDetail.voice': 'Голос',
  'brandDetail.useInChat': 'Использовать в новом чате',
  'brandDetail.delete': 'Удалить бренд',
  'brandDetail.back': 'Бренд-кит',
  'brandDetail.refining': 'Уточняем этот бренд…',
  'brandDetail.notFound': 'Бренд не найден.',
  'brandDetail.logo': 'Логотип',
  'brandDetail.typography': 'Типографика',
  'brandDetail.palette': 'Палитра',
  'brandDetail.voiceTone': 'Голос и тон',
  'brandDetail.imageryLayout': 'Визуалы и компоновка',
  'brandDetail.images': 'Изображения',
  'brandDetail.designSystem': 'Дизайн-система',
  'brandDetail.brandAssets': 'Брендовые ассеты',
  'brandDetail.openProject': 'Открыть проект',
  'brandDetail.themeLight': 'Светлая',
  'brandDetail.themeDark': 'Темная',
  'brandDetail.subjects': 'Сюжеты',
  'brandDetail.treatment': 'Обработка',
  'brandDetail.useLabel': 'Использовать',
  'brandDetail.avoidLabel': 'Избегать',
  'brandDetail.layoutPosture': 'Характер компоновки',
  'brandDetail.deleteConfirm': 'Удалить «{name}»? Бренд и его дизайн-система будут удалены.',
  'brandDetail.viewMore': 'Показать все ({count})',
  'brandDetail.viewLess': 'Показать меньше',
  'settings.resetOnboarding': 'Сбросить onboarding',
  'settings.resetOnboardingDesc': 'Повторить первичную настройку, включая извлечение бренда.',
  'settings.resetOnboardingButton': 'Сбросить',
  'settings.clearUpdaterCacheTitle': 'Очистить кэш обновлений',
  'settings.clearUpdaterCacheHint': 'Удаляет загруженные обновления и устаревший кэш, затем сбрасывает состояние обновления. Используйте, если обновления кажутся зависшими.',
  'settings.clearUpdaterCacheButton': 'Очистить кэш',
  'settings.clearUpdaterCacheConfirmButton': 'Подтвердить очистку',
  'settings.clearUpdaterCacheSuccess': 'Кэш обновлений очищен.',
  'settings.clearUpdaterCacheFailed': 'Не удалось очистить кэш обновлений.',
  'onboarding.brandTitle': 'Извлеките бренд-кит',
  'onboarding.brandSubtitle': 'Вставьте сайт, и мы превратим сигналы бренда в переиспользуемый бренд-кит для будущих работ.',
  'onboarding.brandSkip': 'Пока пропустить',
  'onboarding.brandDone': 'Бренд-кит извлечен',
  'onboarding.buildTitle': 'Создайте один раз — стройте везде',
  'onboarding.buildBody': 'OpenDesign превращает ваш бренд в переиспользуемую дизайн-систему и сохраняет единый фирменный стиль во всём, что вы создаёте.',
  'onboarding.buildBenefitMemoryTitle': 'Единая память бренда',
  'onboarding.buildBenefitMemoryBody': 'Цвета, типографика, отступы, компоненты и голос становятся DESIGN.md, который агенты смогут переиспользовать.',
  'onboarding.buildBenefitAlignedTitle': 'Каждый результат остается согласованным',
  'onboarding.buildBenefitAlignedBody': 'Прототипы, слайды, PDF, дашборды и маркетинговые материалы используют одни и те же правила.',
  'onboarding.buildBenefitSourcesTitle': 'Начните с того, что уже есть',
  'onboarding.buildBenefitSourcesBody': 'Используйте GitHub-репозиторий, сайт, существующий DESIGN.md, скриншоты, шрифты или файлы Figma.',
  'onboarding.buildPreviewLabel': 'Бренд-система',
  'onboarding.buildStart': 'Создать дизайн-систему',
  'onboarding.buildHome': 'На главную',
  'dsCreate.referenceLabel': 'Скопировать из существующей дизайн-системы',
  'dsCreate.referenceLoading': 'Загружаем DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Не удалось загрузить эту дизайн-систему.',
  'dsCreate.heroShowGuideAria': 'Показать руководство по дизайн-системе',
  'dsCreate.heroHideGuideAria': 'Скрыть руководство по дизайн-системе',
  'dsCreate.heroShowGuideTitle': 'Показать руководство',
  'dsCreate.heroHideGuideTitle': 'Скрыть руководство',
  'dsCreate.heroGuide': 'Руководство',
  'dsCreate.missingSourceError': 'Добавьте сайт, DESIGN.md, описание, файл, источник Figma или заметки, чтобы создать дизайн-систему.',
  'dsCreate.continueToGeneration': 'Перейти к генерации',
  'dsCreate.embeddedTitle': 'Создать из ваших материалов',
  'dsCreate.embeddedBody': 'Начните с сайта или бренд-референса, затем добавьте любые исходные файлы, которые у вас уже есть.',
  'dsCreate.sourceSectionTitle': 'Извлечь из GitHub, сайтов или исходных материалов',
  'dsCreate.sourceSectionBody': 'Начните с GitHub-репозитория, сайта, DESIGN.md или файлов, которые показывают ваш стиль. OpenDesign сначала быстро создает рабочую систему, а затем AI может уточнить ее внутри проекта.',
  'dsCreate.githubWebsiteLabel': 'GitHub или сайт',
  'dsCreate.add': 'Добавить',
  'dsCreate.startFromBrand': 'Начать с бренда',
  'dsCreate.brandPickerSubtitle': 'Ищите среди сотен брендов — выберите один, и мы добавим его сайт как стилевой референс.',
  'dsCreate.brandPickerQuickPicks': 'Популярные бренды — нажмите, чтобы добавить',
  'dsCreate.addedSourceLinks': 'Добавленные ссылки-источники',
  'dsCreate.openSourceLabel': 'Открыть {label}',
  'dsCreate.removeSourceLabel': 'Удалить {label}',
  'dsCreate.addFiles': 'Добавить файлы',
  'dsCreate.describeBrand': 'Описать бренд',
  'dsCreate.optional': 'необязательно',
  'dsCreate.describeBrandHelp': 'Голос бренда, вводная информация и контекст продукта. Используется в быстром проходе и AI-уточнении.',
  'dsCreate.companyPlaceholder': 'Например: Mission Impastabowl — fast-casual ресторан пасты с киоском, мобильным приложением и сайтом',
  'dsCreate.pasteDesignMd': 'Вставить DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Вставьте DESIGN.md, чтобы создать систему напрямую из токенов, обоснований и рекомендаций по компонентам.',
  'dsCreate.reference': 'Референс',
  'dsCreate.designMdViewMode': 'Режим просмотра DESIGN.md',
  'dsCreate.advancedToggle': 'Расширенные настройки — repo, локальный код, Figma',
  'dsCreate.githubRepo': 'GitHub-репозиторий',
  'dsCreate.localCodeLabel': 'Подключить локальный код',
  'dsCreate.localCodeHelper': 'Используйте папку или выбранные файлы с этого компьютера.',
  'dsCreate.localCodePrompt': 'Перетащите папку сюда или выберите вручную',
  'dsCreate.uploadFigLabel': 'Загрузить .fig',
  'dsCreate.uploadFigHelper': 'Разбирается на вашем компьютере в реальные токены, компоненты и ассеты — аккаунт Figma не нужен.',
  'dsCreate.uploadFigPrompt': 'Перетащите .fig сюда или выберите вручную',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Добавленные URL Figma',
  'dsCreate.savedFigmaHelp': 'Сохранено как источник дизайна Figma. Агент использует его как канонический референс; для полного офлайн-разбора экспортируйте .fig выше.',
  'dsCreate.notes': 'Заметки',
  'dsCreate.notesPlaceholder': 'Например: мы используем теплую природную палитру и скругленные углы. Голос бренда игривый, но профессиональный...',
  'dsCreate.back': 'Назад',
  'dsCreate.generate': 'Создать',
  'dsCreate.libraryPickerTitle': 'Выбрать из библиотеки',
  'dsCreate.libraryPickerConfirm': 'Добавить в ассеты',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'Предпросмотр DESIGN.md',
  'dsCreate.componentKit': 'набор компонентов',
  'dsCreate.defaultTheme': 'тема по умолчанию',
  'dsCreate.componentKitTitle': '{name} — набор компонентов',
  'dsCreate.designMdGeneratedDescription': 'Создано из вставленных токенов DESIGN.md, обоснований и рекомендаций по компонентам.',
  'dsCreate.previewButtons': 'Кнопки',
  'dsCreate.previewButtonsHelp': 'Пять типов в трех размерах.',
  'dsCreate.buttonPrimary': 'Основная',
  'dsCreate.buttonDashed': 'Пунктирная',
  'dsCreate.buttonText': 'Текстовая',
  'dsCreate.buttonLink': 'Ссылка',
  'dsCreate.sizeSmall': 'Малый',
  'dsCreate.sizeMedium': 'Средний',
  'dsCreate.sizeLarge': 'Крупный',
  'dsCreate.previewTypeScale': 'Типографическая шкала',
  'dsCreate.extractedTokens': 'Извлеченные токены DESIGN.md',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Finance',
  'brandPicker.categoryFashion': 'Fashion',
  'brandPicker.categoryActivewear': 'Activewear',
  'brandPicker.categoryBeauty': 'Beauty',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Food',
  'brandPicker.categoryBeverage': 'Beverage',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Education',
  'brandPicker.categoryElectronics': 'Electronics',
  'brandPicker.categoryAutomotive': 'Automotive',
  'brandPicker.categoryHealthcare': 'Healthcare',
  'brandPicker.categoryTravel': 'Travel',
  'brandPicker.heading': 'Начните с бренда, который вам нравится',
  'brandPicker.subtext': 'Нажмите на любой бренд, чтобы извлечь его кит прямо с сайта.',
  'brandPicker.quickPicksLabel': 'Популярные бренды — нажмите, чтобы извлечь',
  'brandPicker.searchPlaceholder': 'Поиск брендов…',
  'brandPicker.allCategories': 'Все',
  'brandPicker.extractAction': 'Извлечь',
  'brandPicker.showMore': 'Показать ещё',
  'brandPicker.opening': 'Запуск извлечения — открываем {brand}…',
  'ds.kitVisualize': 'Просмотр',
  'ds.kitEdit': 'Редактировать',
  'ds.kitSource': 'Исходник',
  'ds.saveDesignMd': 'Сохранить DESIGN.md',
  'ds.saving': 'Сохранение…',
  'ds.copyDesignMd': 'Копировать DESIGN.md',
  'ds.editDesignMd': 'Редактировать DESIGN.md',
  'ds.openDesignMd': 'Открыть DESIGN.md',
  'ds.copyDesignMdModule': 'Копировать раздел {module}',
  'ds.editDesignMdModule': 'Редактировать раздел {module}',
  'ds.openDesignMdModule': 'Открыть раздел {module}',
  'ds.uploadMd': 'Загрузить MD',
  'ds.uploadFont': 'Добавить файл шрифта',
  'ds.pasteImage': 'Вставить изображение',
  'ds.refresh': 'Обновить',
  'ds.download': 'Скачать',
  'ds.importFolder': 'Импортировать папку',
  'ds.reset': 'Сбросить',
  'ds.editingDesignMdHint': 'Редактирование этого Markdown обновляет отображаемые модули комплекта.',
  'ds.editingModuleHint': 'Редактируется только модуль {module}.',
  'ds.manualEditModuleHint': 'Редактируйте {module} здесь. Наведите курсор на этот раздел, чтобы показать элементы управления.',
  'ds.saveModule': 'Сохранить модуль',
  'ds.uploadLogo': 'Загрузить логотип',
  'ds.uploadImage': 'Загрузить изображение',
  'ds.uploading': 'Загрузка…',
  'ds.moduleEmptyLogo': 'Логотипа пока нет',
  'ds.moduleEmptyFonts': 'Шрифты не найдены.',
  'ds.actionDone': 'Готово',
  'ds.actionFailed': 'Что-то пошло не так. Повторите попытку.',
  'ds.uploadDone': 'Загружено',
  'ds.uploadFailed': 'Не удалось загрузить. Повторите попытку.',
  'ds.deleteLogo': 'Удалить логотип',
  'ds.deleteImage': 'Удалить {caption}',
  'ds.deleteProjectConfirm': 'Удалить «{title}»? Эта дизайн-система и ее проект будут навсегда удалены с этого устройства.',
  'ds.deleteProjectAction': 'Удалить {title}',
  'ds.editColor': 'Редактировать {name}',
  'ds.colorLabel': 'Цвет',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Значение Hex',
  'ds.saveColor': 'Сохранить цвет',
  'ds.invalidHexColor': 'Введите допустимый Hex-цвет, например #FF6A3D.',
  'ds.colorSaveFailed': 'Не удалось сохранить этот цвет.',
  'ds.colorResetFailed': 'Не удалось сбросить этот цвет.',
  'ds.designMdSectionLabel': 'Раздел {module} в DESIGN.md',
  'ds.kitErrorTitle': 'В этом представлении возникла проблема.',
  'ds.kitErrorRetry': 'Перезагрузить',
  'ds.shortcutsLabel': 'Горячие клавиши',
  'ds.shortcutsHint': 'Клавиши: E редактировать · C копировать · U загрузить · R обновить · ⌫ удалить логотип',
  'ds.moduleEmptyImages': 'Изображений пока нет',
  'ds.noOriginalColor': 'Для этого образца нет исходного цвета.',
  'ds.manifestReadFailed': 'Не удалось прочитать _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Свернуть {title}',
  'ds.reviewExpandSection': 'Развернуть {title}',
  'ds.reviewNeedsReview': 'Требует проверки',
  'ds.reviewLooksGood': 'Выглядит хорошо',
  'ds.reviewActionsLabel': 'Проверка {title}',
  'ds.reviewNeedsWorkEllipsis': 'Нужны правки...',
  'ds.reviewEditFile': 'Редактировать {file}',
  'ds.reviewFeedbackLabel': 'Сообщите агенту, что нужно изменить',
  'ds.reviewFeedbackPlaceholder': 'Например: подтянуть отступы в {title}, заново сгенерировать этот предпросмотр...',
  'ds.reviewChangedAfterFeedback': 'Этот раздел изменился после вашего комментария. Проверьте его снова перед публикацией.',
  'ds.reviewChangedDuringRun': 'Этот раздел изменился во время последнего запуска. Проверьте его перед публикацией.',
  'ds.reviewLastFeedback': 'Последний комментарий',
  'ds.previewGenerating': 'Генерируем предпросмотр...',
  'ds.creatingProjectTitle': 'Создаем вашу дизайн-систему...',
  'ds.creatingProjectSubtitle': 'Не закрывайте эту вкладку. Через несколько минут можно будет вернуться.',
  'ds.generationProgressLabel': 'Прогресс генерации дизайн-системы: {progress}%',
  'ds.publishRepoRequiredTitle': 'Завершите импорт GitHub-репозитория перед публикацией.',
  'ds.publishDesignSystem': 'Опубликовать дизайн-систему',
  'ds.unpublishDesignSystem': 'Снять дизайн-систему с публикации',
  'ds.published': 'Опубликовано',
  'ds.publish': 'Опубликовать',
  'ds.extractionRunningTitle': 'Извлекаем дизайн-систему',
  'ds.extractionCompleteTitle': 'Извлечение завершено',
  'ds.extractionRunningBody': 'OpenDesign обновляет эту систему на месте.',
  'ds.extractionCompleteBody': 'Все извлеченные модули показаны ниже; пустые разделы намеренно оставлены пустыми.',
  'ds.publishCardPublished': 'Новые проекты вашей команды смогут использовать эту дизайн-систему как контекст по умолчанию.',
  'ds.publishCardDraft': 'Дизайн-система готова, но ваши комментарии сделают ее лучше. Опубликуйте ее, когда она будет готова для будущих проектов.',
  'ds.useSystemTitle': 'Использовать эту систему',
  'ds.useSystemBody': 'Начните новый дизайн, который унаследует цвета, типографику и компоненты этой системы и автоматически останется в рамках бренда.',
  'ds.createNewDesign': 'Создать новый дизайн',
  'ds.openSourceContext': 'Открыть исходный контекст',
  'ds.manifestNeedsAttention': 'Манифест дизайна требует внимания',
  'ds.openManifest': 'Открыть манифест',
  'ds.workspacePreparing': 'Готовим рабочее пространство дизайн-системы.',
  'ds.workspaceLoadingLabel': 'Рабочее пространство дизайн-системы загружается',
  'ds.sectionQueued': 'В очереди',
  'ds.sectionReviewUpdatedFiles': 'Обновленные файлы требуют проверки',
  'ds.reviewNeedsWork': 'Нужны правки',
  'ds.sectionRequiredFileMissing': 'Отсутствует обязательный файл: {file}',
  'ds.sectionNoFilesYet': 'Файлов пока нет',
  'ds.generationSourceTitle': 'Исходный контекст',
  'ds.generationSourceDetail': 'Читаем связанный контекст и данные репозитория.',
  'ds.generationGuidanceTitle': 'Брендовые рекомендации',
  'ds.generationGuidanceDetail': 'Пишем рекомендации и голос в DESIGN.md.',
  'ds.generationTokensTitle': 'Дизайн-токены',
  'ds.generationTokensDetail': 'Извлекаем токены цвета, типографики и отступов.',
  'ds.generationPreviewsTitle': 'Карточки предпросмотра',
  'ds.generationPreviewsDetail': 'Рендерим карточки предпросмотра для проверки.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Создаем переиспользуемые компоненты и паттерны.',
  'ds.generationAssetsTitle': 'Брендовые ассеты',
  'ds.generationAssetsDetail': 'Собираем логотипы, шрифты, изображения и иконки.',
  'ds.phaseQueuedTypography': 'Типографика в очереди',
  'ds.phaseQueuedTokens': 'Токены в очереди',
  'ds.phaseQueuedSpacing': 'Отступы в очереди',
  'ds.phaseQueuedUiKit': 'UI kit в очереди',
  'ds.phaseQueuedAssets': 'Ассеты в очереди',
  'ds.phaseReadingTypography': 'Читаем типографику',
  'ds.phaseReadingTokens': 'Читаем токены',
  'ds.phaseReadingSpacing': 'Читаем отступы',
  'ds.phaseReadingUiKit': 'Читаем UI kit',
  'ds.phaseReadingAssets': 'Читаем ассеты',
  'ds.phaseWritingTypography': 'Пишем типографику',
  'ds.phaseWritingTokens': 'Пишем токены',
  'ds.phaseWritingSpacing': 'Пишем отступы',
  'ds.phaseBuildingUiKit': 'Собираем UI kit',
  'ds.phaseUpdatingAssets': 'Обновляем ассеты',
  'ds.phaseNeedsAttention': 'Требует внимания',
  'ds.phaseUpdated': 'Обновлено',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Прочитано: {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Members, billing, and team spaces',
  'settings.workspaceLede': 'Team-level settings for this workspace. These areas are managed by the team service — open one to continue.',
  'settings.workspaceBack': 'Back to workspace',
  'settings.workspaceMembers': 'Members & invites',
  'settings.workspaceMembersHint': 'Manage who can access this workspace and send invitations.',
  'settings.workspaceBilling': 'Subscription & seats',
  'settings.workspaceBillingHint': 'Plan, seats, and payment for this workspace.',
  'settings.workspaceAutoRecharge': 'Auto-recharge',
  'settings.workspaceAutoRechargeHint': 'Automatically top up credits when the balance runs low.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Shared projects and visibility for your team.',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': 'Back to home',
  'settings.pageNavGroupPersonal': 'Personal',
  'ds.sectionRunningReadingContext': 'Читаем контекст для {title}.',
  'ds.sectionRunningNow': 'Сейчас: {phase}.',
  'ds.reviewLastReviewed': 'Последняя проверка: {time}',
  'ds.agentFeedbackQueued': 'Комментарий агенту поставлен в очередь',
  'ds.agentFeedbackSent': 'Комментарий агенту отправлен',
  'ds.agentFeedbackSentAt': 'Комментарий агенту отправлен {time}',
  'ds.agentFeedbackFailedWithError': 'Не удалось отправить комментарий агенту: {error}',
  'ds.agentFeedbackFailed': 'Не удалось отправить комментарий агенту',
  'ds.agentFeedbackUnknown': 'Статус комментария агенту неизвестен',
  'ds.repoConnectBannerTitle': 'Подключите репозиторий, чтобы подтянуть части дизайн-системы',
  'ds.repoConnectCardTitle': 'Подключите репозиторий',
  'ds.repoConnectPendingBody': 'Проверяем подключение к GitHub...',
  'ds.repoConnectPendingButton': 'Проверяем GitHub...',
  'ds.repoConnectedTitle': 'GitHub подключен',
  'ds.repoConnectedBody': 'Импортируйте этот репозиторий повторно, чтобы подтянуть его файлы в дизайн-систему.',
  'ds.repoImportButton': 'Импортировать репозиторий',
  'ds.repoConnectBannerBody': 'Подключите GitHub, чтобы OpenDesign мог прочитать репозиторий и подтянуть цвета, типографику и компоненты в эту дизайн-систему.',
  'ds.repoConnectCardBody': 'Подтяните цвета, типографику и компоненты из репозитория в эту дизайн-систему.',
  'ds.repoConnectButton': 'Подключить GitHub',
  'newproj.startFromLabel': 'Начать с',
  'newproj.startBlank': 'Пустой',
  'newproj.startBlankHint': 'Начать с нуля',
  'workspace.pages': 'Страницы',
  'workspace.allProjectFiles': 'Все файлы проекта',
  'workspace.newBlankPage': 'Новая пустая страница',
  'workspace.noPagesYet': 'Пока нет страниц',
  'workspace.pageCreateFailed': 'Не удалось создать страницу.',
  'workspace.pageCreatorTitle': 'Создать страницу',
  'workspace.pageCreatorSearch': 'Поиск шаблонов',
  'workspace.pageCreatorCategoryAll': 'Все сценарии',
  'workspace.pageCreatorEmpty': 'Нет типов страниц по вашему запросу.',
  'workspace.pageCreatorPreview': 'Предпросмотр',
  'workspace.pageCreatorUse': 'Использовать',
  'fileViewer.presentInTabDeckHint': 'Заметки докладчика во всплывающем окне',
  'fileViewer.presentEscHint': 'Нажмите Esc, чтобы выйти',
  'fileViewer.presenterPause': 'Пауза',
  'fileViewer.presenterResume': 'Продолжить',
  'fileViewer.presenterPrevious': 'Назад',
  'fileViewer.presenterNext': 'Далее',
  'questions.uploadingFiles': 'Загрузка файлов…',
  'questions.uploadNeedsProject': 'Для загрузки файлов нужен активный проект.',
  'questions.uploadPartialFailed': 'Загружено файлов: {uploaded}, не удалось: {failed}.',
  'questions.uploadFailed': 'Не удалось загрузить файлы: {failed}.',
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': 'Providers',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Use provider default',
  'settings.mediaProviderDocsTitle': 'Documentation',
  'settings.mediaProviderDocsHint': 'View setup instructions for this provider.',
  'settings.mediaProviderSaveHint': 'Changes are not saved until you select Save.',
  'settings.mediaProviderNoKeyRequired': 'No key required',
  'settings.mediaProviderNoKeyHint': 'This provider uses a local login or bundled runtime.',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.pageBackground': 'Background',
  'manualEdit.pageBaseSize': 'Base size',
  'manualEdit.pageStylesHtmlOnly': 'Page styles are available only for full HTML documents.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Close share confirmation',
  'pluginsView.shareWhatStarts': 'What this starts',
  'pluginsView.shareSourcePlugin': 'Source plugin',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Copied to',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Starting…',
  'community.title': 'Community',
  'community.searchPlaceholder': 'Search',
  'community.searchAria': 'Search',
  'community.filtersAria': 'Template filters',
  'community.closePreview': 'Close preview',
  'community.typePrototype': 'Prototype',
  'community.typeLiveArtifact': 'Live Artifact',
  'community.typeSlides': 'Slides',
  'community.typeImage': 'Image',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Audio',
  'community.usePrompt': 'Использовать промпт',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Trusted',
  'marketplace.filterRestricted': 'Restricted',
  'marketplace.emptyBefore': 'No plugins installed yet. Try',
  'marketplace.emptyAfter': ', or register a marketplace below.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Configured catalogs',
  'marketplace.catalogsEmpty': 'None registered. Add one with',
  'marketplace.pluginCount': '{count} plugin(s)',
  'genui.continue': 'Continue',
  'genui.authorize': 'Authorize',
  'genui.skip': 'Skip',
  'genui.acceptAll': 'Accept all',
  'genui.rejectAll': 'Reject all',
  'genui.submit': 'Submit',
  'genui.submitPartial': 'Submit partial decision',
  'genui.patchNotesPlaceholder': 'Notes for the patch author (optional)',
  'inspect.close': 'Close inspect',
  'inspect.colors': 'Colors',
  'inspect.text': 'Text',
  'inspect.background': 'Background',
  'inspect.typography': 'Typography',
  'inspect.size': 'Size',
  'inspect.weight': 'Weight',
  'inspect.align': 'Align',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'library.title': 'Library',
  'library.headerHint': 'Clip any page, design system, screenshot, image, or Figma import JSON into your Library — local-first, one click, no login.',
  'library.getClipper': 'Get the OpenDesign Web Clipper',
  'library.searchPlaceholder': 'Search captions, tags, titles…',
  'library.filterByKind': 'Filter by kind',
  'library.filterBySource': 'Filter by source',
  'library.kindAll': 'All kinds',
  'library.kindImages': 'Images',
  'library.kindElements': 'Elements',
  'library.kindDesignSystems': 'Design systems',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Fonts',
  'library.kindColors': 'Colors',
  'library.kindText': 'Text',
  'library.kindLinks': 'Links',
  'library.sourceAll': 'All sources',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Generated',
  'library.viewMode': 'View mode',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Show assets as a grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Group assets by day, newest first',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Reload the list with the current filters',
  'library.sync': 'Sync',
  'library.syncing': 'Syncing…',
  'library.syncTooltip': 'Pull your design systems and agent-generated artifacts into the Library',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload images, fonts, or files into the Library',
  'library.selectedCount': '{count} selected',
  'library.selectAll': 'Select all',
  'library.clear': 'Clear',
  'library.chatToDesign': 'Chat to design',
  'library.chatToDesignTitle': 'Start a chat to turn {count} into a design',
  'library.working': 'Working…',
  'library.useInDesignSystem': 'Use in design system',
  'library.createDesignSystem': 'Create new design system',
  'library.createDesignSystemSub': 'Open the create flow with these {count} attached',
  'library.refineExisting': 'Refine existing',
  'library.noEditableDesignSystems': 'No editable design systems yet.',
  'library.addAssetsAndRefine': 'Add assets & open to refine',
  'library.deleteCount': 'Delete {count}',
  'library.loading': 'Loading…',
  'library.emptyTitle': 'No assets yet.',
  'library.emptyHintBefore': 'Clip from any page with the OpenDesign Web Clipper, run',
  'library.emptyHintAfter': ', or upload inside a project — everything lands here.',
  'library.dropToUpload': 'Drop to upload to your Library',
  'library.confirmDeleteTitleOne': 'Delete {count} asset?',
  'library.confirmDeleteTitleMany': 'Delete {count} assets?',
  'library.confirmDeleteBodyOne': 'This permanently removes it from your Library. This can’t be undone.',
  'library.confirmDeleteBodyMany': 'This permanently removes them from your Library. This can’t be undone.',
  'library.cancel': 'Cancel',
  'library.today': 'Today',
  'library.yesterday': 'Yesterday',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Select asset',
  'library.deselectAsset': 'Deselect asset',
  'library.openDesignSystem': 'Open design system',
  'library.openProject': 'Open project',
  'library.opening': 'Opening…',
  'library.editAsPage': 'Edit as page',
  'library.viewSource': 'Source',
  'library.remove': 'Remove',
  'mcp.aboutTemplate': 'About {name}',
  'mcp.approvedRefresh': 'I’ve approved — Refresh',
  'mcp.approveInBrowserHint': 'Approve in the browser tab that opened. We\'ll catch the callback automatically — or click Refresh below if you completed it already.',
  'mcp.argsPlaceholder': 'space-separated',
  'mcp.authModeNone': 'No managed OAuth',
  'mcp.authModeOAuth': 'Managed OAuth',
  'mcp.browserDidntOpen': 'Browser didn\'t open?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Charts and diagrams as proper image artifacts.',
  'mcp.categoryDesignSystems': 'Design systems',
  'mcp.categoryDesignSystemsHint': 'Figma read/write, design-token translation, brand inspiration.',
  'mcp.categoryImageEditing': 'Image editing',
  'mcp.categoryImageEditingHint': 'Local post-processing, OCR and CV-driven edits.',
  'mcp.categoryImageGeneration': 'Image generation',
  'mcp.categoryImageGenerationHint': 'Models that produce raster, vector or video assets.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Push generated artifacts to a public URL.',
  'mcp.categoryUiComponents': 'UI components',
  'mcp.categoryUiComponentsHint': 'Designer-grade components, blocks and landing-page material.',
  'mcp.categoryUtilities': 'Utilities',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub and similar generic tools.',
  'mcp.categoryWebCapture': 'Web capture',
  'mcp.categoryWebCaptureHint': 'Render a URL into an image so the agent can see what it built.',
  'mcp.checking': 'Checking…',
  'mcp.clickConnectHint': 'Click Connect to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.closePicker': 'Close picker',
  'mcp.collapse': 'Collapse',
  'mcp.collapseServerAria': 'Collapse this MCP server',
  'mcp.commandPlaceholder': 'e.g. npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command is required for stdio transport.',
  'mcp.completedAuthTitle': 'I\'ve completed authorization — check connection status now',
  'mcp.connect': 'Connect',
  'mcp.connected': 'Connected.',
  'mcp.connecting': 'Connecting…',
  'mcp.customServer': 'Custom server',
  'mcp.customServerDesc': 'Empty form. Pick stdio or SSE / HTTP and fill the fields yourself.',
  'mcp.disabled': 'Disabled',
  'mcp.disconnect': 'Disconnect',
  'mcp.disconnectFailed': 'Disconnect failed. Check daemon logs.',
  'mcp.disconnecting': 'Disconnecting…',
  'mcp.displayNamePlaceholder': 'Display name (optional)',
  'mcp.enabled': 'Enabled',
  'mcp.enableServerAria': 'Enable this MCP server',
  'mcp.expand': 'Expand',
  'mcp.expandServerAria': 'Expand this MCP server',
  'mcp.expandToEdit': 'Expand to edit',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Headers (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth mode',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID must start with a letter or digit and only contain letters, digits, dash, or underscore (max 64 chars).',
  'mcp.jsonHelperExampleHead': 'Example MCP JSON',
  'mcp.jsonHelperHttpNote': 'use url + headers instead of command / args',
  'mcp.jsonHelperToggle': 'Need help? Map your MCP server\'s JSON config using the example below.',
  'mcp.moveDown': 'Move down',
  'mcp.moveUp': 'Move up',
  'mcp.noManagedOAuth': 'No managed OAuth.',
  'mcp.noManagedOAuthSaveDirect': 'Save this server and OpenDesign will use it directly.',
  'mcp.noManagedOAuthUseAsConfigured': 'OpenDesign will use this server as configured. Add headers below if the server needs a token.',
  'mcp.nonExpiringToken': 'Non-expiring token.',
  'mcp.notConnected': 'Not connected.',
  'mcp.openAuthorizationPage': 'Open authorization page',
  'mcp.pickerFilterPlaceholder': 'Filter by name, transport, capability…',
  'mcp.pickerHint': 'Pre-fills the form. You can still edit any field after.',
  'mcp.pickerNoMatch': 'No templates match “{query}”. Try clearing the filter or use the custom server option below.',
  'mcp.pickTemplate': 'Pick a template',
  'mcp.reauthenticateTitle': 'Reauthenticate (replaces the existing token)',
  'mcp.recheckTokenTitle': 'Re-check token status against the daemon',
  'mcp.reconnect': 'Reconnect',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Remove this MCP server',
  'mcp.saveFirstThenClick': 'Save first, then click',
  'mcp.starting': 'Starting…',
  'mcp.toGrantOAuthAccess': 'to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.tokenExpires': 'Token expires {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Try:',
  'mcp.tryPromptTitle': 'Paste this prompt into the chat composer to try the server end-to-end',
  'mcp.unnamedServer': 'Unnamed MCP server',
  'mcp.urlMalformed': 'URL is malformed.',
  'mcp.urlProtocolInvalid': 'URL must use http:// or https://.',
  'mcp.urlRequired': 'URL is required for SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Waiting for authorization…',
  'memory.connectorReadFailed': 'Couldn\'t read {name}.',
  'memory.connectorNoReadableContent': 'No readable content from {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Memory model',
  'memory.extractionSourceConnector': 'Connected apps were read, but OpenDesign could not turn that context into memory.',
  'memory.extractionSourceChat': 'OpenDesign could not run memory extraction for this chat.',
  'memory.failureAuthExpiredTitle': '{provider} authentication expired',
  'memory.failureAuthActionCli': 'Sign in to the selected Local CLI or choose a different Memory model.',
  'memory.failureAuthActionKey': 'Update the Memory extraction model key or sign in again.',
  'memory.failureQuotaTitle': '{provider} quota or rate limit hit',
  'memory.failureQuotaAction': 'Try again later or switch the Memory extraction model.',
  'memory.failureRequestTitle': '{provider} request failed',
  'memory.failureRequestActionCli': 'Check the selected Local CLI and try again.',
  'memory.failureRequestActionProvider': 'Check the model provider connection and try again.',
  'memory.failureGenericTitle': 'Memory extraction failed',
  'memory.failureGenericActionCli': 'Try again after checking the selected Local CLI.',
  'memory.failureGenericActionSettings': 'Try again after checking the Memory extraction model settings.',
  'memory.noData': 'No data',
  'memory.attemptReadTitle': 'Read {name}',
  'memory.attemptFailedTitle': 'Could not read {name}',
  'memory.attemptSkippedTitle': 'Skipped {name}',
  'memory.skipChatDisabled': 'Chat conversation learning is off.',
  'memory.kindConnectedApps': 'Connected apps',
  'memory.timeAgo': '{time} ago',
  'memory.scanRunningTitle': 'Scanning connected apps',
  'memory.scanFailedTitle': 'Connected app scan failed',
  'memory.scanSkippedTitle': 'Connected app scan skipped',
  'memory.scanSavedOne': 'Saved {count} memory',
  'memory.scanSavedOther': 'Saved {count} memories',
  'memory.scanNoNewMemories': 'No new memories found',
  'memory.scanTitle': 'Connected app scan',
  'memory.scanMetaChecking': 'Checking selected apps',
  'memory.scanMetaNeedsAttention': 'Needs attention',
  'memory.scanMetaFromConnectedApps': 'From connected apps',
  'memory.scanMetaCheckedApps': 'Checked selected apps',
  'memory.scanBusyLabel': 'Scanning apps',
  'memory.scanSelectPrompt': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.connectorReadFailedRetry': 'Could not read connected apps. Try again from the Connectors tab.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} apps',
  'memory.foundSuggestionsOne': 'Found {count} suggested memory from {apps}. Review before saving.',
  'memory.foundSuggestionsOther': 'Found {count} suggested memories from {apps}. Review before saving.',
  'memory.noSuggestionsFound': 'No memory suggestions found. OpenDesign could not read useful content from the selected app yet.',
  'memory.checkedNoSuggestionsOne': 'Checked {count} selected app, but found no new memory suggestions.',
  'memory.checkedNoSuggestionsOther': 'Checked {count} selected apps, but found no new memory suggestions.',
  'memory.savedFromConnectedAppsOne': 'Saved {count} memory from connected apps.',
  'memory.savedFromConnectedAppsOther': 'Saved {count} memories from connected apps.',
  'memory.savedPartial': 'Saved {saved} of {total} selected memories. Please try the remaining items again.',
  'memory.tabManual': 'Add manually',
  'memory.tabManualCaption': 'Write a fact or preference',
  'memory.tabConnected': 'Import from apps',
  'memory.tabConnectedCaption': 'Scan connected tools',
  'memory.storagePathAria': 'Memory storage path — click to copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.flowSavedMemory': 'Saved memory',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.manualPanelHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.',
  'memory.connectedPanelHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. OpenDesign only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.readToolsCount': '{count} read tools',
  'memory.checkingConnectionStatus': 'Checking connection status…',
  'memory.finishAuthorization': 'Finish authorization in your browser, then return here',
  'memory.connectBeforeExtraction': 'Connect this app before extraction',
  'memory.useConnectorAria': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.reconnectConnectorAria': 'Reconnect {name}',
  'memory.connectConnectorAria': 'Connect {name}',
  'memory.connectStateChecking': 'Checking',
  'memory.connectStateWaiting': 'Waiting',
  'memory.connectStateConnecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.selectedOfConnectedOne': 'Selected {count} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {count} of {total} connected apps.',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{bytes} read',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'dsCreate.addingSourceMaterial': 'Adding source material...',
  'dsCreate.browseFolder': 'Browse folder',
  'dsCreate.confirmBody': 'You\'ll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.',
  'dsCreate.confirmTitle': 'OpenDesign will extract your design system.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} selections',
  'dsCreate.extractDesignSystem': 'Extract design system',
  'dsCreate.extractionAlreadyStarting': 'Extraction is already starting. Please wait for the current request to finish.',
  'dsCreate.figmaFileFallbackLabel': 'Figma file',
  'dsCreate.figmaUrlInvalid': 'Enter a Figma file URL (https://figma.com/file/… or /design/…).',
  'dsCreate.githubAccessAutoBody': 'GitHub repo links use the first working access method; other website links are saved as source references.',
  'dsCreate.githubAccessAutoTitle': 'GitHub access: Auto',
  'dsCreate.githubAccessMethodsAria': 'GitHub repository access methods',
  'dsCreate.githubAuthorizeFailed': 'Could not start GitHub authorization.',
  'dsCreate.githubBadgeAutomatic': 'Automatic',
  'dsCreate.githubBadgeChecking': 'Checking',
  'dsCreate.githubBadgeComingSoon': 'Coming soon',
  'dsCreate.githubBadgeConnected': 'Connected',
  'dsCreate.githubBadgeNeedsAttention': 'Needs attention',
  'dsCreate.githubBadgeNotConfigured': 'Not configured',
  'dsCreate.githubBadgeOptional': 'Optional',
  'dsCreate.githubBadgePending': 'Pending',
  'dsCreate.githubComposioCheckingDesc': 'Checking connector status in the background; URL intake is not blocked.',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub connector connected as {account}; it is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioConnectedDesc': 'Composio GitHub connector is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioDefaultDesc': 'Composio GitHub connector access for agent tools; repo URLs still work with local git or GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Reconnect the Composio GitHub connector, or continue with local git/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Add a Composio API key only if this project needs connector-backed GitHub tools.',
  'dsCreate.githubComposioPendingDesc': 'Finish the Composio authorization window; local GitHub intake remains available.',
  'dsCreate.githubConfigureComposio': 'Configure Composio',
  'dsCreate.githubConnecting': 'Connecting...',
  'dsCreate.githubConnectorCheckFailed': 'Could not check the GitHub connector.',
  'dsCreate.githubConnectorCheckTimeout': 'Could not finish checking GitHub connector. You can still add repository URLs or connect GitHub manually.',
  'dsCreate.githubConnectViaComposio': 'Connect via Composio',
  'dsCreate.githubDisconnect': 'Disconnect',
  'dsCreate.githubDisconnectFailed': 'Could not disconnect GitHub.',
  'dsCreate.githubDisconnecting': 'Disconnecting...',
  'dsCreate.githubHideAccessMethods': 'Hide access methods',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'OpenDesign account',
  'dsCreate.githubMethodOdAccountDesc': 'Native GitHub sign-in managed by OpenDesign; this build does not use an OD-managed GitHub token yet.',
  'dsCreate.githubMethodThisDevice': 'This device',
  'dsCreate.githubMethodThisDeviceDesc': 'Uses public git clone, local git credentials, or GitHub CLI auth available on this machine.',
  'dsCreate.githubOpenAuthorization': 'Open authorization',
  'dsCreate.githubShowAccessMethods': 'Show access methods',
  'dsCreate.libraryPartiallyAdded': 'Added {added} of {total} item(s) from the library.',
  'dsCreate.localCodeFilesSelected': '{count} local code files selected',
  'dsCreate.prepareProjectFailed': 'Could not prepare the design system project.',
  'dsCreate.removeFile': 'Remove {name}',
  'dsCreate.startingExtraction': 'Starting extraction...',
  'dsFlow.activityDetailFailed': 'The chat message has the run details. You can adjust the request and try again.',
  'dsFlow.activityDetailReady': 'Review the updated Design System and Design Files tabs.',
  'dsFlow.activityDetailRunning': 'Watching project files and preparing the review draft.',
  'dsFlow.activityFailedTitle': 'Workspace update needs attention',
  'dsFlow.activityProgressAria': 'Workspace update progress {progress}%',
  'dsFlow.activityReadyTitle': 'Workspace update ready',
  'dsFlow.activityRunningTitle': 'OpenDesign is updating this system',
  'dsFlow.addBrandFonts': 'Add brand font files',
  'dsFlow.agentMsgCapturedDirection': 'Captured direction: {summary}',
  'dsFlow.agentMsgCreating': 'I am creating the design system workspace, preview cards, and supporting files from the context you provided.',
  'dsFlow.agentMsgReady': 'Your design system draft is ready. Review the Design System tab, inspect generated files, publish it, or ask me for changes here.',
  'dsFlow.agentMsgRevision': 'I am applying your feedback to the design system. You can keep reviewing the current draft while the revision runs.',
  'dsFlow.agentMsgTokenRebuild': 'I am preparing a token contract rebuild for review. The active contract will stay unchanged until the revision is accepted.',
  'dsFlow.agentPushLayer': 'Agent push layer',
  'dsFlow.assetsLabel': 'Assets',
  'dsFlow.auditNeedsRepair': '{summary} Review the audit details before running a repair.',
  'dsFlow.brandFontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsFlow.brandFontsMissingTitle': 'Brand font files missing',
  'dsFlow.chatCreateRequest': 'Create design system',
  'dsFlow.chatSeedUpdateSystem': 'Update this design system: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: use AI extraction to refine this system. Longer run; updates land here.',
  'dsFlow.conversationCreateFailed': 'Could not create a design system conversation.',
  'dsFlow.evidenceFallbackTokens': 'Fallback tokens',
  'dsFlow.evidenceFonts': 'Fonts',
  'dsFlow.evidenceIndexes': 'Evidence indexes',
  'dsFlow.evidenceScannedFiles': 'Scanned files',
  'dsFlow.evidenceSnippets': 'Snippets',
  'dsFlow.evidenceSourceTokens': 'Source tokens',
  'dsFlow.fileDraftPreview': 'File draft preview',
  'dsFlow.filesTouched': 'Files touched',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'General revision',
  'dsFlow.generationCompleted': 'Generation completed',
  'dsFlow.generationProgressAria': 'Generation progress {progress}%',
  'dsFlow.generationStopped': 'Generation stopped',
  'dsFlow.generationStoppedWithError': 'Generation stopped: {error}',
  'dsFlow.jobCompleted': '{noun} completed',
  'dsFlow.jobDetailGeneration': 'Preparing the remaining files.',
  'dsFlow.jobDetailReady': 'Review workspace is ready.',
  'dsFlow.jobDetailRevision': 'Applying your feedback.',
  'dsFlow.jobDetailTokenRebuild': 'Preparing a reviewable token contract draft.',
  'dsFlow.jobNeedsAttention': '{noun} needs attention',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Token rebuild',
  'dsFlow.jobRebuildingTokens': 'OpenDesign is rebuilding tokens',
  'dsFlow.jobRevising': 'OpenDesign is revising',
  'dsFlow.jobStillWorking': 'OpenDesign is still working',
  'dsFlow.loadingDesignSystem': 'Loading design system...',
  'dsFlow.metaEvidenceNotes': 'Evidence notes',
  'dsFlow.metaScannedInventory': 'Scanned file inventory',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Token extraction evidence',
  'dsFlow.metaTokenReport': 'Token contract quality report',
  'dsFlow.movedBackToDraft': 'Moved back to draft',
  'dsFlow.needsWorkSeed': 'Needs work on {title}: ',
  'dsFlow.no': 'No',
  'dsFlow.openingDesignSystemWorkspace': 'Opening the design system workspace...',
  'dsFlow.openingWorkspace': 'Opening the workspace...',
  'dsFlow.packageFallbackMeta': '{source} · DESIGN.md-only fallback',
  'dsFlow.packageLegacy': 'Legacy design system',
  'dsFlow.packageManifestMeta': '{source} · {mode} mode · manifest indexed',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid ready',
  'dsFlow.packageStructured': 'Structured import package',
  'dsFlow.pendingRevision': 'Pending revision',
  'dsFlow.pickLocalAgentFirst': 'Pick a local agent first, then ask OpenDesign to update this design system.',
  'dsFlow.previewPages': 'Preview pages',
  'dsFlow.proposedChanges': 'Proposed changes',
  'dsFlow.publishCardReady': 'OpenDesign is ready for review. Give feedback on the work so far, then publish when it is useful for future projects.',
  'dsFlow.publishCardRevision': 'OpenDesign is applying your feedback. You can keep reviewing while the updated draft is prepared.',
  'dsFlow.publishCardTokenRebuild': 'OpenDesign is preparing a token contract rebuild for review. The active contract stays unchanged until you accept it.',
  'dsFlow.publishCardWorking': 'OpenDesign is still working, but you can start giving feedback on the work so far.',
  'dsFlow.pullLayer': 'Pull layer',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision accepted',
  'dsFlow.revisionAcceptFailed': 'Could not accept revision',
  'dsFlow.revisionHistory': 'Revision history',
  'dsFlow.revisionMsgAccepted': 'Accepted. The design system draft now includes this update.',
  'dsFlow.revisionMsgPending': 'I prepared a proposed update. Review the diff card on the right, then accept it or ask for another change.',
  'dsFlow.revisionMsgRejected': 'Rejected. I left the current design system unchanged.',
  'dsFlow.revisionProgressUnavailable': 'Could not read revision progress',
  'dsFlow.revisionReady': 'Revision ready for review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision rejected',
  'dsFlow.revisionRejectFailed': 'Could not reject revision',
  'dsFlow.revisionStopped': 'Revision stopped',
  'dsFlow.revisionStoppedWithError': 'Revision stopped: {error}',
  'dsFlow.saveChangesFailed': 'Could not save changes',
  'dsFlow.savedDesignMd': 'Saved DESIGN.md',
  'dsFlow.sectionDraftBody': 'Draft body',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} marked as looks good',
  'dsFlow.sectionNoContent': 'No content yet.',
  'dsFlow.sectionNoDetails': 'No details yet.',
  'dsFlow.setDefaultAction': 'Default for new chats',
  'dsFlow.setDefaultTitle': 'Preselect this design system for new chats and new projects.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'GitHub import',
  'dsFlow.sourceTypeInstalled': 'Installed',
  'dsFlow.sourceTypeLocal': 'Local import',
  'dsFlow.sourceTypeUser': 'User workspace',
  'dsFlow.statusUpdateFailed': 'Could not update status',
  'dsFlow.stepReadCurrentSystem': 'Read current system',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Update design files',
  'dsFlow.subtitleBrand': 'Logo, voice and usage rules',
  'dsFlow.subtitleColor': 'Palette and semantic roles',
  'dsFlow.subtitleComponents': 'Reusable interface patterns',
  'dsFlow.subtitleDefault': 'Design guidance',
  'dsFlow.subtitleSpacing': 'Spacing scale and radius tokens',
  'dsFlow.subtitleTypography': 'Text hierarchy and styles',
  'dsFlow.tabDesignFiles': 'Design Files',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'rebuild recommended',
  'dsFlow.tokenContractReportAvailable': 'quality report available',
  'dsFlow.tokenContractScore': 'score {score}',
  'dsFlow.tokenRebuildStarted': 'Token contract rebuild started',
  'dsFlow.tokenRebuildStartFailed': 'Could not start token contract rebuild',
  'dsFlow.workspaceOpenFailed': 'Could not open the design system workspace.',
  'dsFlow.workspaceUpdatedReview': 'Workspace updated. Review the files or ask for another change.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace updated and DESIGN.md synced for review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace updated. {summary}',
  'dsFlow.yes': 'Yes',
  'pluginDetail.backToList': 'Back to list',
  'pluginDetail.quickCommands': 'Quick commands',
  'pluginDetail.noQuickCommands': 'No quick commands available.',
  'pluginDetail.dataConnections': 'Data connections',
  'pluginDetail.noDataConnections': 'This suite does not require any external data connections.',
  'pluginDetail.knowledgeSkills': 'Knowledge skills',
  'pluginDetail.noKnowledgeSkills': 'This suite has no standalone knowledge skills yet.',
  'pluginDetail.officialBadge': 'OpenDesign official',
  'pluginDetail.loadFailed': 'Failed to load plugin: {error}',
  'pluginDetail.applyFailed': 'Apply failed. Make sure the daemon is reachable.',
  'pluginDetail.examples': 'Examples',
  'skillDetail.providedBy': 'provided by {author}',
  'skillDetail.markdownNotice': 'The following content is taken verbatim from this skill’s SKILL.md',
  'skillDetail.loadFailed': 'Couldn’t load this skill’s SKILL.md.',
  'skillDetail.previewAria': '{title} SKILL.md preview',
  'common.dismiss': 'Dismiss',
  'campaign.deepseekV4Flash.headline': 'На этот раз — интеллект высшего уровня. Без ограничений.',
  'campaign.deepseekV4Flash.description': 'Лендинги, сайты, презентации и изображения — столько, сколько нужно.',
  'campaign.deepseekV4Flash.benefit': 'Безлимитные DeepSeek V4 Pro и V4 Flash',
  'campaign.deepseekV4Flash.timing': '13–27 авг.: бесплатно в период кампании',
  'campaign.deepseekV4Flash.ruleSummary': 'С 13 по 27 авг. платные пользователи могут бесплатно использовать DeepSeek V4 Pro и V4 Flash в OpenDesign. Масштабные злоупотребления могут приостановить доступ.',
  'campaign.deepseekV4Flash.windowLabel': '13–27 авг.',
  'campaign.deepseekV4Flash.weekFreeSuffix': 'две недели бесплатно',
  'campaign.deepseekV4Flash.boundary': 'Безлимитная квота модели и бесплатные генерации в тарифе действуют только внутри OpenDesign — не через MCP, CLI, API или другие поверхности. Окончательное толкование за OpenDesign. Для некоторых моделей в часы пик возможна очередь.',
  'campaign.deepseekV4Flash.countdownLabel': 'Обратный отсчёт',
  'campaign.deepseekV4Flash.countdownEnded': 'Кампания завершена',
  'campaign.deepseekV4Flash.countdownRemaining': '{days}д {hms}',
  'campaign.deepseekV4Flash.closeAria': 'Закрыть',
  'campaign.deepseekV4Flash.unlocked': 'Разблокировано',
  'campaign.deepseekV4Flash.locked': 'Заблокировано',
  'campaign.deepseekV4Flash.later': 'Позже',
  'campaign.deepseekV4Flash.paid.eyebrow': 'Две недели бесплатно',
  'campaign.deepseekV4Flash.paid.status': 'Разблокировано · 13–27 авг.',
  'campaign.deepseekV4Flash.paid.cta': 'Использовать сейчас',
  'campaign.deepseekV4Flash.paid.modelBadge': 'Безлимит',
  'campaign.deepseekV4Flash.unpaid.eyebrow': 'Бесплатно для платных планов',
  'campaign.deepseekV4Flash.unpaid.status': 'Обновите тариф · до 27 авг.',
  'campaign.deepseekV4Flash.unpaid.cta': 'Обновить план и использовать',
  'campaign.deepseekV4Flash.unpaid.modelBadge': 'Нужен апгрейд',
  'campaign.deepseekV4Flash.unpaid.tooltip': 'Оформите платный тариф в период акции, чтобы пользоваться бесплатно; заканчивается 27 авг.',
  'campaign.deepseekV4Flash.restricted.modelBadge': 'Приостановлено',
  'campaign.deepseekV4Flash.restricted.tooltip': 'Обнаружено аномально высокое использование — доступ к кампании приостановлен. Обратитесь в поддержку при необходимости.',
  'campaign.deepseekV4Flash.workbenchBadge': 'DeepSeek V4 Pro + V4 Flash безлимитно и бесплатно',
  'campaign.deepseekV4Flash.workbenchBadgeAria': 'DeepSeek V4 Pro и V4 Flash безлимитно и бесплатно — открыть тарифы',

  'experienceSurvey.tag': "Поделитесь отзывом — помогите улучшить OpenDesign",
  'experienceSurvey.close': "Закрыть",
  'experienceSurvey.recommendation': "Насколько вероятно, что вы порекомендуете OpenDesign коллеге или другу?",
  'experienceSurvey.recommendationLow': "Совсем невероятно",
  'experienceSurvey.recommendationHigh': "Очень вероятно",
  'experienceSurvey.improvement': "Что нам улучшить в первую очередь?",
  'experienceSurvey.improvement.wrongOutput': "Не то, что я просил",
  'experienceSurvey.improvement.falseDone': "Говорит «готово», но ничего не изменилось",
  'experienceSurvey.improvement.hardToUse': "Неудобно пользоваться",
  'experienceSurvey.improvement.upgradePrompts': "Слишком много предложений о подписке",
  'experienceSurvey.improvement.stuck': "Зависает или падает",
  'experienceSurvey.improvement.slow': "Слишком медленно",
  'experienceSurvey.improvement.looks': "Результат выглядит плохо",
  'experienceSurvey.improvement.regression': "Ломает другое",
  'experienceSurvey.improvement.other': "Другое",
  'experienceSurvey.otherPlaceholder': "Расскажите своими словами",
  'experienceSurvey.submit': "Отправить",
  'experienceSurvey.skip': "Пропустить",
  'experienceSurvey.thanksTitle': "Спасибо!",
  'experienceSurvey.thanksBody': "Ваш отзыв попадёт прямо к команде.",
};
